import { getAgentEngineId } from "../../utils/agentEngineId";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import OutboundCallerBrand from "../OutboundCallerBrand/OutboundCallerBrand";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./FastAgentDetails.module.css";
import axios from "axios";
import RealCalls from "./RealCalls/RealCalls";
import HeaderBar from "../HeaderBar/HeaderBar";
import TruncatedTooltip from "../GoLiveWizard/TruncatedTooltip";
import AgentCardDetail from "./AgentCardDetail/AgentCardDetail";
import FooterNew from "../FooterNew/FooterNew";
import PounceOverview, { pounceRangeBounds, PounceSkeleton } from "./PounceOverview/PounceOverview";
import pounceHeaderStyles from "../PounceAgentDetail/PounceAgentHeader/PounceAgentHeader.module.css";
import PounceToggle from "../PounceLeadsPage/PounceToggle/PounceToggle";
import pounceFooterStyles from "../PounceAgentDetail/PounceFooterNav/PounceFooterNav.module.css";
// PounceFooterNav wale hi icons — dono footer ek jaise dikhen.
import { HomeIcon, LeadsIcon, AppointmentsIcon, IntegrationsIcon, SettingsIcon } from "../PounceAgentDetail/PounceFooterNav/PounceFooterIcons";
import pounceSkeletonStyles from "../PounceAgentDetail/PounceAgentSkeleton/PounceAgentSkeleton.module.css";
import SparkleLine from "./SparkleLine/SparkleLine";
import SetupProgress from "../SetupProgress/SetupProgress";
import CalendarNudgeBanner from "../CalendarNudgeBanner/CalendarNudgeBanner";
import NeedHelpNew from "../NeedHelpNew/NeedHelpNew";
import CaughtBanner from "../CaughtBanner/CaughtBanner";
import UpgradeBanner from "../UpgradeBanner/UpgradeBanner";
import NewModal from "../NewModal/NewModal";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import detectPlatform from "../../utils/detectPlatform";
import { isPythonBackend, startPythonTestCall, hasRedeemedAppSumo } from "../../utils/apiBackend";
import { isMobileAppSurface } from "../../contexts/GlobalCallContext";
import { clearAgentPaid } from "../../lib/paymentGuard";

import {
    fetchAgentDetailById,
    fetchDashboardDetails,
    fetchTeamDashboard,
    getDashboardTourStatus,
    markDashboardTourSeen,
    isSyncContactSkip,
    deleteAgent,
    refundAndCancelSubscriptionAgnetApi,
    getReactivationStatus,
    reactivateSubscription,
    confirmReactivation,
    toggleAgentActivation,
    deleteKnowledgeBase,
    createKnowledgeBaseWithDetails,
    updateLlm,
    updateAgentKnowledgeBaseId,
    getBusinessDetailsByBusinessId,
    calenderCheck,
    getAgentSpamSettings,
    getAgentTransferNumbers,
    countAgentsbyUserId,
    getUserDetails,
} from "../../Store/apiStore";

import { fetchSetupScore, markSetupStep, computeSetupNextAction } from "../../lib/setupScore";
import { captureOAuth, returnToProvider, returnToHubspot } from "../../lib/integrationOAuth";
import { trackEvent } from "../../lib/analytics";
import { getVariant, EXPERIMENTS, VARIANT_B } from "../../lib/experiments";
import { loadAndHydrateOnboardingTracker } from "../../lib/onboardingHydrate";
import {
    getResumeRoute,
    clearOnboardingResume,
} from "../../utils/onboardingResume";
import confetti from "canvas-confetti";
import SophiaReadyDialog from "../GoLiveWizard/SophiaReadyDialog";
import dayjs from "dayjs";
import getKnowledgeBaseName from "../../utils/getKnowledgeBaseName";
import Loader from "../Loader/Loader";
import { useDashboardStore } from "../../Store/agentZustandStore";
import introJs from "intro.js";
import "intro.js/minified/introjs.min.css";
import { useAgentStore } from "../../Store/agentDetailStore";
import Loader2 from "../Loader2/Loader2";
import { RetellWebClient } from "retell-client-js-sdk";
import Modal3 from "../Modal3/Modal3";
import CallTest from "../CallTest/CallTest";
import PopUp from "../Popup/Popup";
import AgentAnalysis from "../AgentDetails/AgentAnalysisGraph/AgentAnalysis";
import { useClearStorage } from "../../hooks/useClearStorage";
import useAgentPermissions from "../../hooks/useAgentPermissions";
import LockOverlay from "../LockOverlay/LockOverlay";
import { useNotificationStore } from "../../Store/notificationStore";
import NotificationView from "../Notifications/NotificationView";
import { API_BASE_URL } from "../../Store/apiStore";
import { useCheckoutStore } from "../../Store/checkoutStore";
import isEmbeddedCheckoutEnabled from "../../lib/embeddedCheckoutFlag";
import decodeToken from "../../lib/decodeToken";
import UnlockNumberModal from "../UnlockNumModal/UnlockNumberModal";
import ContactSyncPopup from "../ContactSyncPopup/ContactSyncPopup";
import ConnectDrivePopup from "../ConnectDrivePopup/ConnectDrivePopup";
// Browser push permission ask — moved here from Dashboard since Dashboard
// is no longer routable. fast-agent-detail is the new entry page after login.
import PushPermissionModal from "../PushPermissionModal/PushPermissionModal";
import { registerPushToken } from "../../utils/initNotificationSocket";
// User context for the new profile-icon variant of the HeaderBar.
// We forward the user's profile picture URL so the avatar shown on
// /fast-agent-detail matches the one in the dashboard header.
import useUser from "../../Store/Context/UserContext";
import useProfileGreeting, { NUDGE_TEXT } from "../../hooks/useProfileGreeting";

// Pounce agent ka header, footer aur shimmer yahan PounceAgentDetail wali hi
// classes use karte hain. Wo CSS ab har component ke apne folder me hai;
// yahan teeno ko ek `pounceStyles` me jod diya taaki neeche ke
// `pounceStyles.x` waise hi chalte rahen. Class ke naam files ke beech
// takraate nahi (pehle sab ek hi file me the).
const pounceStyles = {
    ...pounceHeaderStyles,
    ...pounceFooterStyles,
    ...pounceSkeletonStyles,
};

/*
 * Calendar nudge — trigger is the 3rd DASHBOARD VISIT (senior's spec), not the
 * 3rd login.
 *
 * The old rule counted login SESSIONS in a cookie, which survived logout, so a
 * user who logged in three times over three days qualified without ever
 * returning to the dashboard. The spec is "show on the 3rd time the user comes
 * back to the dashboard".
 *
 * Both keys live in sessionStorage so the count RESETS on logout (per-session,
 * confirmed with the user). The cookie helpers that backed the old rule are
 * gone — nothing else used them.
 *
 * NOTE: React StrictMode double-invokes effects in dev, so the count can climb
 * 2 per visit locally. Production / staging builds count once.
 */
const CALENDAR_VISIT_COUNT_PREFIX = "rexpt_calendar_visit_count_";
const CALENDAR_REMINDER_DISMISSED_PREFIX = "rexpt_calendar_reminder_dismissed_";
const CALENDAR_REMINDER_MIN_VISITS = 3;

const getCalendarNudgeKeys = (userId) => {
    const safeUserId = encodeURIComponent(String(userId || "unknown"));
    return {
        visitKey: `${CALENDAR_VISIT_COUNT_PREFIX}${safeUserId}`,
        dismissedKey: `${CALENDAR_REMINDER_DISMISSED_PREFIX}${safeUserId}`,
    };
};

const getDrivePopupSessionKey = (userId, agentId) => {
    if (!userId || !agentId) return null;
    const safeUserId = encodeURIComponent(String(userId));
    const safeAgentId = encodeURIComponent(String(agentId));
    return `fastAgentDetail.drivePopupShown.${safeUserId}.${safeAgentId}`;
};

const POUNCE_RANGES = [
    { key: "today", label: "Today" },
    { key: "yesterday", label: "Yesterday" },
    { key: "7d", label: "Last 7 days" },
    { key: "30d", label: "Last 30 days" },
];

const pounceFormatShortDate = (d) => `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`;

// "25 to 1 Oct" — 7/30 din ki range. Mahina sirf aakhri (chalu) tareekh ka.
const pounceFormatDayRange = (from, to) =>
    `${from.getDate()} to ${to.getDate()} ${to.toLocaleString("en-US", { month: "short" })}`;


/*
 * "{agent} is Live!" setup-summary popup — SHOWN ONCE, EVER, per agent.
 *
 * A one-time onboarding celebration for finishing the setup sequence. The
 * existing sessionStorage trigger flag says "a wizard just finished"; this
 * marker says "this agent has already had its celebration", which is a
 * different, longer-lived fact and so lives in localStorage.
 */
const SETUP_SUMMARY_SEEN_PREFIX = "fastAgentDetail.setupSummarySeen.";

/*
 * A feature opened FROM the Setup Summary popup is entered in isolation: its
 * back / save / skip must all return here, never continue into the onboarding
 * add-on sequence. Router state carries this, and the sessionStorage mirror
 * survives screens that remount through an OAuth round-trip.
 */
const SUMMARY_RETURN_ROUTE = "/fast-agent-detail";
const SUMMARY_RETURN_FLAG = "setupSummary.returnTo";

const getSummaryAgentId = () => {
    try {
        return sessionStorage.getItem("SelectAgentId") || "";
    } catch (_e) {
        return "";
    }
};

const setupSummarySeenKey = (agentId) =>
    `${SETUP_SUMMARY_SEEN_PREFIX}${encodeURIComponent(String(agentId || "unknown"))}`;

const hasSeenSetupSummary = (agentId) => {
    try {
        return localStorage.getItem(setupSummarySeenKey(agentId)) === "1";
    } catch (_e) {
        // Storage unavailable (private mode) — fall back to SHOWING it. A
        // repeated celebration is a much smaller failure than permanently
        // swallowing the summary of a setup the user just completed.
        return false;
    }
};

const markSetupSummarySeen = (agentId) => {
    try {
        localStorage.setItem(setupSummarySeenKey(agentId), "1");
    } catch (_e) {
        /* best-effort — see hasSeenSetupSummary */
    }
};

const FastAgentDetails = () => {
    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const queryAgentId = searchParams.get("agentId");
    const queryBusinessId =
        searchParams.get("bussinesId") || searchParams.get("businessId");
    const [resolvedBusinessId, setResolvedBusinessId] = useState("");
    const token = localStorage.getItem("token") || "";

    // Synchronously set SelectAgentId in sessionStorage so first render captures the query agentId
    if (queryAgentId) {
        // SelectAgentRole describes whichever agent SelectAgentId named. When
        // the query switches to a DIFFERENT agent, that role is the previous
        // agent's — keeping it rendered a receptionist as the Pounce agent (seen
        // on the return from Google Calendar connect).
        if (sessionStorage.getItem("SelectAgentId") !== queryAgentId) {
            sessionStorage.removeItem("SelectAgentRole");
        }
        sessionStorage.setItem("SelectAgentId", queryAgentId);
    }

    // Capture OAuth params on mount; don't redirect here (would race the agent-count check).
    useEffect(() => {
        captureOAuth(window.location.search);
    }, [token]);

    // Close the pending OAuth loop only once an agent is confirmed to exist.
    //   • HubSpot secure install → returnToHubspot() sends the user back to
    //     HubSpot (closes the install popup + ticks "Complete").
    //   • Make/Zapier (we're the provider) → returnToProvider() echoes code+state.
    //   Only one is ever pending in a given session; try HubSpot first.
    const closeOAuthLoopIfAgentExists = useCallback(() => {
        if (returnToHubspot()) return;
        returnToProvider(token);
    }, [token]);


    // Decode token
    const decodeTokenData = decodeToken(token);
    const customer_id = decodeTokenData?.customerId;
    /*
     * Effective user ID resolution — team-member aware.
     *
     * When a team member logs in their JWT carries their OWN id, not
     * the owner's. All agent / appointments / dashboard fetches need
     * to run against the owner's account so the team member sees the
     * owner's data (mirroring Dashboard's `teamOwnerId || userIdFromToken`
     * pattern). Without this, countAgentsbyUserId returns 0 and the
     * page renders the "Draft Agent" empty state — exactly the bug
     * the user reported when adding a team member.
     *
     * Team-member specific things (tour seen / per-user cookies) end
     * up scoped to the owner too; that's actually desirable here
     * because we suppress the tour for team members anyway and the
     * cookies are best-effort UX nudges.
     */
    const userIdFromToken = decodeTokenData?.id;
    const teamOwnerIdLS =
        typeof window !== "undefined"
            ? localStorage.getItem("teamOwnerId")
            : null;
    // Multi-owner: prefer the owner of the agent the member just opened
    // (set by Dashboard.handleCardClick). Falls back to the legacy single
    // teamOwnerId, then the member's own id (owners).
    const selectedOwnerId =
        typeof window !== "undefined"
            ? sessionStorage.getItem("SelectAgentOwnerId")
            : null;
    const userId = selectedOwnerId || teamOwnerIdLS || userIdFromToken;

    const API_BASE = process.env.REACT_APP_API_BASE_URL;

    const [loading, setLoading] = useState(true);

    const [retellWebClient, setRetellWebClient] = useState(null);
    const [isCallActive, setIsCallActive] = useState(false);
    const [openCallModal, setOpenCallModal] = useState(false);
    const [callLoading, setCallLoading] = useState(false);
    const [isCallInProgress, setIsCallInProgress] = useState(false);
    const [callId, setCallId] = useState(null);
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("success");
    const isStartingRef = useRef(false);
    const isEndingRef = useRef(false);
    // Python agent (rexpt.in / port 3001) test-call handle. A Python agent has
    // no Retell web-call — it streams over a WebSocket (startPythonTestCall).
    // Retell agents leave this null and use retellWebClient as before.
    const pythonCallRef = useRef(null);
    const handleEndCallRef = useRef(null);
    // GA4: when the test call started, so we can report duration_sec on end.
    const callStartTimeRef = useRef(null);
    const [notificatioView, setNotificationsView] = useState(false);
    const [refresh, setRefresh] = useState(0)
    const [isTourOpen, setIsTourOpen] = useState(false);
    const [tourDone, setTourDone] = useState(false); // ✅ true after tour completes/skips
    const tourStartedRef = useRef(false);
    // intro.js instance ref — kept here so the route-change watcher
    // (lower down) can call tourIntroRef.current.exit() when the user
    // navigates away from /fast-agent-detail mid-tour. Without this we
    // couldn't reach the live intro instance from outside startTour().
    const tourIntroRef = useRef(null);
    const tourLaunchTimerRef = useRef(null);

    // ✅ Missing states added
    const [showUpgradeConfirmModal, setShowUpgradeConfirmModal] = useState(false);
    const [showUpgradeConfirmModalAssign, setShowUpgradeConfirmModalAssign] = useState(false);
    const [assignNumberPaid, setAssignNumberPaid] = useState(false);
    // Assign-Number CTA popup — opens on click instead of jumping straight
    // to /recommended-plan. From here the user picks View Plans (full
    // pricing screen) or Activate Trial ($20 / 21-day Starter trial).
    const [showAssignPopup, setShowAssignPopup] = useState(false);
    const [trialLoading, setTrialLoading] = useState(false);
    const [trialError, setTrialError] = useState("");
    // Sofia Setup Score snapshot — drives the purple progress card shown
    // for FREE-plan users until they reach 100%. Same fetch that already
    // powers the agent-cards section is reused; we just hold on to it.
    const [setupScore, setSetupScore] = useState(null);

    // ----- Dashboard actions migrated to FastAgentDetails -----
    // These let the user upgrade / delete / deactivate / toggle PAYG
    // for the currently selected agent without leaving the home page.
    const packageName = sessionStorage.getItem("package") || "Free";

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleteloading, setdeleteloading] = useState(false);

    const [showDeactivateConfirm, setShowDeactivateConfirm] = useState(false);
    const [deactivateLoading, setDeactivateLoading] = useState(false);
    // Feedback captured in the "pause" (deactivate) modal — UI only.
    const [deactivateReason, setDeactivateReason] = useState("");
    const [deactivateOtherText, setDeactivateOtherText] = useState("");

    const [showPaygConfirm, setshowPaygConfirm] = useState(false);
    const [isPaygActive, setisPaygActive] = useState(false);
    const [paygStatusLoading, setpaygStatusLoading] = useState(false);
    const [checkPaygStatus, setcheckPaygStatus] = useState();
    const [paygEnabledPopup, setpaygEnabledPopup] = useState(false);

    /*
     * Cancel Subscription state.
     *
     * Drives the confirm modal that replaced the PAYG action in the
     * More menu. Refund eligibility is computed at render time from
     * the agent's subscription (5-day age + <5% usage). The actual
     * cancel call goes through refundAndCancelSubscriptionAgnetApi
     * which the backend uses to decide refund-now vs schedule-at-
     * period-end; we just surface the right copy in the modal so
     * the user knows which outcome to expect.
     */
    const [showCancelSubConfirm, setShowCancelSubConfirm] = useState(false);
    const [cancelSubLoading, setCancelSubLoading] = useState(false);
    // Reactivate-last-plan: status from the backend (mode 'resume' | 'checkout').
    const [reactivation, setReactivation] = useState(null);
    const [showReactivateConfirm, setShowReactivateConfirm] = useState(false);
    const [reactivateLoading, setReactivateLoading] = useState(false);
    // Agent cancelled in this session; the DB status only updates when the webhook lands.
    const [justCancelledAgentId, setJustCancelledAgentId] = useState(null);
    // Scheduled cancel from this session ({ agentId, accessUntil }): locks the entry before the webhook updates the row.
    const [justScheduledCancel, setJustScheduledCancel] = useState(null);
    const [cancelReason, setCancelReason] = useState("");
    const [cancelOtherText, setCancelOtherText] = useState("");
    /*
     * Draft-agent resume state (0-agent users).
     *
     * Previously: if the user landed on /fast-agent-detail with no
     * agent context AND zero agents in DB, we redirected to /fork.
     * That bounce broke the "abandoned onboarding → log back in →
     * resume from where you left" UX that Dashboard's Draft Agent
     * card used to provide.
     *
     * Now: for 0-agent users we stay on /fast-agent-detail and
     * render an inline Draft Agent card (Continue + Discard buttons).
     * Continue routes via the same agent_creation_method1 lookup
     * Dashboard's handleCompleteSetup used; Discard mirrors
     * Dashboard's "clear sessionStorage + navigate to /steps".
     *
     * showDraftView flips to true when the count probe resolves to
     * zero; until then the normal loading state holds.
     */
    const [showDraftView, setShowDraftView] = useState(false);
    const [showDiscardDraftModal, setShowDiscardDraftModal] = useState(false);

    const [upgradeLoading, setUpgradeLoading] = useState(false);
    const { setHasFetched } = useDashboardStore();

    // Contact sync popup — shown once after agent creation for paid plans
    const [showContactSyncPopup, setShowContactSyncPopup] = useState(false);
    const [isSyncSkipContact, setIsSyncSkipContact] = useState(null); // null = not loaded yet
    const [calendarReminderReady, setCalendarReminderReady] = useState(false);
    const [calendarReminderEligible, setCalendarReminderEligible] = useState(false);
    const [showCalendarReminder, setShowCalendarReminder] = useState(false);
    const [pushPermissionOpen, setPushPermissionOpen] = useState(false);
    // Login prompts gate — currently only the "No calls yet" (NoCallsModal)
    // popup should appear on login. Flip this back to `true` to restore the
    // "Connect your calendar" + "Enable notifications" (push permission)
    // prompts alongside it.
    const SHOW_LOGIN_PROMPTS = false;

    /*
     * Connect-Drive popup state (Law Firm + paid plan + drive
     * not connected). Popup shows on every mount until the user
     * actually connects Drive — "Do it later" only hides it for
     * the current page mount; banner stays visible as a reminder.
     *
     * driveConnected:
     *   null  = not checked yet
     *   true  = connected (banner + popup hidden)
     *   false = not connected (banner + popup eligible)
     */
    const [driveConnected, setDriveConnected] = useState(null);
    const [showDrivePopup, setShowDrivePopup] = useState(false);

    /*
     * Setup-summary dialog (one-shot, post-onboarding).
     *
     * Set by ContactSyncStep right before navigating here. We read it
     * synchronously on first render so we don't flash the dashboard
     * without the dialog. Dismissed via the Okay button — the flag is
     * cleared then so a refresh / future visit doesn't re-open it.
     *
     * Tour gating: while this dialog is open the dashboard intro tour
     * is BLOCKED (the tour useEffect short-circuits on summaryOpen).
     * After Okay we set summaryOpen=false which lets the tour effect
     * proceed normally — same eligibility rules as before.
     */
    const SETUP_SUMMARY_FLAG = "fastAgentDetail.showSetupSummary";
    // Set by /setup-ready when the user opens one of its setup steps. Those
    // steps can route through the go-live wizard, which sets the summary flag
    // on finish — but the "is Live" summary popup is a one-time onboarding
    // celebration and must NOT re-appear just because the user completed a
    // step from /setup-ready. When this marker is present we consume both it
    // and the summary flag so the popup stays closed.
    const SETUP_READY_SUPPRESS_FLAG = "setupReady.suppressSetupSummary";
    const [summaryOpen, setSummaryOpen] = useState(() => {
        try {
            const wantSummary =
                sessionStorage.getItem(SETUP_SUMMARY_FLAG) === "true";
            const suppressed =
                sessionStorage.getItem(SETUP_READY_SUPPRESS_FLAG) === "true";
            const alreadySeen = hasSeenSetupSummary(getSummaryAgentId());

            // Always consume the suppress marker so a stale one cannot leak
            // into a later visit — but see below for whether it is ACTED on.
            if (suppressed) {
                sessionStorage.removeItem(SETUP_READY_SUPPRESS_FLAG);
            }

            if (!wantSummary) return false;

            /*
             * The suppress marker is set by /setup-ready on EVERY "Setup now"
             * click. Its purpose is narrow: stop the celebration re-appearing
             * when the user is just finishing ONE step later on.
             *
             * But the FIRST-EVER run of the sequence also starts from
             * /setup-ready, so the marker was killing the one showing it was
             * meant to allow — user completed triage -> contact sync ->
             * calendar, landed on the dashboard, and got no popup at all.
             *
             * The durable per-agent seen-marker is the correct discriminator:
             * "has this agent already had its celebration?" So the suppress
             * marker is honoured ONLY once the summary has actually been seen.
             * First completion shows; every later step-edit stays silent.
             */
            /*
             * Durable once-ever gate. SETUP_SUMMARY_FLAG alone is not enough:
             * it lives in sessionStorage, so it dies with the tab and any later
             * wizard finish can set it again — the celebration would then
             * re-appear on a return visit. The seen-marker is in localStorage
             * (survives the tab) and keyed per agent, so a second agent still
             * earns its own first-time summary. SelectAgentId is written
             * synchronously at the top of this file, so it is readable here.
             */
            if (alreadySeen) {
                sessionStorage.removeItem(SETUP_SUMMARY_FLAG);
                return false;
            }
            return true;
        } catch (_e) {
            return false;
        }
    });

    // User context — feeds the profile avatar in the header.
    const { user, updateUser } = useUser();

    // Header ka "Hello! <naam>" greeting — naam, profile-nudge aur photo.
    // Logic hooks/useProfileGreeting.js me hai; /dashboard bhi wahi use karta
    // hai, taaki dono header ek jaisa behave karein.
    const { headerFirstName, showCompletePrompt } = useProfileGreeting();
    /*
     * Rows to render inside the summary card. Built once after agent
     * data + spam + setup-score + calendar status are available; null
     * until then (dialog renders an empty state in the interim, but
     * the data fetch races complete fast enough that users typically
     * don't notice).
     */
    const [summaryItems, setSummaryItems] = useState(null);
    // Confetti fires exactly once per mount when the dialog opens.
    const confettiFiredRef = useRef(false);

    // Notifications
    const notifications = useNotificationStore((state) => state.notifications);
    const unreadCount = notifications.filter((n) => n.status === "unread").length;

    useClearStorage();
    // Multi-owner: resolve permissions for the SELECTED agent's owner, not a
    // single global membership. (Resolved below, once the agent — which carries
    // its own owner — is available.)

    const [agentDetails, setAgentDetail] = useState({
        agentId:
            location?.state?.agentId || sessionStorage.getItem("SelectAgentId"),
        bussinesId:
            location?.state?.bussinesId ||
            sessionStorage.getItem("SelectAgentBusinessId"),
        agentDetails: location?.state?.agentDetails,
    });

    const { agentData, setAgentById, setCurrentAgentId, getAgentById } =
        useAgentStore();

    // Resolve permissions for THIS agent's owner. The agent record carries its
    // owner (`userId`), which is the only reliable signal — session hints can be
    // missing (e.g. a single-agent member lands here straight from login) or
    // stale, which previously made an admin look like support and hid
    // Upgrade / Cancel Subscription / Delete from them.
    const { isTeamMember, isAdmin, canViewCallLogs, canViewAppointments, canEditAgents } = useAgentPermissions(
        agentData?.agent?.userId || selectedOwnerId || teamOwnerIdLS || undefined
    );
    // Admin team members act like the owner — payment / subscription actions
    // are unlocked for them (on any owner's agent they administer). Support
    // members and owners keep their behaviour.
    const isRestrictedTeamMember = isTeamMember && !isAdmin;

    // DELETE is different: a team member (even an admin) may delete ONLY their
    // OWN agent — never an owner's. An owner deleting their own agent is fine.
    // Own = the agent's owner is the logged-in user.
    const isOwnAgent = !isTeamMember || agentData?.agent?.userId === decodeTokenData?.id;

    const agentId =
        location?.state?.agentId ||
        queryAgentId ||
        params?.agentId ||
        sessionStorage.getItem("SelectAgentId");

    const bussinesId =
        location?.state?.bussinesId ||
        queryBusinessId ||
        params?.bussinesId ||
        resolvedBusinessId ||
        sessionStorage.getItem("SelectAgentBusinessId");

    const agentDetailsPayload = useMemo(
        () => ({ agentId, bussinesId }),
        [agentId, bussinesId]
    );

    // Resolve role before the API responds so the first render already picks
    // the right header/shimmer (Pounce vs Receptionist). Only trust sources
    // that belong to THIS agentId — store/storage may still hold the
    // previously opened agent.
    const loadedAgent =
        agentData?.agent && String(agentData.agent.agent_id) === String(agentId)
            ? agentData.agent
            : null;
    const cachedAgent = agentId ? getAgentById?.(agentId)?.agentData?.agent : null;
    const storedRole = (store) =>
        agentId && store.getItem("SelectAgentId") === String(agentId)
            ? store.getItem("SelectAgentRole")
            : null;
    const cachedAgentRole =
        loadedAgent?.agentRole ||
        loadedAgent?.role ||
        cachedAgent?.agentRole ||
        cachedAgent?.role ||
        location?.state?.agentRole ||
        (location?.state?.isPounce ? "pounce" : null) ||
        storedRole(sessionStorage) ||
        storedRole(localStorage) ||
        "";

    const isPounceAgent = String(cachedAgentRole).toLowerCase() === "pounce";
    const [pounceRange, setPounceRange] = useState("today");
    const [activePounceTab, setActivePounceTab] = useState("home");
    const handleAssignNum = async () => {
        try {
            const customerId = decodeTokenData?.customerId;
            const params = new URLSearchParams({ ispayg: "true", agentId: agentId || agentDetails?.agentId || "" });
            const successUrl = `${window.location.origin}/assign-number?${params.toString()}`;
            const cancelUrl = `${window.location.origin}/fast-agent-detail?AssignNumber=false`;

            const res = await axios.post(
                `${API_BASE_URL}/quick-setup-payg`,
                {
                    customerId,
                    userId,
                    url: successUrl,
                    cancelUrl,
                    isAssignNumber: true,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (res?.data?.checkoutUrl) {
                window.location.replace(res.data.checkoutUrl);
            }

            setShowUpgradeConfirmModal(false);
            setShowUpgradeConfirmModalAssign(false);
        } catch (error) {
            console.error("Error in handleAssignNum:", error);
        }
    };

    // ----- Upgrade -----
    // Routes to /recommended-plan?from=upgrade (skipping the pitch screen).
    //
    // from=upgrade SIRF is "Upgrade Agent" action ka marker hai — dashboard /
    // agent-detail menu se aane wala rasta. Do kaam karta hai: RecommendedPlan
    // isse plans grid kholta hai (bilkul mode=plans ki tarah), aur
    // GlobalCallBanner ko pata chal jaata hai ki ye screen upgrade tap se khuli
    // hai, kisi live sales call se nahi — to purple call banner chhupa rehta
    // hai. Baaki entry points (reactivate, setup-score, assign-number popup,
    // lifecycle emails) jaise the waise hi mode=plans par hain.
    //
    // RecommendedPlan reads currentAgentPlan from agentData and disables
    // the current plan + downgrade tiers so only upgrades are selectable.
    // After Stripe checkout, the user lands in the normal go-live flow.
    // GoLiveWizard handles the post-checkout agent update. Retiring the
    // previous plan is NOT done from the browser — cancelSupersededSubscription
    // does it off the checkout.session.completed webhook. upgradeOldSubId is
    // still passed along, but only as a hint (it can point at an add-on
    // subscription, so the server resolves the real target by product).
    const handleUpgradeClick = () => {
        const a = agentData?.agent;
        if (!a) return;
        // Support team members must never start a plan upgrade — payment
        // lives with the account owner. Admin team members are allowed.
        if (isRestrictedTeamMember) {
            setPopupType("failed");
            setPopupMessage(
                "You are not authorized. Contact your admin to get access."
            );
            return;
        }
        setUpgradeLoading(true);
        try {
            // Deliberate upgrade → clear any "just paid" guard so a legitimate
            // new purchase isn't blocked by the duplicate-payment protection.
            clearAgentPaid(a?.agent_id);

            // Route by current plan:
            //   • NO plan (free / demo / empty) → the /fast-step go-live demo flow
            //     (variant B with a number already assigned is the one exception —
            //     see below).
            //   • Any plan ($5 PAYG, trial, Starter/Scaler/Growth) → the plans list
            //     (/recommended-plan?from=upgrade) to upgrade.
            const _planKey = String(a?.agentPlan || "").trim().toLowerCase();
            const _noPlan = !_planKey || _planKey === "free" || _planKey === "demo";

            // If the user had a previous subscription or cancelled subscription
            // (e.g. they had a $5 PAYG or $20 trial plan and cancelled), they should
            // see the real plans grid (Starter, Scaler, Growth) instead of the $20 trial again.
            const hasPriorSub = Boolean(
                a?.subscriptionId ||
                a?.subscription?.id ||
                a?.subscription?.customer_id ||
                a?.isCancelSubscribed ||
                a?.cancelSubscriptionDate ||
                (a?.subscription && typeof a.subscription === "object" && Object.keys(a.subscription).length > 0)
            );

            /*
             * A/B variant B + PLAN NAHI + number pehle se assigned → /recommended-plan.
             *
             * B me number payment se PEHLE mil jaata hai, to plan "free" hote
             * hue bhi user /fast-step ka demo aur number dono paar kar chuka
             * hota hai. Neeche wali _noPlan branch use wapas /fast-step bhej
             * deti — yaani loop. Uske liye agla sahi kadam plan lena hai.
             *
             * `_noPlan` ka check zaroori hai. Iske bina variant B ka PAID user
             * (jaise Starter) bhi yahin nikal jaata tha, aur neeche wali upgrade
             * branch ka sessionStorage kabhi set hi nahi hota — natija:
             * RecommendedPlan ka isUpgradeFlow false, to Starter card lock hi
             * nahi hota (user apne hi plan ko "upgrade" kar sakta tha) aur
             * upgradeOldSubId na hone se purani subscription cancel bhi nahi
             * hoti. A me ye theek tha kyunki wahan ye branch chalti hi nahi.
             * Paid user ab neeche wale normal upgrade raste pe jaata hai.
             *
             * from=upgrade do kaam karta hai (dono branch ek jaisa behave karein
             * isliye niche wali paid-plan branch pe bhi wahi param hai):
             *   • RecommendedPlan seedha "Choose Your Plan" grid kholta hai —
             *     "Upgrade Agent" dabane ke baad plans hi dikhne chahiye,
             *     pitch / $5-trial screen nahi. (Pehle yahan GoLiveVariant ka
             *     recommended screen aata tha.)
             *   • GlobalCallBanner ko pata chalta hai ki ye screen upgrade tap
             *     se khuli hai, live sales call se nahi — to purple call banner
             *     chhupa rehta hai.
             * URL me rakha hai (router state me nahi) taaki refresh ke baad bhi
             * dono cheezein bani rahein.
             */
            if (_noPlan && !hasPriorSub && isVariantB() && hasAssignedVoipNumber(a)) {
                /*
                 * "Upgrade se aaya hai" ka marker — TrialOffer / GoLivePayg ise
                 * padh kar apna cross-sell link dikhate hain ("Not sure? Start
                 * with $5/mo plan" aur "Prefer to see plans first?").
                 *
                 * Baaki dono branches ye pehle se set karti hain, par wo
                 * /fast-step aur plans-grid pe jaati hain — offer screen pe
                 * sirf YAHI branch le jaati hai, aur yahan marker chhoot gaya
                 * tha. URL me bhi kuch nahi tha (/21-day-trial, bina query),
                 * to cameFromUpgrade hamesha false rehta aur link kabhi dikhta
                 * hi nahi.
                 *
                 * sessionStorage isliye (URL param nahi): user trial <-> $5 ke
                 * beech switch karta hai to marker dono screens pe bana rehta
                 * hai, aur refresh bhi jhel jaata hai.
                 */
                sessionStorage.setItem("updateBtn", "update");
                sessionStorage.setItem("SelectAgentId", a?.agent_id);
                sessionStorage.setItem("SelectAgentBusinessId", a?.businessId || "");
                navigate("/21-day-trial", {
                    state: {
                        agentID: a?.agent_id,
                        locationPath: location.pathname,
                        planName: a?.agentPlan,
                    },
                });
                return;
            }

            if (_noPlan && !hasPriorSub) {
                sessionStorage.setItem("updateBtn", "update");
                sessionStorage.setItem("SelectAgentId", a?.agent_id);
                sessionStorage.setItem("SelectAgentBusinessId", a?.businessId || "");
                navigate("/fast-step", { state: { suppressPopup: true } });
                return;
            }

            sessionStorage.setItem("updateBtn", "update");
            sessionStorage.setItem("currentAgentPlan", a?.agentPlan || "");
            sessionStorage.setItem("SelectAgentId", a?.agent_id);
            sessionStorage.setItem("SelectAgentBusinessId", a?.businessId || "");
            // Old subscription id for the post-checkout cancel call below.
            sessionStorage.setItem("upgradeOldSubId", a?.subscriptionId || a?.subscription?.id || "");
            // Keep RecommendedPlan in "upgrade" mode (locks current/lower
            // tiers), but send payment success through the normal flow.
            sessionStorage.setItem("upgradeReturnTo", "/go-live-setup");
            navigate("/recommended-plan?mode=plans&from=upgrade", {
                state: {
                    agentID: a?.agent_id,
                    locationPath: location.pathname,
                    subscriptionID: a?.subscriptionId || a?.subscription?.id,
                    planName: a?.agentPlan,
                    interval: a?.subscription?.interval || null,
                    customerId: a?.subscription?.customer_id || null,
                },
            });
        } catch (err) {
            console.error("Error during upgrade navigation:", err);
        } finally {
            setUpgradeLoading(false);
        }
    };

    // ----- Delete -----
    const handleDelete = async () => {
        const a = agentData?.agent;
        if (!a) return;
        const agent_id = a?.agent_id;
        const mins_left = a?.mins_left ? Math.floor(a.mins_left / 60) : 0;
        try {
            setdeleteloading(true);
            if (a.agentPlan !== "free") {
                try {
                    // immediate: the agent row is deleted right below, so the
                    // period-end teardown would have nothing left to act on.
                    await refundAndCancelSubscriptionAgnetApi(agent_id, mins_left, { immediate: true });
                } catch (notifyError) {
                    throw new Error(`Refund failed: ${notifyError.message}`);
                }
            }
            try {
                await deleteAgent(token, agent_id);
            } catch (deleteError) {
                throw new Error(`Delete failed: ${deleteError.message}`);
            }
            setPopupMessage("Agent deleted successfully!");
            setPopupType("success");
            setHasFetched(false);
            sessionStorage.removeItem("SelectAgentId");
            sessionStorage.removeItem("SelectAgentBusinessId");
            // After deletion the current agent is gone — send the user to the
            // onboarding fork so they can create a new one.
            setTimeout(() => navigate("/fork"), 1200);
        } catch (error) {
            setPopupMessage(`Failed to delete agent: ${error.message}`);
            setPopupType("failed");
        } finally {
            setdeleteloading(false);
            setShowDeleteConfirm(false);
        }
    };

    // ----- Deactivate / Activate -----
    const handleDeactivateAgent = async () => {
        const a = agentData?.agent;
        if (!a) return;
        let step = "start";
        try {
            setDeactivateLoading(true);
            const existingKBId = a?.knowledgeBaseId;
            const businessId = a?.businessId;
            const agentIdLocal = a?.agent_id;
            if (!agentIdLocal) throw new Error("Agent ID missing");
            const isCurrentlyDeactivated = !!a?.isDeactivated;

            if (!isCurrentlyDeactivated) {
                if (existingKBId) {
                    step = "deleteKnowledgeBase";
                    await deleteKnowledgeBase(token, existingKBId);
                }
                if (a?.agentPlan !== "free") {
                    step = "subscription-pause";
                    try {
                        await fetch(`${API_BASE}/subscription-pause`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                            },
                            body: JSON.stringify({ subscriptionId: a?.subscriptionId }),
                        });
                    } catch (pauseError) {
                        console.error("Error pausing subscription:", pauseError);
                    }
                }
            }

            if (isCurrentlyDeactivated && businessId) {
                step = "getBusinessDetailsByBusinessId";
                const businessDetails = await getBusinessDetailsByBusinessId(businessId);
                const packageMap = {
                    Free: 1,
                    Starter: 2,
                    Scaler: 3,
                    Growth: 4,
                    Corporate: 5,
                    Enterprise: 6,
                };
                const packageValue = packageMap[packageName] || 1;
                step = "getKnowledgeBaseName";
                const knowledgeBaseName = await getKnowledgeBaseName(
                    businessDetails,
                    userId,
                    packageValue,
                    a?.agentCode
                );
                const mergedUrls = [];
                if (businessDetails?.webUrl?.trim()) mergedUrls.push(businessDetails.webUrl.trim());
                if (businessDetails?.googleUrl) mergedUrls.push(businessDetails.googleUrl);
                const businessData = businessDetails?.knowledge_base_texts || {};
                const knowledgeBaseText = {
                    title: businessDetails?.businessType || "Business Info",
                    text: `
Business Name: ${businessData?.name || ""}
Address: ${businessData?.address || ""}
Phone: ${businessData?.phone || ""}
Website: ${businessData?.website || ""}
Rating: ${businessData?.rating || ""} (${businessData?.totalRatings || ""} reviews)
Business Status: ${businessData?.businessStatus || ""}
Categories: ${businessData?.categories || ""}
Opening Hours: ${businessData?.hours || ""}
                    `.trim(),
                };

                step = "createKnowledgeBaseWithDetails";
                const formData = new FormData();
                formData.append("knowledge_base_name", (knowledgeBaseName || "kb").slice(0, 39));
                if (mergedUrls.length > 0) {
                    formData.append("knowledge_base_urls", JSON.stringify(mergedUrls));
                }
                formData.append("enable_auto_refresh", "true");
                formData.append("knowledge_base_texts", JSON.stringify([knowledgeBaseText]));
                const createRes = await createKnowledgeBaseWithDetails(token, formData);
                if (!createRes?.success) {
                    throw new Error(createRes?.error || createRes?.message || "KB create failed");
                }
                const newKBId = createRes?.data?.knowledge_base_id || createRes?.knowledge_base_id;
                if (!newKBId) throw new Error("Knowledge base id not received from backend");
                sessionStorage.setItem("knowledgeBaseId", newKBId);

                step = "updateRetellLLM";
                const llmId = getAgentEngineId(a) || localStorage.getItem("llmId") || sessionStorage.getItem("llmId");
                if (llmId) {
                    const updateLLMRes = await updateLlm(token, llmId, { knowledge_base_ids: [newKBId] });
                    if (!updateLLMRes?.success) {
                        throw new Error(updateLLMRes?.error || updateLLMRes?.message || "LLM update failed");
                    }
                }

                if (a?.agentPlan !== "free") {
                    step = "subscription-resume";
                    try {
                        await fetch(`${API_BASE}/subscription-resume`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: `Bearer ${token}`,
                            },
                            body: JSON.stringify({ subscriptionId: a?.subscriptionId }),
                        });
                    } catch (resumeError) {
                        console.error("Error resuming subscription:", resumeError);
                    }
                }

                step = "updateAgentKnowledgeBaseId";
                try {
                    await updateAgentKnowledgeBaseId(agentIdLocal, newKBId);
                } catch (e1) {
                    try {
                        await updateAgentKnowledgeBaseId(token, agentIdLocal, newKBId);
                    } catch (e2) {
                        console.error("Failed to update agent KB ID in DB:", e2);
                    }
                }
            }

            step = "toggleAgentActivation";
            try {
                await toggleAgentActivation(agentIdLocal, !isCurrentlyDeactivated);
            } catch (e1) {
                await toggleAgentActivation(token, agentIdLocal, !isCurrentlyDeactivated);
            }

            // Optimistic store update — flip the icon (and Activate/Deactivate
            // label) immediately, without waiting for the background re-fetch
            // to complete. Otherwise the user sees the old icon for 2-3s.
            const newIsDeactivated = !isCurrentlyDeactivated ? 1 : 0;
            const cached = getAgentById(agentIdLocal);
            if (cached?.agentData) {
                setAgentById(
                    agentIdLocal,
                    {
                        ...cached.agentData,
                        agent: {
                            ...cached.agentData.agent,
                            isDeactivated: newIsDeactivated,
                        },
                    },
                    cached.assignedNumbers,
                    cached.totalBookings
                );
            }

            setPopupType("success");
            setPopupMessage(
                isCurrentlyDeactivated ? "Agent activated successfully." : "Agent deactivated successfully."
            );
            setShowDeactivateConfirm(false);
            setHasFetched(false);
            setRefresh((p) => p + 1);
        } catch (error) {
            console.error(`Activation/Deactivation Error at step: ${step}`, error);
            setPopupType("failed");
            setPopupMessage(`Failed to update agent status. Step: ${step}`);
            setShowDeactivateConfirm(false);
        } finally {
            setDeactivateLoading(false);
        }
    };

    // ----- Pay-As-You-Go -----
    const checkAgentPaygStatus = async (id) => {
        if (!id) return;
        try {
            const response = await fetch(`${API_BASE}/pay-as-you-go-status-check`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ agentId: id, customerId: customer_id }),
            });
            const data = await response.json();
            setpaygStatusLoading(true);
            if (data.success) {
                setisPaygActive(true);
                localStorage.setItem("isPayg", "true");
            } else {
                setisPaygActive(false);
            }
        } catch (error) {
            console.error("Error checking Payg status:", error);
        } finally {
            setpaygStatusLoading(false);
        }
    };

    const checkUserPayg = async () => {
        try {
            const res = await axios.post(`${API_BASE_URL}/check-payg-enable`, { customer_id });
            if (res?.data?.success) {
                setcheckPaygStatus(res?.data?.paygStatus);
            } else {
                setcheckPaygStatus(false);
            }
        } catch (error) {
            console.error("Error checking payg status:", error);
            setcheckPaygStatus(false);
        }
    };

    const handleTogglePayG = async () => {
        const a = agentData?.agent;
        if (!a) return;
        setpaygStatusLoading(true);
        try {
            const requestData = {
                customerId: customer_id,
                agentId: a?.agent_id,
                status: isPaygActive ? "inactive" : "active",
                isFree:
                    a.agentPlan === "free" ||
                    (a.agentPlan === "Pay-As-You-Go" ? true : false),
                isByAdmin: a?.subscriptionId === "byAdmin" ? true : false,
            };
            const response = await fetch(`${API_BASE}/pay-as-you-go-saveAgent`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(requestData),
            });
            if (response.ok) {
                const responseData = await response.json();
                if (responseData.status === "active") {
                    setisPaygActive(true);
                    setPopupMessage("Agent's Pay-as-you-go feature activated.");
                    setPopupType("success");
                } else {
                    setisPaygActive(false);
                    setPopupMessage("Agent's Pay-as-you-go feature has been disabled.");
                    setPopupType("failed");
                }
                setHasFetched(false);
                setRefresh((p) => p + 1);
            } else {
                const responseData = await response.json();
                setPopupMessage(responseData?.error || "Failed to update PAYG status.");
                setPopupType("failed");
            }
        } catch (error) {
            console.error("Error during PAYG toggle:", error);
        } finally {
            setpaygStatusLoading(false);
        }
    };

    // ----- Logout (moved here from Dashboard) -----
    const handleLogout = () => {
        setPopupType("confirm");
        setPopupMessage("Are you sure you want to logout?");
    };

    const handleLogoutConfirm = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("userId");
        localStorage.removeItem("agents");
        localStorage.clear();
        sessionStorage.clear();
        window.location.replace("/?step=3");
    };

    // Open the More-menu actions from FooterNew
    const openUpgradeConfirm = () => setShowUpgradeConfirmModal(true);
    const openDeleteConfirm = () => setShowDeleteConfirm(true);
    const openDeactivateConfirm = () => {
        // Fresh feedback each time the pause modal opens.
        setDeactivateReason("");
        setDeactivateOtherText("");
        setShowDeactivateConfirm(true);
    };

    /*
     * Reactivate-from-cancel handler.
     *
     * Stripe sub cancel webhook resets agentPlan="free" + isDeactivated=1.
     * If we just flipped isDeactivated back to 0 the agent would be live
     * with no paid plan. Route the user through /recommended-plan so the
     * backend webhook on the new sub re-enables the agent (handlePaymentSuccess
     * already sets isDeactivated=0 + agentPlan=<new plan> on first invoice).
     * Mirrors handleUpgradeClick's sessionStorage shape so RecommendedPlan
     * runs in upgrade-flow mode (back routing sane, /go-live-setup as
     * success URL).
     */
    const handleReactivateNoSub = () => {
        const a = agentData?.agent;
        if (!a) return;
        setShowDeactivateConfirm(false);
        sessionStorage.setItem("updateBtn", "update");
        sessionStorage.setItem("currentAgentPlan", a?.agentPlan || "free");
        sessionStorage.setItem("SelectAgentId", a?.agent_id || "");
        sessionStorage.setItem(
            "SelectAgentBusinessId",
            a?.businessId || ""
        );
        sessionStorage.setItem("upgradeReturnTo", "/go-live-setup");
        navigate("/recommended-plan?mode=plans", {
            state: {
                agentID: a?.agent_id,
                locationPath: location.pathname,
                planName: a?.agentPlan,
            },
        });
    };
    const openPaygConfirm = () => {
        setshowPaygConfirm(true);
        setpaygEnabledPopup(checkPaygStatus === null || checkPaygStatus === 0);
    };
    /*
     * Reset the reason on every open. Without this, closing the modal without
     * confirming and reopening it showed the previous answer still selected —
     * and the "Yes, Cancel" guard below would already be satisfied, so a
     * destructive action sat one click away on a form the user had not
     * answered this time round.
     */
    const openCancelSubConfirm = () => {
        setCancelReason("");
        setCancelOtherText("");
        setShowCancelSubConfirm(true);
    };

    /*
     * Draft Agent → Continue Setup.
     *
     * Mirrors Dashboard.handleCompleteSetup exactly:
     *   1. If the user never reached the Details screen
     *      (OwnerDetails missing AND no name/phone signal), send
     *      them to /details so they can fill basic info first.
     *   2. Otherwise route by the agent_creation_method1 flag
     *      stored when the user originally picked Fast vs Guided.
     *      Fast → /business-step, Guided → /steps, unknown → /fork.
     *
     * Keeping the logic IDENTICAL to Dashboard's version is
     * intentional — same code path means the resume experience
     * matches whether a user came in pre- or post- multi-agent
     * dashboard re-enable.
     */
    const handleDraftContinue = async () => {
        /*
         * Last-chance hydration before routing.
         *
         * Mount-time hydration in the `count === 0` branch usually
         * has finished by the time the user reads the card and taps,
         * but a fast clicker can race it. Awaiting here guarantees
         * sessionStorage.agent_creation_method1 + the form-state
         * keys are populated BEFORE we navigate, so the destination
         * step component renders pre-filled instead of blank. If the
         * tracker call already completed, this is a cheap no-op
         * (helper short-circuits on subsequent calls in practice
         * because sessionStorage is already set).
         */
        const emailForTracker =
            user?.email ||
            decodeTokenData?.email ||
            localStorage.getItem("userEmail") ||
            "";
        try {
            await loadAndHydrateOnboardingTracker({
                email: emailForTracker,
                userId,
            });
        } catch (_e) {
            /* Defensive — helper already handles its own errors. */
        }

        // Resume into the EXACT route the user last left from (persisted to
        // localStorage so it survives a full app reopen). Falls back to the
        // Fast Setup flow (/business-step) when nothing was recorded.
        const resumeRoute = getResumeRoute() || "/business-step";
        const targetRoute = (resumeRoute === "/details" || resumeRoute === "/steps") ? "/business-step" : resumeRoute;
        navigate(targetRoute, { state: { mode: "resume" } });
    };

    /*
     * Draft Agent → Discard.
     *
     * Clears sessionStorage wholesale (brutal but intentional —
     * wipes OwnerDetails, business state, method selection, etc.)
     * then starts a fresh new-agent flow directly at the business
     * step (/business-step, mode "new"), so the user begins creating
     * the new agent right away instead of seeing the Fast/Guided
     * fork screen again.
     */
    const handleDraftDiscardConfirmed = () => {
        try {
            sessionStorage.clear();
        } catch (_e) { }
        // Discarding the draft must also wipe the persisted resume backup,
        // otherwise the next /business-step mount would rehydrate the old
        // selections from localStorage instead of starting fresh.
        clearOnboardingResume();
        setShowDiscardDraftModal(false);
        navigate("/business-step", { state: { mode: "new" } });
    };

    /*
     * Cancel-subscription executor.
     *
     * Mirrors Dashboard.handleCancelSubscription's non-PAYG branch —
     * we route through refundAndCancelSubscriptionAgnetApi which
     * encapsulates the refund-eligibility check on the backend side.
     * The modal UI surfaces the right copy (immediate refund vs
     * scheduled at period-end) based on a client-side mirror of the
     * eligibility math so the user knows which path they're on
     * BEFORE confirming.
     *
     * After success we refresh the agent record (callSummary, plan
     * status, etc.) so the dashboard reflects the cancelled state
     * without a full reload. User stays on /fast-agent-detail per
     * product spec — no navigation, just a success toast.
     */
    const handleCancelSubscriptionConfirmed = async () => {
        const a = agentData?.agent;
        if (!a) return;
        const agent_id = a?.agent_id;
        const mins_left = a?.mins_left ? Math.floor(a.mins_left / 60) : 0;
        setCancelSubLoading(true);
        try {
            const result = await refundAndCancelSubscriptionAgnetApi(agent_id, mins_left);
            setPopupType("success");
            setPopupMessage(
                result?.message || "Subscription cancellation processed.",
            );
            setShowCancelSubConfirm(false);
            setJustCancelledAgentId(agent_id);
            if (result?.scheduled) {
                setJustScheduledCancel({ agentId: agent_id, accessUntil: result.accessUntil || null });
            }
            // Only paint the agent as dead when the backend actually tore it down
            // (refund-eligible → immediate). When it isn't eligible the plan is
            // merely scheduled to stop at period end: the agent keeps its minutes
            // and its number until then, so wiping the cache here would show a
            // deactivated agent that is in fact still live and usable.
            const wasImmediate = result?.immediate === true || result?.eligible === true;
            const cached = getAgentById(agent_id);
            if (wasImmediate && cached?.agentData) {
                setAgentById(
                    agent_id,
                    {
                        ...cached.agentData,
                        agent: {
                            ...cached.agentData.agent,
                            agentPlan: "free",
                            isDeactivated: 1,
                            mins_left: 0,
                        },
                    },
                    cached.assignedNumbers,
                    cached.totalBookings
                );
            }
            // Refresh agent data so the UI reflects the new state.
            setHasFetched(false);
            setRefresh((p) => p + 1);
        } catch (error) {
            console.error("[FastAgentDetails] cancel subscription failed:", error);
            setPopupType("failed");
            setPopupMessage(
                `Failed to cancel subscription: ${error?.message || "Unknown error"}`,
            );
            setShowCancelSubConfirm(false);
        } finally {
            setCancelSubLoading(false);
        }
    };

    // Set true when the agentId→businessId backfill can't complete (fetch error,
    // agent not in the user's list, or no businessId on the record) so the load
    // guard below falls through to its recovery branch instead of spinning
    // forever on a cold WebView/email deep-link. Additive — the happy path
    // (businessId resolves) is unchanged.
    const [bizIdResolveFailed, setBizIdResolveFailed] = useState(false);

    useEffect(() => {
        if (!agentId || bussinesId || !userId) return;
        const resolveBusinessIdFromAgent = async () => {
            try {
                const res = await fetchDashboardDetails(userId, token);
                const matchedAgent = (res?.agents || []).find(
                    (agent) => String(agent?.agent_id) === String(agentId)
                );
                // Accept either camelCase or snake_case (some payloads use business_id).
                const bizId = matchedAgent?.businessId || matchedAgent?.business_id;
                if (bizId) {
                    setResolvedBusinessId(bizId);
                    sessionStorage.setItem("SelectAgentId", agentId);
                    sessionStorage.setItem("SelectAgentBusinessId", bizId);
                } else {
                    setBizIdResolveFailed(true); // no match / no businessId → don't hold the loader
                }
            } catch (err) {
                console.error("Failed to resolve business id for agent link:", err);
                setBizIdResolveFailed(true);
            }
        };
        resolveBusinessIdFromAgent();
    }, [agentId, bussinesId, userId, token]);

    useEffect(() => {
        if (agentData?.agent?.agent_id) {
            checkAgentPaygStatus(agentData?.agent?.agent_id);
        }
    }, [agentData?.agent?.agent_id]);

    useEffect(() => {
        checkUserPayg();
    }, [checkPaygStatus, paygEnabledPopup]);

    // ✅ Retell Web Client init
    useEffect(() => {
        const client = new RetellWebClient();
        client.on("call_started", () => setIsCallActive(true));
        client.on("call_ended", () => setIsCallActive(false));
        setRetellWebClient(client);
    }, []);

    // Post-upgrade hook — fires when the user lands here from the Stripe
    // success URL with ?upgraded=1. We cancel the old subscription, refresh
    // agent data (so the new plan label appears), and clear the URL params.
    // If the user came here outside the upgrade flow, we just clear any
    // stale upgrade flags so they don't leak into a later assign-number flow.
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const isPostUpgrade = params.get("upgraded") === "1";

        if (isPostUpgrade) {
            // The previous plan is NOT cancelled from here any more. This used
            // to POST /cancel-subscription with upgradeOldSubId — i.e.
            // agent.subscriptionId, which the assign-number flow overwrites with
            // the "Add-on Services" subscription id — so an upgrade killed the
            // customer's add-on / PAYG and left Starter/Scaler billing.
            // cancelSupersededSubscription now does it server-side off the
            // checkout.session.completed webhook, targeting by product.
            sessionStorage.removeItem("upgradeOldSubId");
            sessionStorage.removeItem("upgradeReturnTo");
            sessionStorage.removeItem("currentAgentPlan");
            setHasFetched(false);
            setRefresh((p) => p + 1);
            setPopupType("success");
            setPopupMessage("Plan upgraded successfully!");
            // Strip query params from URL so a refresh doesn't re-trigger.
            navigate("/fast-agent-detail", { replace: true });
        } else {
            sessionStorage.removeItem("upgradeOldSubId");
            sessionStorage.removeItem("upgradeReturnTo");
            sessionStorage.removeItem("currentAgentPlan");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ✅ Check assign number payment status
    const checkAssignNumber = async () => {
        try {
            const res = await axios.post(`${API_BASE}/assign-number-check`, {
                customer_id,
            });
            if (res.data.success) {
                setAssignNumberPaid(true);
            } else {
                setAssignNumberPaid(false);
            }
        } catch (error) {
            console.error("Error checking assign number:", error);
            setAssignNumberPaid(false);
        }
    };

    useEffect(() => {
        checkAssignNumber();
    }, []);

    /*
     * White-screen safety net. If the page sits in the loading
     * state for more than 8 seconds (slow network, stuck fetch,
     * unhandled promise) we force-unblock so the user sees the
     * dashboard chrome instead of an indefinite spinner. The
     * downstream effects keep retrying their own fetches; this
     * timer just refuses to leave the user hanging.
     */
    useEffect(() => {
        if (!loading) return;
        const timer = setTimeout(() => setLoading(false), 8000);
        return () => clearTimeout(timer);
    }, [loading]);

    // ✅ Assign number validity check
    const handleAssignNumberValidtyCheck = async (agentId) => {
        try {
            const res = await axios.post(
                `${API_BASE_URL}/check-assign-number-month`,
                { agentId }
            );
            return res.data;
        } catch (error) {
            console.error("Error checking assign number:", error);
            return false;
        }
    };

    // ✅ Load agent details
    useEffect(() => {
        /*
         * White-screen guard. If the user lands here with no agentId
         * resolvable from URL params / sessionStorage / location.state
         * (e.g. fresh OAuth bounce-back, deep link, or storage cleared
         * by another tab), the original code returned early WITHOUT
         * flipping `loading` to false — leaving the user staring at
         * the loader forever. We now fall back to the onboarding fork
         * so they have a path forward instead of an infinite spinner.
         */
        if (agentId && !bussinesId && !bizIdResolveFailed) {
            setLoading(true);
            return;
        }

        if (!agentId || !bussinesId) {
            /*
             * NOTE: no setLoading(false) here on purpose.
             *
             * Dropping the loader before the async agent-count probe resolves
             * is what made a brand-new first-time user see the "Draft Agent"
             * card for a beat before being routed to /business-step. The loader
             * now stays up until we actually know which of the three outcomes
             * applies; each branch below turns it off (or navigates away).
             * The 8s white-screen watchdog above guarantees this cannot hang.
             */
            /*
             * No agent context. Three outcomes possible:
             *
             *   - 2+ existing agents → /dashboard (multi-agent picker).
             *     The earlier blanket bounce to /fork caused a loop:
             *     fork has no "pick existing" affordance, so users
             *     with multiple agents got trapped.
             *
             *   - 1 existing agent → select it and reload fast-agent-detail inline.
             *
             *   - 0 agents → render the Draft Agent card inline on
             *     THIS page (don't navigate). Previously we bounced
             *     to /fork which silently started a fresh onboarding
             *     instead of letting the user resume where they left.
             *     The draft card mirrors Dashboard's UX: Continue
             *     button → handleCompleteSetup (reads
             *     agent_creation_method1 from storage and routes),
             *     Discard button → clear + /steps.
             *
             * Agent count is fetched async, so we set loading=false
             * first to avoid the infinite spinner and only navigate
             * once the count call resolves.
             */
            const hasResume = !!sessionStorage.getItem("SelectAgentId");
            if (hasResume) {
                // The one case that wants the normal view immediately: agentId
                // IS known here (only bussinesId failed to resolve), so there is
                // real data to render — nothing is a placeholder.
                setLoading(false);
                return;
            }
            (async () => {
                try {
                    let agentsList = [];
                    if (isTeamMember) {
                        try {
                            const res = await fetchTeamDashboard();
                            agentsList = res?.agents || [];
                        } catch (err) {
                            console.error("fetchTeamDashboard failed:", err);
                        }
                    } else if (userId) {
                        try {
                            const res = await fetchDashboardDetails(userId, token);
                            agentsList = res?.agents || [];
                        } catch (err) {
                            console.error("fetchDashboardDetails failed:", err);
                        }
                    }

                    const count = agentsList.length;

                    // Agent exists → close any pending Make/Zapier OAuth loop.
                    if (count >= 1) closeOAuthLoopIfAgentExists();

                    if (count === 1) {
                        const firstAgent = agentsList[0];
                        if (firstAgent?.agent_id) {
                            sessionStorage.setItem("SelectAgentId", firstAgent.agent_id);
                            sessionStorage.setItem(
                                "SelectAgentBusinessId",
                                firstAgent.businessId || ""
                            );
                            setShowDraftView(false);
                            navigate("/fast-agent-detail", {
                                replace: true,
                                state: {
                                    agentId: firstAgent.agent_id,
                                    bussinesId: firstAgent.businessId || "",
                                },
                            });
                        } else {
                            navigate("/fast-agent-detail", { replace: true });
                        }
                    } else if (count > 1) {
                        navigate("/dashboard", { replace: true });
                    } else {
                        /*
                         * 0 agents — flip to the Draft Agent card AND
                         * hydrate sessionStorage from the saved
                         * onboarding tracker.
                         *
                         * Why both: the card itself just shows
                         * "Continue Setup". The button routes via
                         * `agent_creation_method1` AND the destination
                         * step component reads sessionStorage to
                         * pre-fill the user's previous answers
                         * (businessType, services, place details,
                         * voice, agent name, etc.). Without the
                         * tracker fetch, the user lands on a blank
                         * form and starts over — exactly the
                         * regression the user reported.
                         */
                        /*
                         * 0 agents. Distinguish a genuine ABANDONED DRAFT (the
                         * user started onboarding — a saved tracker OR a local
                         * resume route exists) from a BRAND-NEW first-time user
                         * (no progress at all). ONLY the former sees the "Draft
                         * Agent" resume card; a brand-new user goes straight to
                         * a fresh /business-step instead of a misleading
                         * "continue your draft" card.
                         *
                         * The tracker fetch is AWAITED — the old code fired it
                         * and forgot, so the card was shown before anyone knew
                         * whether a draft existed. We still hydrate when one
                         * does exist, so resumed steps pre-fill prior answers.
                         */
                        /*
                         * Personal Details not submitted yet (user left /details
                         * without Continue, e.g. killed the app and reopened the
                         * link) → resume on /details, never skip past it. Server
                         * verifyDetails is the source of truth. Team members use
                         * the owner's account, so they are never checked here.
                         */
                        if (!isTeamMember && !selectedOwnerId && !teamOwnerIdLS && userIdFromToken) {
                            try {
                                const ud = await getUserDetails(userIdFromToken, token);
                                const u = ud?.user || ud || {};
                                const v = u.verifyDetails;
                                if ("verifyDetails" in u && !(v === true || v === 1 || v === "true")) {
                                    setLoading(false);
                                    navigate("/details", { replace: true });
                                    return;
                                }
                            } catch (_e) {
                                /* fetch failed — fall through to the normal flow */
                            }
                        }
                        const emailForTracker =
                            user?.email ||
                            decodeTokenData?.email ||
                            localStorage.getItem("userEmail") ||
                            "";
                        let hasDraft = false;
                        if (emailForTracker || userId) {
                            const r = await loadAndHydrateOnboardingTracker({
                                email: emailForTracker,
                                userId,
                            });
                            hasDraft = !!r?.hydrated;
                        }
                        // A local resume route survives a flaky tracker fetch —
                        // treat it as a draft signal too so a real draft is not
                        // lost to one failed request.
                        if (!hasDraft && getResumeRoute()) hasDraft = true;

                        if (hasDraft) {
                            setShowDraftView(true);
                            setLoading(false);
                        } else {
                            setShowDraftView(false);
                            navigate("/business-step", {
                                replace: true,
                                state: { mode: "new" },
                            });
                        }
                    }
                } catch (err) {
                    // On failure, default to /fork — old behaviour.
                    console.warn(
                        "[FastAgentDetails] agent check failed:",
                        err?.message || err,
                    );
                    setLoading(false);
                    navigate("/fork", { replace: true });
                }
            })();
            return;
        }

        setShowDraftView(false);
        sessionStorage.setItem("SelectAgentId", agentId);
        sessionStorage.setItem("SelectAgentBusinessId", bussinesId);

        // Agent in context → close any pending Make/Zapier OAuth loop (no-op if none).
        closeOAuthLoopIfAgentExists();

        const load = async () => {
            const cached = getAgentById(agentId);
            if (cached) {
                setCurrentAgentId(agentId);
                setLoading(false);
            }

            try {
                setLoading(true);
                const response = await fetchAgentDetailById(agentDetailsPayload);
                const agentInfo = response?.data;

                let numbersArray = [];
                const voipNumbersStr = agentInfo?.agent?.voip_numbers;
                if (voipNumbersStr) {
                    try {
                        numbersArray = JSON.parse(voipNumbersStr);
                    } catch { }
                }

                const loadedRole = agentInfo?.agent?.agentRole || agentInfo?.agent?.role || "";
                if (loadedRole) {
                    localStorage.setItem("SelectAgentId", agentId);
                    sessionStorage.setItem("SelectAgentRole", loadedRole);
                    localStorage.setItem("SelectAgentRole", loadedRole);
                } else {
                    sessionStorage.removeItem("SelectAgentRole");
                    localStorage.removeItem("SelectAgentRole");
                }

                setAgentById(agentId, agentInfo, numbersArray);
                setCurrentAgentId(agentId);
            } catch (err) {
                console.error("Failed to fetch agent details:", err);
            } finally {
                setLoading(false);
            }
        };

        load();
    }, [
        agentId,
        bussinesId,
        agentDetailsPayload,
        isTeamMember,
        getAgentById,
        navigate,
        setAgentById,
        setCurrentAgentId,
        token,
        user?.email,
        userId,
        decodeTokenData?.email,
        closeOAuthLoopIfAgentExists,
        fetchTeamDashboard,
        bizIdResolveFailed, // re-run once backfill fails so the guard can fall through
    ]);

    const agent = agentData?.agent;

    /*
     * Setup-bar retirement — TWO triggers, ONE flag.
     *
     * After the first ONE WEEK on the app, the always-on "Great Progress" setup
     * bar is retired from this page; at the SAME moment its entry appears in the
     * bottom More menu as the "Setup Score" icon (FooterNew `showSetupScoreEntry`).
     * The bar ALSO retires the moment the agent is deactivated / its
     * subscription is cancelled.
     *
     * Anchored to AGENT CREATION date, not subscription dates: createdAt never
     * resets, so the window survives cancel/re-pay and works for free and paid
     * agents alike. (Verified present on this API: the AgentDetails model sets
     * `timestamps: true` and fetchAgentDetailsById returns the row unfiltered.)
     * Setup score itself is a mark-once ledger on the backend, so it never
     * decreases across that window either.
     *
     * Both triggers share ONE flag so the page and the More menu can never
     * disagree — the previous split (bar hidden by one rule, menu icon shown by
     * another) is exactly how the entry point went missing on deactivation.
     */
    const AGENT_ONBOARDING_WINDOW_DAYS = 7;
    const isAgentOnboardingWeekOver = (() => {
        const createdAt = agent?.createdAt;
        if (!createdAt) return false; // no date yet → keep the bar (safe default)
        const days = dayjs().diff(dayjs(createdAt), "day");
        return Number.isFinite(days) && days >= AGENT_ONBOARDING_WINDOW_DAYS;
    })();

    /*
     * `isDeactivated` is polymorphic across surfaces — the optimistic store
     * update below writes a NUMBER (1/0) while the post-cancel re-fetch returns
     * boolean `true`. The old page gate tested `=== 1`, which missed the boolean
     * and left the bar on screen after a cancellation. Accept all three forms.
     *
     * Named `isAgentCancelledOrDeactivated`, NOT `isAgentDeactivated`: the
     * Deactivate/Activate confirm modal further down already owns a local
     * `isAgentDeactivated` inside its IIFE. A same-name binding here would be
     * legal (different scope) but would shadow it, and anyone editing that modal
     * could reasonably misread which flag they were looking at. That existing
     * local is live code and stays exactly as it is.
     */
    const isAgentCancelledOrDeactivated =
        agent?.isDeactivated === true ||
        Number(agent?.isDeactivated) === 1 ||
        String(agent?.isDeactivated || "").trim().toLowerCase() === "true";

    /*
     * A cancellation is scheduled but the paid period has not run out yet.
     *
     * `agentPlan` and `isDeactivated` cannot see this state: the not-eligible
     * cancel path leaves the agent record untouched on purpose (they keep their
     * minutes and number until period end). The Subscription row is where it
     * lands — handleSubscriptionCanceled writes `status: 'cancel_scheduled'`,
     * `payment_status: 'payment_canceled_on_end'` and `next_renewal_date: <the
     * cancel date>` — and fetchAgentDetailsById already returns that row as
     * `data.subscription`, so no extra request is needed.
     *
     * Both markers are read: `status` is the primary signal, `payment_status`
     * covers a row whose status was moved on by a later webhook while the
     * scheduled cancel still stands. Same pair MySubscription uses on
     * /edit-profile, so the two screens cannot disagree about "already
     * cancelled".
     */
    const subscriptionRow = agentData?.subscription;
    const justScheduledThisAgent =
        !!agent?.agent_id && justScheduledCancel?.agentId === agent.agent_id;
    const isSubscriptionCancelScheduled =
        String(subscriptionRow?.status || "").trim().toLowerCase() === "cancel_scheduled" ||
        subscriptionRow?.payment_status === "payment_canceled_on_end" ||
        justScheduledThisAgent;

    const cancelScheduledUntil = (() => {
        if (!isSubscriptionCancelScheduled) return null;
        // Until the webhook lands, the row still holds the old renewal date; the cancel response has the real one.
        const raw = (justScheduledThisAgent && justScheduledCancel.accessUntil) || subscriptionRow?.next_renewal_date;
        if (!raw) return null;
        const d = new Date(raw);
        return Number.isNaN(d.getTime())
            ? null
            : d.toLocaleDateString("en-US", { day: "numeric", month: "long", year: "numeric" });
    })();

    const isSubscriptionCanceled =
        String(subscriptionRow?.status || "").trim().toLowerCase() === "canceled";
    // PAYG rows often lack agentId, so a PAYG cancel shows up only as account-level is_payg = 0.
    const isPaygSwitchedOff =
        /payg|pay-as-you-go/i.test(String(agentData?.agent?.agentPlan || "")) &&
        Number(agentData?.user?.is_payg) === 0;
    const reactivateAgentId = agentData?.agent?.agent_id;
    const mayReactivate =
        isSubscriptionCancelScheduled ||
        isSubscriptionCanceled ||
        isAgentCancelledOrDeactivated ||
        isPaygSwitchedOff ||
        (!!reactivateAgentId && justCancelledAgentId === reactivateAgentId);

    useEffect(() => {
        if (!reactivateAgentId || isRestrictedTeamMember) return;
        if (!mayReactivate) {
            setReactivation(null);
            return;
        }
        let cancelled = false;
        getReactivationStatus(reactivateAgentId)
            .then((s) => !cancelled && setReactivation(s))
            .catch(() => !cancelled && setReactivation(null));
        return () => {
            cancelled = true;
        };
    }, [reactivateAgentId, mayReactivate, isRestrictedTeamMember, refresh]);

    // Back from a reactivation checkout: finish PAYG activation, then send the user to pick a number
    // (only if the agent has none). Keyed on the params: the embedded sheet lands here without remounting.
    const reactivatedParam = searchParams.get("reactivated");
    const reactivatedSessionId = searchParams.get("session_id");
    useEffect(() => {
        const sessionId = reactivatedSessionId;
        if (reactivatedParam !== "1" || !sessionId || !queryAgentId) return;
        const stayOnPage = () => {
            searchParams.delete("reactivated");
            searchParams.delete("session_id");
            navigate({ search: searchParams.toString() }, { replace: true });
            setHasFetched(false);
            setRefresh((p) => p + 1);
        };
        confirmReactivation(queryAgentId, sessionId)
            .then((res) => {
                if (res?.hasNumber) {
                    setPopupType("success");
                    setPopupMessage("Your plan is active again. Your number stays the same.");
                    stayOnPage();
                    return;
                }
                // Same as a paid agent's Assign Phone Number click. fromCheckout=1 stops the wizard
                // bouncing a plan whose agentPlan the invoice webhook hasn't updated from "free" yet.
                try {
                    sessionStorage.setItem("SelectAgentId", queryAgentId);
                    sessionStorage.setItem("SelectAgentBusinessId", queryBusinessId || agent?.businessId || "");
                    sessionStorage.setItem("goLiveWizard.assignNumberOnly", "1");
                } catch (_e) { }
                navigate("/go-live-setup?fromCheckout=1", { replace: true });
            })
            .catch((e) => {
                setPopupType("failed");
                setPopupMessage(e?.message || "Could not confirm your reactivation. Please refresh.");
                stayOnPage();
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reactivatedParam, reactivatedSessionId, queryAgentId]);

    const handleReactivateConfirmed = async () => {
        if (!reactivateAgentId) return;
        setReactivateLoading(true);
        try {
            const result = await reactivateSubscription(reactivateAgentId, {
                embedded: isEmbeddedCheckoutEnabled(),
            });
            if (result?.mode === "checkout" && result?.clientSecret) {
                // Pay in the in-page sheet; on success it lands back here with reactivated=1.
                setShowReactivateConfirm(false);
                useCheckoutStore.getState().openCheckout({
                    clientSecret: result.clientSecret,
                    sessionId: result.sessionId,
                    hostedUrl: result.checkoutUrl || null,
                    meta: {
                        agentId: reactivateAgentId,
                        planName: reactivation?.planName,
                        next: "/fast-agent-detail",
                        extraParams: {
                            businessId: agent?.businessId || queryBusinessId || "",
                            reactivated: "1",
                            session_id: result.sessionId,
                        },
                    },
                });
                return;
            }
            if (result?.mode === "checkout" && result?.checkoutUrl) {
                window.location.href = result.checkoutUrl;
                return;
            }
            setShowReactivateConfirm(false);
            setJustCancelledAgentId(null);
            setReactivation(null);
            setPopupType("success");
            setPopupMessage("Your plan is active again. Your number stays the same.");
            setHasFetched(false);
            setRefresh((p) => p + 1);
        } catch (error) {
            setShowReactivateConfirm(false);
            setPopupType("failed");
            setPopupMessage(
                error?.code === "card_required"
                    ? `${error.message} You can add one in Edit Profile → Payment Method.`
                    : error?.message || "Could not reactivate your plan.",
            );
        } finally {
            setReactivateLoading(false);
        }
    };

    /*
     * Retirement is a LATCH, not a state read.
     *
     * `setupBarRetiredAt` is the durable half: stamped server-side the first
     * time either condition holds, never cleared. Without it the bar came back
     * after a cancelled user upgraded, because `isAgentCancelledOrDeactivated`
     * flips false again on re-subscribe — one permanent fact ORed with one
     * reversible one is still reversible.
     *
     * The two live terms stay so the bar retires IMMEDIATELY on cancel, without
     * waiting for the next getScore round-trip. The server field is what makes
     * it survive an upgrade, a different device, and cleared storage.
     */
    const retireSetupBar =
        !!setupScore?.setupBarRetiredAt ||
        isAgentOnboardingWeekOver ||
        isAgentCancelledOrDeactivated;

    /*
     * Setup poora ho chuka — na page pe bar, na More menu me entry.
     *
     * Ye check pehle SIRF page wale render me inline tha (`percent >= 100`),
     * `retireSetupBar` me nahi. Natija: 100% pe bar to page se hat jaati thi,
     * par jis agent ka pehla hafta nikal chuka tha uski More menu me "Setup
     * Score" entry 100% ke baad bhi padi rehti thi — kuch karne ko bacha hi
     * nahi hota, phir bhi.
     *
     * Ab ek hi jagah se dono chalte hain, theek waise hi jaise upar
     * `retireSetupBar` ke comment me chetavni hai: page aur menu alag-alag rule
     * padhein to entry point kabhi dikhta hai kabhi nahi.
     *
     * Score load hone tak `setupScore` null hota hai → percent 0 → false, yaani
     * loading ke dauraan behaviour jaisa tha waisa hi rehta hai.
     */
    const isSetupComplete = (Number(setupScore?.percent) || 0) >= 100;

    // Fetch isSyncSkipContact from dashboard API (not available in agent detail API)
    useEffect(() => {
        if (!userId) return;
        const fetchSyncStatus = async () => {
            try {
                const res = await fetchDashboardDetails(userId, token);
                setIsSyncSkipContact(res?.isSyncSkipContact ?? true);
            } catch (err) {
                console.error("Error fetching sync status:", err);
                setIsSyncSkipContact(true); // default to true (don't show popup) on error
            }
        };
        fetchSyncStatus();
    }, [userId, token]);

    useEffect(() => {
        if (!userId) {
            setCalendarReminderReady(true);
            setCalendarReminderEligible(false);
            return;
        }
        // new
        let cancelled = false;
        const { visitKey, dismissedKey } = getCalendarNudgeKeys(userId);

        const checkCalendarReminder = async () => {
            setCalendarReminderReady(false);

            /*
             * Count DASHBOARD VISITS, not logins. This effect re-runs on every
             * FastAgentDetails mount — first load and each return — so +1 here
             * is exactly one visit. sessionStorage, so it resets on logout.
             */
            let visitCount = Number(sessionStorage.getItem(visitKey) || 0);
            if (!Number.isFinite(visitCount)) visitCount = 0;
            visitCount += 1;
            try {
                sessionStorage.setItem(visitKey, String(visitCount));
            } catch (_e) {
                /* private mode — the nudge just won't reach the threshold */
            }

            try {
                const res = await calenderCheck(userId);
                if (cancelled) return;
                const connected = !!res?.data?.connected;

                if (connected) {
                    // Connected → the nudge is meaningless. Reset both keys so a
                    // later DISCONNECT starts the 3-visit count cleanly rather
                    // than firing immediately on a stale count.
                    sessionStorage.removeItem(visitKey);
                    sessionStorage.removeItem(dismissedKey);
                    setCalendarReminderEligible(false);
                    setShowCalendarReminder(false);
                } else {
                    // Suppress on refresh after user dismissed in this session.
                    const dismissed = sessionStorage.getItem(dismissedKey) === "true";
                    setCalendarReminderEligible(
                        !dismissed && visitCount >= CALENDAR_REMINDER_MIN_VISITS
                    );
                }
            } catch (err) {
                console.error("Calendar reminder check failed:", err);
                if (!cancelled) setCalendarReminderEligible(false);
            } finally {
                if (!cancelled) setCalendarReminderReady(true);
            }
        };

        checkCalendarReminder();
        return () => {
            cancelled = true;
        };
    }, [userId]);

    useEffect(() => {
        if (!calendarReminderReady || !calendarReminderEligible) return;
        if (showCalendarReminder) return;
        if (loading || showDraftView || notificatioView) return;
        if (summaryOpen || isTourOpen || !tourDone) return;
        if (showContactSyncPopup || pushPermissionOpen) return;
        // Don't stack over the Drive popup. (The old branch reads
        // `showDrivePopup || popupGapActive` here — add the `|| popupGapActive`
        // half when the one-popup-at-a-time gap mechanism lands; it does not
        // exist in live yet, so referencing it now would throw.)
        if (showDrivePopup) return;
        if (popupMessage || showAssignPopup || showUpgradeConfirmModal || showUpgradeConfirmModalAssign) return;
        if (showDeleteConfirm || showDeactivateConfirm || showPaygConfirm || showCancelSubConfirm || showDiscardDraftModal) return;

        const timer = setTimeout(() => setShowCalendarReminder(true), 400);
        return () => clearTimeout(timer);
    }, [
        calendarReminderReady,
        calendarReminderEligible,
        showCalendarReminder,
        loading,
        showDraftView,
        notificatioView,
        summaryOpen,
        isTourOpen,
        tourDone,
        showContactSyncPopup,
        pushPermissionOpen,
        showDrivePopup,
        popupMessage,
        showAssignPopup,
        showUpgradeConfirmModal,
        showUpgradeConfirmModalAssign,
        showDeleteConfirm,
        showDeactivateConfirm,
        showPaygConfirm,
        showCancelSubConfirm,
        showDiscardDraftModal,
    ]);

    const dismissCalendarReminder = () => {
        setShowCalendarReminder(false);
        setCalendarReminderEligible(false);
        if (userId) {
            const { dismissedKey } = getCalendarNudgeKeys(userId);
            sessionStorage.setItem(dismissedKey, "true");
        }
    };

    /*
     * Is the floating nudge allowed on screen RIGHT NOW?
     *
     * Separate from `showCalendarReminder` on purpose. That flag is decided once,
     * by the reveal effect, at show TIME — so a popup opening afterwards could
     * not retract a banner that was already up, and the banner (z-index 1200)
     * painted over the test-call modal (Modal3, z-index 111) and anything else
     * lower in the stack.
     *
     * This is evaluated on every render, so the banner hides the moment any
     * overlay appears and comes back when it closes. Independent of z-index —
     * we do not fight the stacking order, we just don't render.
     */
    const calendarNudgeVisible =
        showCalendarReminder &&
        !openCallModal &&
        !summaryOpen &&
        !isTourOpen &&
        !showContactSyncPopup &&
        !pushPermissionOpen &&
        !showDrivePopup &&
        !showAssignPopup &&
        !showUpgradeConfirmModal &&
        !showUpgradeConfirmModalAssign &&
        !showDeleteConfirm &&
        !showDeactivateConfirm &&
        !showPaygConfirm &&
        !showCancelSubConfirm &&
        !showDiscardDraftModal &&
        !popupMessage &&
        !showDraftView &&
        !notificatioView;

    /*
     * Contact-sync popup — RETIRED on this page (2026-08-23).
     *
     * Contact sync now has its own dedicated step inside the onboarding
     * sequence (ScreenCallsIntro -> /contact-sync, reached from the Triage
     * dialog's add-on flow). Popping it AGAIN on the dashboard the first time
     * the user lands here asked the same question twice — the second time with
     * no context and on top of a page they had just arrived at.
     *
     * The effect is kept (rather than deleted) with a single hard gate, so the
     * decision is visible at the point of failure and is one line to revert.
     * `showContactSyncPopup` stays declared: three other popups read it as a
     * "something else is open" suppression input, and with it pinned false
     * those reads are correct no-ops rather than dangling references.
     */
    const SHOW_CONTACT_SYNC_POPUP_ON_DASHBOARD = false;

    useEffect(() => {
        if (!SHOW_CONTACT_SYNC_POPUP_ON_DASHBOARD) {
            setShowContactSyncPopup(false);
            return;
        }
        if (!tourDone) return; // ✅ tour khatam hone ka wait karo
        if (!calendarReminderReady) return;
        if (calendarReminderEligible || showCalendarReminder) return;
        if (pushPermissionOpen) return;
        if (isSyncSkipContact === null) return; // not loaded yet — do nothing
        if (isSyncSkipContact) {
            setShowContactSyncPopup(false);
            return;
        }
        if (agent && agent.agentPlan !== "free") {
            setShowContactSyncPopup(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [agent, isSyncSkipContact, tourDone, calendarReminderReady, calendarReminderEligible, showCalendarReminder, pushPermissionOpen]);

    /*
     * Law Firm gate — Drive is mandatory for Law Firm agents because
     * call recordings / transcripts have to land in the owner's
     * Drive. Check + popup gating runs once the agent record is
     * available AND the agent is on a paid plan.
     *
     * businessType lives on either `agentData.business` or the
     * nested `agentData.agent.business` (legacy shape). Read both
     * defensively so we don't miss the Law Firm signal.
     */
    const businessType =
        agentData?.business?.businessType ||
        agentData?.agent?.business?.businessType ||
        "";
    const isLawFirmAgent = businessType === "Law Firm";

    const agentPlanLower = (agent?.agentPlan || "").toString().trim().toLowerCase();
    const isPaidPlanAgent =
        !!agent?.agentPlan &&
        agentPlanLower !== "" &&
        agentPlanLower !== "free" &&
        agentPlanLower !== "demo";

    /*
     * Upgrade banner SIRF entry-level plans pe — $5 PAYG aur 21-day trial.
     *
     * Starter / Scaler / Growth wale pehle se asli plan pe hain; unhe "upgrade"
     * ka banner dikhana shor hai (aur Growth wale ke liye to upgrade karne ko
     * kuch hai hi nahi). Free / demo pe bhi nahi — unka agla kadam upar wala
     * setup-progress card hai, upgrade nahi.
     *
     * PAYG ke liye `isPaygActive` (jo /pay-as-you-go-status-check se aata hai)
     * pehla source hai: PAYG ek ALAG subscription hai aur uska agentPlan aksar
     * "free" hi rehta hai, to sirf plan key dekhne se wo pakda hi nahi jaata.
     * Plan key sirf backup hai, un records ke liye jahan wo sach me set ho.
     *
     * Trial ke liye plan key kaam nahi karti: 21-day trial Starter plan ka hi
     * Stripe trial hai, to trial ke dauraan agentPlan "starter" hota hai —
     * usse asli paid Starter se alag nahi kar sakte. Stripe ka subscription
     * status hi sahi signal hai ("trialing").
     */
    /*
     * PAYG teen signals se pakadte hain, kyunki teeno alag-alag fail ho sakte
     * hain aur teeno ka matlab ek hi hai — "$5 Pay-As-You-Go chal raha hai":
     *
     *   1. isPaygActive  — /pay-as-you-go-status-check ka jawab. Sabse
     *      authoritative, par API fail ho to false reh jaata hai.
     *   2. is_payg        — agent row ka flag. PAYG activate hote hi
     *      stripeModel ise `agentPlan: 'Pay-As-You-Go'` ke SAATH 1 set karta
     *      hai. Isi subscription ka plan_name Stripe me "PAYG Extra" hota
     *      hai, to "Pay Extra" wala case bhi yahi flag cover karta hai.
     *   3. agentPlan      — sirf backup. DB me value "Pay-As-You-Go" hoti hai
     *      (capital + hyphen), isliye lowercase karke compare karte hain.
     *
     * Teesra akela kaafi nahi hai: cancel/webhook ke raston me agentPlan
     * "free" pe reset ho jaata hai jabki PAYG subscription abhi bhi live hoti
     * hai — aise agent ko banner na dikhta.
     */
    const isPaygAgent =
        isPaygActive ||
        Number(agent?.is_payg) === 1 ||
        ["payg", "pay-as-you-go"].includes(agentPlanLower);
    const isTrialingAgent =
        String(agent?.subscription?.status || "").trim().toLowerCase() ===
        "trialing";

    /*
     * Already on a real paid plan → the PAYG signals above are stale, ignore them.
     *
     * The three PAYG signals exist to FIND PAYG, because a PAYG agent's
     * `agentPlan` is often still "free" (PAYG is a separate subscription). What
     * was missing is the opposite rule: once the plan name IS a paid SMB plan,
     * PAYG cannot also be current, so a leftover flag must not outvote it.
     *
     * It could, and did: upgrading $5 PAYG → $119 Starter updates `agentPlan`
     * (the card correctly read STARTER) but clears NEITHER `is_payg` on the
     * agent row NOR the payg_subscriptions row — every `is_payg: 0` write in the
     * backend sits in the cancellation/teardown path, none in an upgrade path.
     * So `isPaygAgent` stayed true forever and the Upgrade banner never left.
     *
     * NOT a fix for the stale flag itself — `is_payg` also gates whether calls
     * are cut off at the minute limit, so an upgraded agent may still be treated
     * as uncapped. That is a separate backend item; this only stops the wrong
     * data reaching this banner.
     */
    const isPaidSmbPlan = ["starter", "scaler", "growth"].includes(agentPlanLower);

    /*
     * Order matters. The 21-day trial IS a Starter plan — `agentPlan` reads
     * "starter" for its whole duration — so `isPaidSmbPlan` is true for trials
     * too. Trials must still see the banner, which is why `isTrialingAgent`
     * (Stripe's own status, the only signal that separates a trial Starter from
     * a paid one) is evaluated FIRST and is not subject to the plan gate.
     *
     *   $5 PAYG                         → shows
     *   21-day trial (status trialing)  → shows
     *   paid Starter / Scaler / Growth  → hidden
     *   free / demo                     → hidden
     */
    const showUpgradeBanner = isTrialingAgent || (isPaygAgent && !isPaidSmbPlan);

    useEffect(() => {
        if (!agent?.agent_id || !userId) return;
        if (!isLawFirmAgent || !isPaidPlanAgent) {
            setDriveConnected(null);
            return;
        }
        if (isTeamMember) {
            // Drive connection is the owner's responsibility — never
            // prompt a team member to connect.
            return;
        }

        let cancelled = false;
        (async () => {
            try {
                const res = await axios.post(
                    `${API_BASE_URL}/is-drive-connected`,
                    { userId, agentId: agent.agent_id }
                );
                if (cancelled) return;
                const connected = !!res.data?.connected;
                setDriveConnected(connected);
                if (!connected) {
                    /*
                     * Setup Summary owns the screen first.
                     *
                     * This effect gated on the intro tour but NOT on the
                     * summary, so a first-visit Law-Firm agent got BOTH popups
                     * stacked. Bail while the summary is up — placed here, AFTER
                     * setDriveConnected (so `driveLocked` still updates and the
                     * lock overlays stay correct) but BEFORE the session key is
                     * marked, so bailing does not consume the "already shown"
                     * flag and lose the popup entirely.
                     *
                     * `summaryOpen` is in the deps below, so the moment the user
                     * taps Okay — or the summary is suppressed — this re-runs and
                     * opens Drive then. The tour cannot bury it either: the tour
                     * effect re-runs on `showDrivePopup` and cancels its pending
                     * start timer when this opens.
                     */
                    if (summaryOpen) return;

                    const popupSessionKey = getDrivePopupSessionKey(userId, agent.agent_id);
                    const alreadyShown =
                        popupSessionKey && sessionStorage.getItem(popupSessionKey) === "true";

                    if (!alreadyShown) {
                        if (popupSessionKey) {
                            sessionStorage.setItem(popupSessionKey, "true");
                        }
                        setShowDrivePopup(true);
                    }
                }
            } catch (err) {
                if (!cancelled) {
                    console.warn(
                        "[FastAgentDetails] drive status check failed:",
                        err?.message || err
                    );
                    setDriveConnected(false);
                }
            }
        })();

        return () => {
            cancelled = true;
        };
        // Re-check every time the user navigates back to this page or
        // the agent context flips. `summaryOpen` is a dependency so the Drive
        // popup opens the moment the Setup Summary is dismissed — without it
        // the bail above would be permanent for that visit.
    }, [agent?.agent_id, userId, isLawFirmAgent, isPaidPlanAgent, isTeamMember, summaryOpen]);

    // Post-OAuth return — Drive callback sends users to
    // /fast-agent-detail?drive=connected. Flip state + strip the
    // query so a refresh doesn't re-trigger.
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("drive") !== "connected") return;
        // Google Drive connected (web). The Drive OAuth callback only lands on
        // ?drive=connected after the backend has stored the Drive token: the
        // same "fire on the OAuth-success return" rule as calendar_sync_completed.
        // Native-app connects never pass through this URL; they are recorded in
        // utils/nativeDrive.js.
        trackEvent("google_drive_connected", { source: "fast_agent_detail" });
        setDriveConnected(true);
        setShowDrivePopup(false);
        setPopupType("success");
        setPopupMessage("Drive connected. Your agent can now save call recordings.");
        navigate(location.pathname, { replace: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    // Calendar connected (web) from every entry point that lands here: the
    // Dashboard and ConnectCalenderV2 send no returnTo, so the calendar
    // callback defaults to /fast-agent-detail (googleAuth.js), and the Setup
    // Ready card returns here explicitly. The callback appends
    // ?googleAuth=success only after the tokens are stored. Nothing else on
    // this page reads the param, so it is left untouched; the once-per-user
    // guard in trackEvent stops a refresh from counting it twice.
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get("googleAuth") !== "success") return;
        trackEvent("calendar_sync_completed", { source: "fast_agent_detail" });
        // The Dashboard cards read calendarId from their cached agent list —
        // make it refetch so the Google badge matches this agent's new state.
        setHasFetched(false);
    }, [location.search, setHasFetched]);

    const startTour = () => {
        if (tourStartedRef.current || typeof introJs !== "function") return;

        // Safety guard: never launch the tour if, during its 1.5s delay,
        // the user clicked something and is no longer on a clean
        // dashboard — otherwise intro.js paints its overlay over the
        // wrong screen. Abort when we've left /fast-agent-detail OR the
        // first tour target isn't in the DOM (page navigated / changed).
        if (typeof window !== "undefined") {
            if (window.location.pathname !== "/fast-agent-detail") return;
            if (!document.getElementById("tour-edit-agent")) return;
        }

        tourStartedRef.current = true;

        const intro = introJs();
        // Expose the instance so the route-change watcher can call
        // intro.exit() if the user navigates away mid-tour.
        tourIntroRef.current = intro;
        const allSteps = [
            {
                element: "#tour-edit-agent",
                title: "Manage Agent",
                intro: "Update your agent's name, avatar, and core settings here to keep them fresh and accurate.",
                position: "bottom"
            },
            {
                element: "#tour-call-routing",
                title: "Call Triage",
                intro: "Ensure every call goes where it belongs! Set up logic to forward calls to the right department or person.",
                position: "top"
            },
            {
                element: "#tour-connect-calendar",
                title: "Connect Calendar",
                intro: "Want your receptionist to book appointments? Connect your calendar here to enable seamless scheduling for your business.",
                position: "top"
            },
            {
                element: "#tour-widget-install",
                title: "Website Integration",
                intro: "Extend your agent's reach! You can integrate it directly into your website to handle live calls and inquiries.",
                position: "top"
            },
            {
                element: "#tour-public-agent-url",
                title: "Your Public Agent Page",
                intro:
                    "This is your agent’s public gateway. Share it on your socials or website to give customers an experience that’s like Calendly on steroids—without actually needing Calendly. Instead of just picking a time, visitors can chat or call your AI receptionist directly to get answers and book instantly. It’s scheduling evolved.",
                position: "top"
            },
            {
                element: "#tour-total-calls",
                title: "Call History",
                intro: "This is where you can see the total number of calls your agent has handled for you.",
                position: "top"
            },
            // {
            //     element: "#tour-footer-home",
            //     title: "Home",
            //     intro: "Jump back to your main dashboard anytime to see high-level stats and manage all your agents in one central place.",
            //     position: "top"
            // },
            {
                element: "#tour-footer-calendar",
                title: "Bookings",
                intro: "View and manage all the appointments scheduled by your AI Receptionist in one place.",
                position: "top"
            },
            {
                element: "#tour-footer-more",
                title: "More Settings",
                intro:
                    "Open this for all your agent-level settings — Test, Call Setting, " +
                    "Calendar, Schedule, Knowledge Base, Voice, Widget, and Business Details.",
                position: "top"
            },
            {
                element: "#tour-footer-contacts",
                title: "Contacts & Call Routing",
                intro: "Manage your contacts here. Set up VIP transfers, auto-block spam callers, and control how your agent greets saved callers.",
                position: "top"
            }
        ];

        // Only include steps for elements that are actually in the DOM
        const validSteps = allSteps.filter(step => document.querySelector(step.element));

        if (validSteps.length === 0) {
            tourStartedRef.current = false;
            return;
        }

        /*
         * Viewport-aware tour strategy — two completely different
         * scroll/refresh recipes because each viewport size has its
         * own set of bugs:
         *
         *   - DESKTOP (>=768px): intro.js's native scroll worked
         *     correctly here (helperLayer rect computed AFTER scroll
         *     finishes). The previous manual scrollIntoView caused
         *     desktop highlights to land on the wrong element. So:
         *     scrollToElement:true + scrollTo:"tooltip" + padding:80.
         *
         *   - MOBILE (<768px): intro.js's native scroll (tested with
         *     both scrollTo:"tooltip" and "element") leaves the
         *     highlight on the WRONG element (e.g. "Call Routing"
         *     when tooltip says "Call Triage"). The legacy manual
         *     scroll-then-refresh recipe ran fine on mobile — short
         *     viewport, smooth scroll completes inside the refresh
         *     window. So we revert to that recipe for mobile only:
         *     scrollToElement:false + manual scrollIntoView in
         *     onafterchange + timed refresh.
         *
         * Detected once at startTour so the user can't accidentally
         * mid-tour resize their browser into the other regime and
         * confuse the math.
         */
        const isMobileViewport =
            typeof window !== "undefined" && window.innerWidth < 768;
        intro.setOptions({
            steps: validSteps,
            tooltipClass: styles.customTourTooltip,
            highlightClass: styles.tourHighlight,
            nextLabel: "Next →",
            prevLabel: "← Back",
            skipLabel: "Skip Tour",
            doneLabel: "Finish",
            showProgress: true,
            showButtons: true,
            showBullets: false,
            exitOnOverlayClick: false,
            // Mobile: manual scroll handled in onafterchange below.
            // Desktop: native scroll with tooltip-anchored padding.
            scrollToElement: !isMobileViewport,
            ...(isMobileViewport
                ? {}
                : { scrollTo: "tooltip", scrollPadding: 80 }),
            disableInteraction: true,
            fixElementPosition: true,
            overlayOpacity: 0.35
        });

        const lockScroll = (e) => {
            // Lamba tooltip text mobile pe apne andar scroll hota hai (CSS
            // max-height) — uske andar ka touch/wheel mat roko, baaki page lock.
            if (e.target?.closest?.(".introjs-tooltiptext")) return;
            if (e.cancelable) e.preventDefault();
        };

        /*
         * Real phone pe highlight galat jagah (text sahi, box galat).
         *
         * DevTools mobile view me data turant aata hai; real phone pe slow
         * network ki wajah se "Great Progress" card / baaki cards tour shuru
         * hone KE BAAD render hote hain aur content neeche khisak jaata hai.
         * Upar ke fixed refresh timers (RAF/150ms/300ms) us shift se pehle hi
         * chal chuke hote the, to helper layer purani jagah pe atka rehta tha.
         * Address bar chhupne/dikhne se viewport bhi badalta hai — uspe bhi
         * koi refresh nahi tha.
         *
         * Fix: tour chalte waqt page (#root) ka size badle, ya viewport
         * resize/scroll ho, to agle frame pe intro.refresh(). rAF se ek frame
         * me ek hi refresh hota hai.
         */
        let refreshFrame = 0;
        const scheduleRefresh = () => {
            if (refreshFrame) return;
            refreshFrame = requestAnimationFrame(() => {
                refreshFrame = 0;
                try { intro.refresh(); } catch (_e) { }
            });
        };
        let layoutObserver = null;
        const startLayoutWatch = () => {
            const root = document.getElementById("root");
            if (root && typeof ResizeObserver !== "undefined") {
                layoutObserver = new ResizeObserver(scheduleRefresh);
                layoutObserver.observe(root);
            }
            window.addEventListener("resize", scheduleRefresh);
            window.visualViewport?.addEventListener("resize", scheduleRefresh);
            window.visualViewport?.addEventListener("scroll", scheduleRefresh);
        };
        const stopLayoutWatch = () => {
            layoutObserver?.disconnect();
            layoutObserver = null;
            if (refreshFrame) cancelAnimationFrame(refreshFrame);
            refreshFrame = 0;
            window.removeEventListener("resize", scheduleRefresh);
            window.visualViewport?.removeEventListener("resize", scheduleRefresh);
            window.visualViewport?.removeEventListener("scroll", scheduleRefresh);
        };

        const cleanup = async () => {
            stopLayoutWatch();
            window.removeEventListener("wheel", lockScroll);
            window.removeEventListener("touchmove", lockScroll);
            document.body.classList.remove("tour-open");
            setIsTourOpen(false);
            setTourDone(true); // ✅ tour khatam — ab ContactSyncPopup show ho sakta hai
            // Drop the intro instance ref — there's nothing left to
            // exit and we don't want the route watcher firing exit on
            // a dead instance after a clean finish.
            tourIntroRef.current = null;
            try {
                await markDashboardTourSeen(userId);
            } catch (err) {
                console.error("Failed to mark tour as seen:", err);
            }
        };

        intro.onstart(() => {
            window.addEventListener("wheel", lockScroll, { passive: false });
            window.addEventListener("touchmove", lockScroll, { passive: false });
            document.body.classList.add("tour-open");
            setIsTourOpen(true);
            startLayoutWatch();
        });

        intro.oncomplete(cleanup);
        intro.onexit(cleanup);

        intro.onafterchange((targetElement) => {
            if (!targetElement) return;
            if (isMobileViewport) {
                /*
                 * MOBILE recipe — manual scroll + refresh, with the scroll
                 * made INSTANT.
                 *
                 * It used to be `behavior: "smooth"` followed by a fixed 300ms
                 * refresh, on the assumption that a short viewport always
                 * finishes gliding inside that window. It does not: smooth-scroll
                 * duration is decided by the browser from the distance travelled,
                 * the device and the current frame rate — it is not something a
                 * timeout can be tuned against.
                 *
                 * When the glide was still running at 300ms, intro.refresh()
                 * measured the target mid-flight and painted the highlight where
                 * the NEXT element happened to be sitting, while the tooltip text
                 * (which comes from the step index, not the geometry) stayed
                 * correct. That is the "right text, wrong box" report — worst on
                 * the longest jump, Total Calls → footer bar.
                 *
                 * `behavior: "auto"` lands the scroll synchronously, so by the
                 * next animation frame the position is final and the measurement
                 * cannot be stale. This removes the race rather than re-tuning it;
                 * the visible cost is a snap between steps instead of a glide.
                 */
                try {
                    targetElement.scrollIntoView({
                        behavior: "auto",
                        block: "center",
                        inline: "nearest",
                    });
                } catch (_e) { }
                // Next frame: position is already final, this is the real measure.
                requestAnimationFrame(() => {
                    try { intro.refresh(); } catch (_e) { }
                });
                // Backstop only — covers a late layout shift (font swap, image
                // decode, a lock overlay resolving) rather than the scroll itself.
                setTimeout(() => {
                    try { intro.refresh(); } catch (_e) { }
                }, 150);
                // Real phone: scroll ke baad address bar chhupta/dikhta hai
                // (~200-400ms animation) — viewport aur element ki jagah
                // badal jaati hai. Upar ke refresh us se pehle chal chuke hote
                // the, box purani jagah (jaise Total Calls row) pe reh jaata.
                // Animation settle hone ke baad do backstop refresh.
                setTimeout(() => {
                    try { intro.refresh(); } catch (_e) { }
                }, 350);
                setTimeout(() => {
                    try { intro.refresh(); } catch (_e) { }
                }, 700);
                return;
            }
            /*
             * DESKTOP recipe — native scroll already happened (set
             * by scrollToElement:true). Just run a refresh schedule
             * so the helperLayer rect re-settles if a font swap or
             * late image push shifts the layout.
             *   - RAF (~16ms): catches first paint after native scroll
             *   - 200ms: covers font swaps + async image decodes
             *   - 500ms: hard backstop for slow networks
             */
            requestAnimationFrame(() => {
                try { intro.refresh(); } catch (_e) { }
            });
            setTimeout(() => {
                try { intro.refresh(); } catch (_e) { }
            }, 200);
            setTimeout(() => {
                try { intro.refresh(); } catch (_e) { }
            }, 500);
        });

        tourLaunchTimerRef.current = setTimeout(() => {
             if (document.querySelector('[class*="bottommodaloverlay"]')) {
                tourStartedRef.current = false; 
                const waitModalClose = setInterval(() => {
                    if (!document.querySelector('[class*="bottommodaloverlay"]')) {
                        clearInterval(waitModalClose);
                        startTour(); 
                    }
                }, 500);
                return;
            }
            intro.start();
            setTimeout(() => intro.refresh(), 300);
        }, 2500);
    };

    useEffect(() => {
        window.scrollTo(0, 0); // Reset on mount
        // ── Setup-summary dialog gate ────────────────────────────
        // While the post-onboarding "Sophia is Live" dialog is on
        // screen, the dashboard intro tour MUST wait. Otherwise
        // intro.js paints its overlay over the dialog and the user
        // sees both at once. The effect re-runs when summaryOpen
        // flips to false (after Okay tap), at which point the tour
        // eligibility check proceeds normally.
        if (summaryOpen) return;
        /*
         * ── Connect-Drive popup gate ─────────────────────────────
         * Same reasoning, different popup. Once the summary is
         * dismissed, the Drive auto-open effect and this one BOTH
         * re-run: Drive opens immediately, the tour opens 1.5s later
         * and intro.js paints straight over it.
         *
         * Gating here (with `showDrivePopup` in the deps below) also
         * cancels an ALREADY-PENDING start: a dep change runs this
         * effect's cleanup, which clears the pending 1.5s timer, and
         * then this early return stops a new one being scheduled. So
         * a Drive popup that opens mid-countdown kills the countdown
         * rather than racing it.
         *
         * When Drive is dismissed the effect re-runs once more and
         * the tour proceeds normally.
         */
        if (showDrivePopup) return;
        /*
         * Pending-start timer tracking — fixes the "two tours
         * overlapping" race the user reported.
         *
         * Root cause: checkTour() schedules `setTimeout(startTour, 1500)`.
         * If the effect's deps change DURING that 1.5s window (e.g.
         * agentData refresh flips hasVoipNumbers from false→true→true
         * after a transient re-fetch, or the route watcher re-runs),
         * a SECOND setTimeout is scheduled. Both fire, and even though
         * tourStartedRef gates double-starts INSIDE startTour, React
         * Strict Mode dev re-mount discards the ref between the two
         * invocations — leaving the first intro instance painted in
         * the DOM (it's never exited because the cleanup callback is
         * what nulls it) while a new instance starts on top.
         *
         * Fix: track the pending timer ID in a closure, cancel it in
         * the effect's cleanup so an unmount/dep-change kills the
         * scheduled second start before it can fire. Also exit the
         * live intro instance on cleanup so a remount can't paint a
         * second tooltip alongside the first.
         */
        let pendingStartTimer = null;
        // One-shot click listener that pre-empts the tour if the user
        // engages with the page during the pre-tour delay (see below).
        let interactionListener = null;
        // Guards the async gap below: getDashboardTourStatus is awaited,
        // and if the user clicks a button + navigates away DURING that
        // await, the cleanup runs BEFORE the post-await `setTimeout` is
        // assigned — so that timer would escape cleanup and fire
        // startTour on the wrong screen. We flip this in cleanup and
        // bail out after the await so no stray timer is ever scheduled.
        let cancelled = false;
        const checkTour = async () => {
            // Number gate removed — tour ab har user ke liye chalega, chahe
            // VOIP number ho ya na ho.
            if (!userId || tourStartedRef.current) return;
            try {
                const resp = await getDashboardTourStatus(userId);
                if (cancelled) return; // unmounted/navigated during await
                const d = resp?.data ?? resp;

                const isTruthy = (v) => v === 1 || v === "1" || v === true || v === "true";
                let shouldShow;

                if (typeof d?.shouldShow === "boolean") {
                    shouldShow = d.shouldShow;
                } else {
                    const eligible = isTruthy(d?.dashboardTourEligible);
                    const seen = isTruthy(d?.dashboardTourSeen);
                    shouldShow = eligible && !seen;
                }

                if (shouldShow && !tourStartedRef.current) {
                    // If the user clicks/taps ANYTHING during the pre-tour
                    // delay, they're already engaging with the page — cancel
                    // the pending tour so it never launches over their action
                    // or follows them to another screen. Capture phase so we
                    // catch the click before a button's own handler navigates
                    // away. Covers BOTH route changes and in-page surfaces
                    // (modals/sheets) that the pathname-based guard misses.
                    const onInteract = () => {
                        if (pendingStartTimer) {
                            clearTimeout(pendingStartTimer);
                            pendingStartTimer = null;
                        }
                        document.removeEventListener("click", onInteract, true);
                        interactionListener = null;
                        setTourDone(true); // unblock downstream nudges
                    };
                    interactionListener = onInteract;
                    document.addEventListener("click", onInteract, true);

                    // Small delay to ensure DOM elements are rendered
                    pendingStartTimer = setTimeout(() => {
                        // Tour is launching — stop listening for the cancel
                        // click so the user's tour interactions don't kill it.
                        document.removeEventListener("click", onInteract, true);
                        interactionListener = null;
                        startTour();
                    }, 1500);
                } else {
                    setTourDone(true); // ✅ tour needed nahi — sync popup allow karo
                }
            } catch (err) {
                console.error("Tour status check failed:", err);
            }
        };
        checkTour();
        return () => {
            // Stop a tour-status check that's still awaiting from
            // scheduling its timer after we've already torn down.
            cancelled = true;
            // Cancel a still-pending startTour. If the timer already
            // fired, this is a no-op.
            if (pendingStartTimer) {
                clearTimeout(pendingStartTimer);
                pendingStartTimer = null;
            }
            // Cancel a still-pending intro.start() timer inside startTour
            if (tourLaunchTimerRef.current) {
                clearTimeout(tourLaunchTimerRef.current);
                tourLaunchTimerRef.current = null;
            }
            // Detach the pre-tour interaction listener if still attached.
            if (interactionListener) {
                document.removeEventListener("click", interactionListener, true);
                interactionListener = null;
            }
            // Tear down any live intro instance on unmount/effect
            // re-run so a remount can't render a second tooltip on
            // top of the existing one.
            const intro = tourIntroRef.current;
            if (intro) {
                try { intro.exit(true); } catch (_e) { }
                tourIntroRef.current = null;
            }
        };
        // `showDrivePopup` is a dependency so this effect re-runs when the Drive
        // popup opens — its cleanup cancels any pending 1.5s tour start, and the
        // gate above stops a new one being scheduled. Without the dep the gate
        // would only be evaluated on mount and a mid-countdown Drive popup would
        // still get painted over.
    }, [userId, summaryOpen, showDrivePopup]);

    /*
     * Tour route-guard.
     *
     * The dashboard intro tour is scoped to /fast-agent-detail — its
     * step element selectors (`#tour-edit-agent`, `#tour-footer-more`,
     * etc.) only exist on this page. If the user navigates away while
     * a tour is running (e.g. by tapping a CTA inside a tooltip, using
     * the browser back button, or clicking a deep-link in a
     * notification), intro.js keeps its overlay painted over the new
     * page and breaks the next screen's interactions.
     *
     * Watching location.pathname here: whenever the path moves AWAY
     * from /fast-agent-detail with a live tour instance, we call
     * intro.exit(true) — `true` skips the "are you sure?" prompt and
     * triggers our cleanup() (which removes scroll locks, clears the
     * body class, and marks the tour as seen so we don't try to
     * re-launch it later).
     */
    useEffect(() => {
        if (location.pathname === "/fast-agent-detail") return;
        if (tourLaunchTimerRef.current) {
            clearTimeout(tourLaunchTimerRef.current);
            tourLaunchTimerRef.current = null;
        }
        const intro = tourIntroRef.current;
        if (!intro) return;
        try {
            intro.exit(true);
        } catch (_e) {
            /* exit can throw if intro was already torn down */
        }
        tourIntroRef.current = null;
    }, [location.pathname]);

    /*
     * Tour overlay vs in-page surfaces.
     *
     * The Notifications panel renders INSIDE /fast-agent-detail (it's
     * a `notificatioView` state flip, not a route change) so the
     * pathname-based exit above doesn't catch it. Without this gate
     * intro.js keeps painting its highlight on whatever step was
     * active while the notifications list takes over the viewport —
     * looks broken on the user side (highlight pointing at empty
     * space behind the panel). Mirror the route-exit logic for the
     * notification toggle: when it flips ON with a live tour, kill
     * the tour. The user can re-trigger it via the dashboard hint
     * later if needed.
     */
    useEffect(() => {
        if (!notificatioView) return;
        const intro = tourIntroRef.current;
        if (!intro) return;
        try {
            intro.exit(true);
        } catch (_e) { }
        tourIntroRef.current = null;
    }, [notificatioView]);

    // ── Setup-summary fetch + confetti ───────────────────────────
    // Once the agent is loaded AND we know the dialog should open,
    // fetch the per-row status (calendar / spam / triage rules) in
    // parallel and assemble the rows. Confetti fires exactly once
    // per dialog open. All fetches are best-effort — a failure on
    // any one falls back to "pending" so the user always sees the
    // setup-now affordance for that row.
    useEffect(() => {
        if (!summaryOpen) return;
        if (!agent?.agent_id) return; // wait for agent to load
        if (summaryItems !== null) return; // already built
        let cancelled = false;

        // One-shot confetti — three quick bursts mirror GoLiveCelebration.
        if (!confettiFiredRef.current) {
            confettiFiredRef.current = true;
            const fire = (delay, opts) =>
                setTimeout(() => {
                    try {
                        confetti({
                            particleCount: 90,
                            spread: 70,
                            origin: { y: 0.4 },
                            colors: ["#6524EB", "#16A34A", "#F59E0B", "#fff"],
                            ...opts,
                        });
                    } catch (_e) {
                        /* canvas-confetti can fail in iframes — non-fatal */
                    }
                }, delay);
            fire(50, {});
            fire(280, { angle: 60, origin: { x: 0, y: 0.5 } });
            fire(560, { angle: 120, origin: { x: 1, y: 0.5 } });
        }

        (async () => {
            const agentId = agent.agent_id;

            // Parallel fetch — all best-effort. Each returns a sane
            // default on failure so the UI never blocks on a single
            // slow / failing endpoint.
            const [calRes, spamRes, scoreRes, triageRes] = await Promise.all([
                userId ? calenderCheck(userId).catch(() => null) : Promise.resolve(null),
                getAgentSpamSettings(agentId).catch(() => ({})),
                fetchSetupScore(agentId).catch(() => null),
                getAgentTransferNumbers(agentId).catch(() => null),
            ]);
            if (cancelled) return;
            // Note: this useEffect only fires when summaryOpen — the
            // SetupScoreCard rendered above the agent card has its own
            // independent fetch further below so it doesn't depend on
            // the user opening the summary dialog.

            // ── Per-row status derivation ──────────────────────
            /*
             * voip_numbers can arrive in any of:
             *   - JSON string of array of strings: '["+1234567890"]'
             *   - Already-parsed array of strings: ["+1234567890"]
             *   - Array of objects (legacy): [{phoneNumber: "..."}] / [{number: "..."}]
             *   - Bare string: "+1234567890"
             *
             * Old code only handled object array (v[0]?.phoneNumber) so
             * the common string-array case fell through to "" → row
             * incorrectly rendered Pending. We now mirror GoLiveCelebration's
             * VOIP_PARSE + formatPhoneDisplay approach: pick first item,
             * pull a string out regardless of wrapper, then format.
             */
            const extractFirstNumber = (firstItem) => {
                if (!firstItem) return "";
                if (typeof firstItem === "string") return firstItem.trim();
                if (typeof firstItem === "object") {
                    return (
                        firstItem.phoneNumber ||
                        firstItem.number ||
                        firstItem.voipNumber ||
                        firstItem.phone_number ||
                        ""
                    );
                }
                return "";
            };
            const rawPhone = (() => {
                const v = agent?.voip_numbers;
                if (!v) return "";
                if (Array.isArray(v)) return extractFirstNumber(v[0]);
                if (typeof v === "string") {
                    const trimmed = v.trim();
                    if (trimmed.startsWith("[")) {
                        try {
                            const parsed = JSON.parse(trimmed);
                            if (Array.isArray(parsed)) {
                                return extractFirstNumber(parsed[0]);
                            }
                            return extractFirstNumber(parsed);
                        } catch {
                            return trimmed;
                        }
                    }
                    return trimmed;
                }
                if (typeof v === "object") return extractFirstNumber(v);
                return "";
            })();
            // Pretty-format for display — "+1 234-567-8901" style.
            // Falls back to raw string if too short to format.
            const formatPhone = (num) => {
                const cleaned = String(num || "").replace(/\D/g, "");
                if (cleaned.length < 10) return String(num || "");
                const last10 = cleaned.slice(-10);
                const cc =
                    cleaned.length > 10
                        ? cleaned.slice(0, cleaned.length - 10)
                        : "1";
                return `+${cc} ${last10.slice(0, 3)}-${last10.slice(3, 6)}-${last10.slice(6)}`;
            };
            const phoneNumber = rawPhone ? formatPhone(rawPhone) : "";
            const hasNumber = !!rawPhone;

            const calendarConnected = !!calRes?.data?.connected;
            const spamEnabled = !!spamRes?.autoBlacklistEnabled;
            const triageDone = !!scoreRes?.steps?.triageRulesSaved?.done;
            const triageRules = Array.isArray(triageRes)
                ? triageRes
                : (triageRes?.data || []);
            const triageLabel = triageRules
                .map((r) => r?.condition)
                .filter(Boolean)
                .join(" | ");

            // Stroke colour matches the icon palette in the Figma —
            // muted purple (#6524EB) on a soft purple background.
            const strokeColor = "#6524EB";
            const items = [
                {
                    key: "businessNumber",
                    label: "Business Number",
                    icon: (
                        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M0.705729 1.35438C1.24668 0.712557 2.02791 0.300079 2.81684 0.0469567C3.31474 -0.113018 3.81522 0.154891 4.04715 0.604614L5.10848 2.66117C5.68155 3.77199 4.70244 4.00071 4.01824 5.02035C3.86662 5.2465 3.67645 5.59472 3.83513 5.86391C5.20677 8.19349 6.80642 9.7933 9.13595 11.1648C9.61971 11.4494 10.4414 10.6252 10.7504 10.3148C11.2882 9.77388 11.6184 9.51947 12.3392 9.89146L14.3957 10.9528C14.8455 11.1847 15.1134 11.6852 14.9534 12.1831C14.4446 13.7675 13.3897 15.0216 11.6145 14.9997C7.0923 14.9445 0.0555198 7.90754 0.00025849 3.38588C-0.00873595 2.63033 0.216814 1.9346 0.705729 1.35438ZM7.95253 0.947686C11.3215 0.947686 14.052 3.67824 14.052 7.04728C14.052 7.67112 14.9996 7.67112 14.9996 7.04728C14.9996 3.15522 11.8445 0 7.95248 0C7.32865 0 7.3287 0.947686 7.95253 0.947686ZM7.95253 5.54911C8.78 5.54911 9.45074 6.21984 9.45074 7.04735C9.45074 7.67119 10.3984 7.67119 10.3984 7.04735C10.3984 5.69689 9.30362 4.60149 7.95255 4.60149C7.32872 4.60149 7.3287 5.54911 7.95253 5.54911ZM7.95253 3.24848C10.0508 3.24848 11.7514 4.94912 11.7514 7.04745C11.7514 7.67129 12.699 7.67129 12.699 7.04745C12.699 4.4261 10.5738 2.30096 7.95265 2.30096C7.32882 2.30096 7.3287 3.24848 7.95253 3.24848Z" fill={strokeColor} />
                        </svg>
                    ),
                    status: hasNumber ? "done" : "pending",
                    value: hasNumber ? phoneNumber : "Pending",
                    onAction: () => openSummaryFeature("/assign-number"),
                },
                {
                    key: "aiReceptionist",
                    label: "AI Receptionist",
                    icon: (
                        <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.9809 18.5603L15.1811 16.2635C15.1091 16.0094 14.9867 15.7733 14.8215 15.57C14.6564 15.3667 14.452 15.2007 14.2213 15.0823L9.60131 13.0578L9.48293 12.2506C10.0901 11.9334 10.6251 11.4882 11.0529 10.9442C11.4808 10.4003 11.7918 9.76986 11.9657 9.09415H12.8935C13.1246 9.09071 13.3451 8.99412 13.5074 8.82528C13.6696 8.65643 13.7606 8.42889 13.7605 8.19184C13.7605 7.5356 13.7605 6.55125 13.7605 5.89502C13.4406 -1.96008 2.5626 -1.96336 2.24266 5.87533C2.24266 6.27564 2.24266 7.1878 2.24266 7.57826V8.18199C2.24266 8.4213 2.33536 8.65081 2.50036 8.82003C2.66536 8.98925 2.88915 9.08431 3.1225 9.08431H4.05033C4.22421 9.76002 4.53525 10.3905 4.96308 10.9344C5.39092 11.4783 5.92592 11.9235 6.53307 12.2408L6.4019 13.0578L1.77874 15.0823C1.54801 15.2007 1.34364 15.3667 1.17846 15.57C1.01329 15.7733 0.890878 16.0094 0.818919 16.2635L0.0190658 18.5603C0.00150697 18.6101 -0.00403767 18.6635 0.0029056 18.716C0.00984888 18.7685 0.0290736 18.8185 0.058938 18.8617C0.0888023 18.9049 0.128419 18.94 0.174404 18.9641C0.220389 18.9882 0.271376 19.0005 0.32301 19H15.6802C15.7316 19 15.7822 18.9873 15.8277 18.9629C15.8733 18.9386 15.9125 18.9034 15.942 18.8603C15.9715 18.8172 15.9904 18.7674 15.9972 18.7152C16.004 18.663 15.9984 18.6098 15.9809 18.5603ZM3.90635 6.09189C3.56156 6.07807 3.21624 6.08904 2.87294 6.1247V5.87533C3.15449 -1.09385 12.8487 -1.09057 13.1207 5.87533V6.10502C13.0439 6.08533 12.0873 6.0722 12.0873 6.0722C11.6617 3.74914 9.98844 2.00356 8.0016 2.00356C6.01477 2.00356 4.34147 3.74914 3.90635 6.08205V6.09189ZM8.74707 14.0323C8.60499 14.1888 8.41829 14.2952 8.21368 14.3364C8.00906 14.3775 7.797 14.3512 7.60782 14.2613C7.41864 14.1714 7.26202 14.0225 7.16036 13.8358C7.05869 13.6491 7.01719 13.4342 7.04178 13.2219L7.15376 12.477C7.71849 12.6247 8.31031 12.6247 8.87504 12.477C8.92623 12.9561 9.1342 13.6386 8.74707 14.0323ZM9.03501 11.7355C6.81782 12.5919 4.82138 10.5576 4.50464 8.22465C4.92228 8.43659 5.38637 8.53382 5.8516 8.50683C7.4513 8.23449 8.0016 7.61763 8.47512 7.07296C8.64471 6.8601 8.8392 6.66945 9.05421 6.50532C9.14536 6.44322 9.2552 6.41669 9.36379 6.43054C9.47239 6.44439 9.57255 6.49769 9.6461 6.58078C10.1948 7.07778 10.8539 7.42927 11.5657 7.60451C11.521 9.3304 10.4747 11.2138 9.03501 11.7355Z" fill={strokeColor} />
                        </svg>
                    ),
                    status: agent?.agentName ? "done" : "pending",
                    value: agent?.agentName ? (
                        <>
                            <span style={{ color: "#6524EB" }}>{agent.agentName}</span>
                            <span style={{ color: "#24252c", fontWeight: 700 }}>
                                {" "}- {agent.agentRole || "General Receptionist"}
                            </span>
                        </>
                    ) : "Pending",
                    onAction: () => openSummaryFeature("/edit-agent"),
                },
                {
                    key: "calendar",
                    label: "Calendar",
                    icon: (
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0 2.67668V14.1514C0 14.909 0.686431 15.5227 1.5338 15.5227H14.3685C15.2159 15.5227 15.9023 14.909 15.9023 14.1514V2.67668C15.9023 1.91909 15.2159 1.3054 14.3685 1.3054H12.7067V0.60676C12.7067 0.272175 12.4023 0 12.028 0C11.6538 0 11.3494 0.272175 11.3494 0.60676V1.3054H4.55294V0.60676C4.55294 0.272175 4.2485 0 3.87426 0C3.50002 0 3.19559 0.272175 3.19559 0.60676V1.3054H1.5338C0.686431 1.3054 0 1.91909 0 2.67668ZM11.3494 2.45998V3.37532C11.3494 3.7099 11.6538 3.98208 12.028 3.98208C12.4023 3.98208 12.7067 3.7099 12.7067 3.37532V2.45998C13.0383 2.65761 13.2574 2.99393 13.2574 3.37532C13.2574 3.98208 12.7067 4.47442 12.028 4.47442C11.3494 4.47442 10.7987 3.98208 10.7987 3.37532C10.7987 2.99219 11.0178 2.65587 11.3494 2.45998ZM3.19559 2.45998V3.37532C3.19559 3.7099 3.50002 3.98208 3.87426 3.98208C4.2485 3.98208 4.55294 3.7099 4.55294 3.37532V2.45998C4.88452 2.65761 5.10363 2.99393 5.10363 3.37532C5.10363 3.98208 4.55294 4.47442 3.87426 4.47442C3.19559 4.47442 2.64489 3.98208 2.64489 3.37532C2.64489 2.99219 2.86401 2.65587 3.19559 2.45998ZM2.14073 5.50418H13.7635C14.1862 5.50418 14.5294 5.81103 14.5294 6.18895V13.607C14.5294 13.9849 14.1862 14.2918 13.7635 14.2918H2.13879C1.71608 14.2918 1.37286 13.9849 1.37286 13.607V6.19068C1.37286 5.81276 1.71608 5.50591 2.13879 5.50591L2.14073 5.50418Z" fill="#6524EB" />
                            <path d="M6.93616 6.32812H5.92979C5.78842 6.32812 5.67383 6.43058 5.67383 6.55696V7.4567C5.67383 7.58308 5.78842 7.68553 5.92979 7.68553H6.93616C7.07752 7.68553 7.19212 7.58308 7.19212 7.4567V6.55696C7.19212 6.43058 7.07752 6.32812 6.93616 6.32812Z" fill="#6524EB" />
                            <path d="M9.96937 6.32812H8.96299C8.82163 6.32812 8.70703 6.43058 8.70703 6.55696V7.4567C8.70703 7.58308 8.82163 7.68553 8.96299 7.68553H9.96937C10.1107 7.68553 10.2253 7.58308 10.2253 7.4567V6.55696C10.2253 6.43058 10.1107 6.32812 9.96937 6.32812Z" fill="#6524EB" />
                            <path d="M13.0065 6.32812H12.0001C11.8587 6.32812 11.7441 6.43058 11.7441 6.55696V7.4567C11.7441 7.58308 11.8587 7.68553 12.0001 7.68553H13.0065C13.1478 7.68553 13.2624 7.58308 13.2624 7.4567V6.55696C13.2624 6.43058 13.1478 6.32812 13.0065 6.32812Z" fill="#6524EB" />
                            <path d="M3.89905 9.01562H2.89268C2.75131 9.01562 2.63672 9.11808 2.63672 9.24446V10.1442C2.63672 10.2706 2.75131 10.373 2.89268 10.373H3.89905C4.04041 10.373 4.15501 10.2706 4.15501 10.1442V9.24446C4.15501 9.11808 4.04041 9.01562 3.89905 9.01562Z" fill="#6524EB" />
                            <path d="M6.93616 9.01562H5.92979C5.78842 9.01562 5.67383 9.11808 5.67383 9.24446V10.1442C5.67383 10.2706 5.78842 10.373 5.92979 10.373H6.93616C7.07752 10.373 7.19212 10.2706 7.19212 10.1442V9.24446C7.19212 9.11808 7.07752 9.01562 6.93616 9.01562Z" fill="#6524EB" />
                            <path d="M9.96937 9.01562H8.96299C8.82163 9.01562 8.70703 9.11808 8.70703 9.24446V10.1442C8.70703 10.2706 8.82163 10.373 8.96299 10.373H9.96937C10.1107 10.373 10.2253 10.2706 10.2253 10.1442V9.24446C10.2253 9.11808 10.1107 9.01562 9.96937 9.01562Z" fill="#6524EB" />
                            <path d="M13.0065 9.01562H12.0001C11.8587 9.01562 11.7441 9.11808 11.7441 9.24446V10.1442C11.7441 10.2706 11.8587 10.373 12.0001 10.373H13.0065C13.1478 10.373 13.2624 10.2706 13.2624 10.1442V9.24446C13.2624 9.11808 13.1478 9.01562 13.0065 9.01562Z" fill="#6524EB" />
                            <path d="M3.89905 11.7109H2.89268C2.75131 11.7109 2.63672 11.8134 2.63672 11.9398V12.8395C2.63672 12.9659 2.75131 13.0683 2.89268 13.0683H3.89905C4.04041 13.0683 4.15501 12.9659 4.15501 12.8395V11.9398C4.15501 11.8134 4.04041 11.7109 3.89905 11.7109Z" fill="#6524EB" />
                            <path d="M6.93421 11.7109H5.92783C5.78647 11.7109 5.67188 11.8134 5.67188 11.9398V12.8395C5.67188 12.9659 5.78647 13.0683 5.92783 13.0683H6.93421C7.07557 13.0683 7.19017 12.9659 7.19017 12.8395V11.9398C7.19017 11.8134 7.07557 11.7109 6.93421 11.7109Z" fill="#6524EB" />
                            <path d="M9.96937 11.7109H8.96299C8.82163 11.7109 8.70703 11.8134 8.70703 11.9398V12.8395C8.70703 12.9659 8.82163 13.0683 8.96299 13.0683H9.96937C10.1107 13.0683 10.2253 12.9659 10.2253 12.8395V11.9398C10.2253 11.8134 10.1107 11.7109 9.96937 11.7109Z" fill="#6524EB" />
                        </svg>

                    ),
                    status: calendarConnected ? "done" : "pending",
                    value: calendarConnected ? (
                        <>
                            <span style={{ color: "#24252C", fontWeight: 700 }}>Connected </span>
                            <span style={{ color: "#6524EB" }}>- Google Calendar</span>
                        </>
                    ) : "Pending",
                    onAction: () => openSummaryFeature("/calendar-access"),
                },
                {
                    key: "spam",
                    label: "Spam Filtering",
                    icon: (
                        <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.5597 2.80059L8.22601 0.0417215C8.07926 -0.0139072 7.91976 -0.0139072 7.77301 0.0417215L0.440233 2.80059C0.176821 2.90053 0 3.15888 0 3.44927V7.03483C0 12.5308 2.95052 17.4693 7.70378 19.9274C7.79675 19.9755 7.89701 20 8 20C8.10299 20 8.20326 19.9755 8.29622 19.9274C13.0495 17.4683 16 12.5306 16 7.03483V3.44927C16 3.15982 15.8231 2.90148 15.5597 2.80059ZM12.3369 7.34897L7.81697 12.711C7.69028 12.8628 7.50708 12.9486 7.31386 12.9486H7.31021C7.11333 12.9449 6.93013 12.8591 6.80709 12.7035L3.99331 9.27627C3.7536 8.98305 3.78641 8.54839 4.06987 8.30419C4.34969 8.05623 4.76988 8.09394 5.00685 8.38339L7.32016 11.2007L11.3307 6.44591C11.5741 6.15646 11.9943 6.12911 12.2704 6.37708C12.5502 6.62883 12.5766 7.06331 12.3369 7.34897Z" fill="#6524EB" />
                        </svg>

                    ),
                    status: spamEnabled ? "done" : "pending",
                    value: spamEnabled ? "Enabled" : "Pending",
                    onAction: () => openSummaryFeature("/contacts"),
                },
                {
                    key: "triage",
                    label: "Call Triage",
                    icon: (
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.0021 7.20238C20.0064 8.31202 19.7521 9.40739 19.2593 10.4016C18.7665 11.3958 18.0488 12.2616 17.1632 12.9302C17.0879 12.9875 16.9929 13.0125 16.8991 12.9998C16.8054 12.9871 16.7205 12.9376 16.6632 12.8623C16.6059 12.787 16.5808 12.692 16.5935 12.5982C16.6063 12.5044 16.6557 12.4196 16.731 12.3622C21.6498 8.62932 18.9613 0.70522 12.7888 0.703434C11.7869 0.699131 10.7978 0.928647 9.90023 1.37373C9.00263 1.81881 8.22124 2.46719 7.61823 3.26729C7.56091 3.34308 7.47584 3.39299 7.38173 3.40605C7.28762 3.41912 7.19217 3.39426 7.11638 3.33694C7.0406 3.27963 6.99068 3.19456 6.97762 3.10045C6.96456 3.00633 6.98942 2.91089 7.04673 2.8351C11.1893 -2.63194 19.9978 0.341965 20.0021 7.20238ZM17.5133 16.0116C17.4472 17.7932 18.0369 20.1545 15.2955 19.9363C7.19853 20.0928 -0.292663 12.1258 0.00879937 4.23097C0.110597 2.16181 2.0151 2.47363 3.26524 2.46363C4.18034 2.52542 5.16938 2.22432 5.96483 2.93511C6.73455 3.70056 6.41702 4.7346 6.61847 5.62399C6.72491 6.64303 7.46214 7.67564 6.62919 8.69862C6.20378 9.26154 5.73051 9.8541 5.32904 10.4199C6.28405 12.218 7.75529 13.6893 9.55344 14.6443C10.1489 14.2185 10.7018 13.781 11.2822 13.337C11.6264 13.0524 12.0689 12.915 12.5138 12.9548C13.1853 13.037 13.8203 13.3131 14.4672 13.3691C14.7321 13.4199 15.0011 13.4462 15.2709 13.4477C16.9982 13.3874 17.6697 14.3682 17.5133 16.0116Z" fill="#6524EB" />
                            <path d="M14.1567 4.67331V5.8338H15.3175C15.5465 5.83465 15.7658 5.926 15.9277 6.08793C16.0895 6.24986 16.1808 6.46923 16.1815 6.69818V7.70865C16.1813 7.93781 16.0902 8.15753 15.9281 8.31953C15.7661 8.48154 15.5463 8.57259 15.3172 8.57268H14.1567V9.73352C14.1565 9.96268 14.0653 10.1824 13.9033 10.3444C13.7412 10.5064 13.5214 10.5975 13.2923 10.5976H12.2822C12.0532 10.5968 11.8337 10.5055 11.6718 10.3435C11.5099 10.1816 11.4185 9.96218 11.4178 9.73317V8.57268H10.2573C10.144 8.57254 10.0318 8.55006 9.92722 8.50653C9.82261 8.46299 9.72762 8.39926 9.64766 8.31898C9.56771 8.23869 9.50437 8.14343 9.46127 8.03865C9.41817 7.93386 9.39616 7.8216 9.39649 7.7083V6.69783C9.39658 6.46926 9.4872 6.25003 9.64852 6.08811C9.80984 5.92618 10.0287 5.83475 10.2573 5.8338H11.4181V4.67296C11.4192 4.44445 11.5107 4.22565 11.6726 4.06441C11.8345 3.90317 12.0537 3.8126 12.2822 3.8125H13.2926C13.4059 3.81217 13.5182 3.83419 13.623 3.87729C13.7278 3.92039 13.823 3.98373 13.9033 4.06368C13.9836 4.14363 14.0473 4.23863 14.0909 4.34324C14.1344 4.44785 14.1565 4.56001 14.1567 4.67331Z" fill="#6524EB" />
                        </svg>

                    ),
                    status: triageDone ? "done" : "pending",
                    // Rules ka sirf pehle 15 characters — poora text tooltip me.
                    value: (
                        <span style={{ display: "inline-flex", alignItems: "center", flexWrap: "wrap", gap: "4px" }}>
                            {triageDone ? (
                                <span style={{ color: "#27B75E" }}>Complete</span>
                            ) : (
                                "Pending"
                            )}
                            {triageLabel ? (
                                <>
                                    <span style={{ color: "#24252C", fontWeight: 700 }}>
                                        - <TruncatedTooltip text={triageLabel} limit={15} />
                                    </span>
                                </>
                            ) : null}
                        </span>
                    ),
                    // Wizard step 4 = Call Triage, matching /setup-ready's own
                    // callTriage card. /call-transfer is the bare standalone
                    // screen and was the wrong destination.
                    onAction: () => openSummaryFeature("/go-live-setup", 4),
                },
                {
                    key: "availability",
                    label: "Availability",
                    icon: (
                        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6553 10.1097H16.4189V17.48H17.6553C17.8515 17.48 18.0121 17.3185 18.0121 17.1231V10.4674C18.0121 10.2712 17.8506 10.1105 17.6553 10.1105V10.1097ZM19.2077 10.7574H18.4107V16.8323H19.2077C19.6453 16.8323 20.0047 16.4737 20.0047 16.0353V11.5535C20.0047 11.1159 19.6461 10.7565 19.2077 10.7565V10.7574ZM3.58574 10.1097H2.34939C2.15317 10.1097 1.99254 10.2711 1.99254 10.4665V17.1222C1.99254 17.3185 2.15403 17.4791 2.34939 17.4791H3.58574V10.1088V10.1097ZM1.59404 10.7574H0.797022C0.359426 10.7574 0 11.1159 0 11.5544V16.0361C0 16.4737 0.358581 16.8332 0.797022 16.8332H1.59404V10.7574ZM2.48397 9.71116H2.35027C1.97346 9.71116 1.65569 9.99159 1.60272 10.3589H1.16601V8.83772C1.16601 3.97389 5.1399 0 10.0037 0C14.8676 0 18.8415 3.97389 18.8415 8.83772V10.3589H18.4047C18.3518 9.99161 18.034 9.71116 17.6572 9.71116H17.5235V8.83772C17.5235 4.70158 14.1399 1.31892 10.0047 1.31892C5.86678 1.31892 2.48323 4.70158 2.48323 8.83772V9.71116H2.48397ZM13.2785 10.5195C11.47 8.71096 8.53715 8.71096 6.72769 10.5195C4.91918 12.328 4.91918 15.2608 6.72769 17.0703C8.5362 18.8788 11.4691 18.8788 13.2785 17.0703C15.087 15.2618 15.087 12.3289 13.2785 10.5195ZM12.6057 11.1923C11.1688 9.75543 8.83848 9.75543 7.40153 11.1923C5.96463 12.6292 5.96463 14.9595 7.40153 16.3965C8.83843 17.8334 11.1687 17.8334 12.6057 16.3965C14.0426 14.9596 14.0426 12.6293 12.6057 11.1923ZM10.0036 9.71636C7.75138 9.71636 5.92547 11.5422 5.92547 13.7945C5.92547 16.0467 7.75133 17.8726 10.0036 17.8726C12.2558 17.8726 14.0817 16.0467 14.0817 13.7945C14.0817 11.5422 12.2559 9.71636 10.0036 9.71636ZM9.80477 10.6046V10.7938C9.80477 11.056 10.2033 11.056 10.2033 10.7938V10.6046C10.2033 10.3423 9.80477 10.3423 9.80477 10.6046ZM7.6073 11.6794C7.4215 11.4936 7.70367 11.2123 7.88946 11.3972L8.02317 11.5309C8.20897 11.7167 7.9268 11.9981 7.741 11.8131L7.6073 11.6794ZM6.81374 13.9932C6.55154 13.9932 6.55154 13.5947 6.81374 13.5947H7.00302C7.26522 13.5947 7.26522 13.9932 7.00302 13.9932H6.81374ZM7.8886 16.1907C7.7028 16.3765 7.42148 16.0943 7.60643 15.9085L7.74014 15.7748C7.92594 15.589 8.20725 15.8712 8.0223 16.057L7.8886 16.1907ZM10.2024 16.9842C10.2024 17.2464 9.80386 17.2464 9.80386 16.9842V16.7949C9.80386 16.5327 10.2024 16.5327 10.2024 16.7949V16.9842ZM12.3999 15.9094C12.5857 16.0952 12.3035 16.3765 12.1177 16.1915L11.984 16.0578C11.7982 15.872 12.0804 15.5907 12.2661 15.7757L12.3999 15.9094ZM13.1934 13.5956C13.4556 13.5956 13.4556 13.9941 13.1934 13.9941H13.0041C12.7419 13.9941 12.7419 13.5956 13.0041 13.5956H13.1934ZM12.1186 11.3981C12.3044 11.2123 12.5857 11.4945 12.4007 11.6803L12.267 11.814C12.0812 11.9998 11.7999 11.7176 11.9848 11.5318L12.1186 11.3981ZM9.80477 11.8114C9.80477 11.5492 10.2033 11.5492 10.2033 11.8114V13.7119L10.8275 14.3362C11.0133 14.522 10.7312 14.8033 10.5454 14.6184L9.86383 13.9368C9.82736 13.9003 9.80392 13.85 9.80392 13.7944V11.8114L9.80477 11.8114Z" fill="#6524EB" />
                        </svg>

                    ),
                    // Default 24/7 — agent is always reachable until the
                    // user opens Business Hours and configures custom
                    // hours. Render as "done" so the row reads as a
                    // confirmation, not a pending TODO.
                    status: "done",
                    value: "24/7",
                    onAction: () => openSummaryFeature("/Business_hours"),
                },
            ];
            if (!cancelled) setSummaryItems(items);
        })();

        return () => {
            cancelled = true;
        };
    }, [summaryOpen, agent?.agent_id, userId, navigate, summaryItems]);

    // Okay handler — clears the flag, closes the dialog. The tour
    // useEffect re-runs (summaryOpen changed) and starts the
    // dashboard intro tour if eligible.
    /*
     * The isolated-return mirror is consumed the moment the user is back here.
     * Leaving it set would make a LATER, ordinary entry into the calendar
     * screen (from the onboarding sequence) wrongly behave as isolated and
     * bail to the dashboard instead of advancing.
     */
    useEffect(() => {
        try {
            sessionStorage.removeItem(SUMMARY_RETURN_FLAG);
        } catch (_e) {
            /* harmless */
        }
    }, []);

    /*
     * Open a feature from the Setup Summary popup.
     *
     * Three things every one of these actions must do, which a bare
     * navigate() did not:
     *
     * 1. RETIRE THE POPUP. It is a one-time celebration. Leaving via a
     *    "Setup now" button is still leaving — without marking it seen, the
     *    sessionStorage trigger flag survived and the popup re-opened the
     *    moment the user came back to this page. Same marker `Okay` writes,
     *    so both exits behave identically.
     * 2. CLOSE the sheet before navigating, so it is not still mounted
     *    underneath the feature screen.
     * 3. Carry `returnTo` so the feature screen knows it was entered in
     *    ISOLATION — back / save / skip must all land back here, not walk
     *    into the onboarding add-on sequence.
     *
     * SUMMARY_RETURN_FLAG mirrors `returnTo` in sessionStorage for screens
     * that remount through an OAuth round-trip and lose router state.
     */
    const openSummaryFeature = (route, wizardStep = null) => {
        const loadedId = agent?.agent_id || "";
        const sessionId = getSummaryAgentId();
        if (loadedId) markSetupSummarySeen(loadedId);
        if (sessionId && sessionId !== loadedId) markSetupSummarySeen(sessionId);
        try {
            sessionStorage.removeItem(SETUP_SUMMARY_FLAG);
            sessionStorage.setItem(SUMMARY_RETURN_FLAG, SUMMARY_RETURN_ROUTE);

            /*
             * Wizard-hosted features (Call Triage) open the go-live wizard AT
             * that step — the same thing /setup-ready's card does, so the user
             * gets the "Tell {agent} When Calls Transfer" step rather than the
             * bare /call-transfer screen.
             *
             * The one difference from /setup-ready: it CLEARS assignNumberOnly
             * because it owns the whole Number → Forwarding → Triage → Add-ons
             * sequence. We SET it, because a feature opened from the summary is
             * an isolated single-feature visit — that flag makes TriageStep skip
             * the "is live" dialog and finishToContactSync return here, which is
             * exactly the isolation rule the summary popup follows.
             */
            if (wizardStep) {
                if (loadedId || sessionId) {
                    sessionStorage.setItem("SelectAgentId", loadedId || sessionId);
                }
                const bizId = agent?.businessId || agent?.business_id || "";
                if (bizId) sessionStorage.setItem("SelectAgentBusinessId", bizId);
                sessionStorage.setItem("goLiveWizard.assignNumberOnly", "1");
                localStorage.setItem("goLiveWizard.lastStep", String(wizardStep));
            }
        } catch (_e) {
            /* private mode — router state below still carries returnTo */
        }
        setSummaryOpen(false);
        navigate(route, { state: { returnTo: SUMMARY_RETURN_ROUTE } });
    };

    const handleSummaryOkay = () => {
        try {
            sessionStorage.removeItem(SETUP_SUMMARY_FLAG);
        } catch (_e) {
            /* harmless */
        }
        /*
         * Mark seen on Okay, not on open: Okay is the only dismissal (summary
         * mode blocks backdrop + ESC), so a reload mid-dialog correctly brings
         * it back — the user hasn't acknowledged it yet.
         *
         * Marked under BOTH the loaded agent id and the sessionStorage one.
         * The open-gate runs before the agent has loaded and can only read
         * SelectAgentId; if the two ever disagree, writing one key would let
         * the popup return under the other.
         */
        const loadedId = agent?.agent_id || "";
        const sessionId = getSummaryAgentId();
        if (loadedId) markSetupSummarySeen(loadedId);
        if (sessionId && sessionId !== loadedId) markSetupSummarySeen(sessionId);
        setSummaryOpen(false);
    };

    useEffect(() => {
        const getAgentDetailsAndBookings = async () => {
            if (!agentDetails?.agentId) return;
            const cached = getAgentById(agentDetails.agentId);
            if (cached) {
                setCurrentAgentId(agentDetails.agentId);
                setLoading(false);
            }
            try {
                const response = await fetchAgentDetailById(agentDetails);
                const agentInfo = response?.data;
                // setAgentCalApiKey(agentInfo?.agent?.calApiKey);
                let numbersArray = [];
                // console.log(agentInfo, "agentinfo")
                // setAgentInfo(agentInfo);
                const voipNumbersStr = agentInfo?.agent?.voip_numbers;
                if (voipNumbersStr) {
                    try {
                        numbersArray = JSON.parse(voipNumbersStr);
                    } catch {
                        console.warn("Failed to parse voip_numbers");
                    }
                }

                let total = 0;

                // Set all data into zustand
                setAgentById(agentDetails.agentId, agentInfo, numbersArray, total);
            } catch (err) {
                console.error("Failed to fetch data", err.response || err.message || err);
            } finally {
                setLoading(false);
            }
        };
        if (refresh > 0) {
            getAgentDetailsAndBookings();
        }
    }, [refresh]);
    // Independent fetch for the SetupScoreCard rendered above the agent
    // card. The summary-dialog effect already calls fetchSetupScore but
    // only when the user opens that dialog — the card needs the data on
    // first paint, so we fetch separately here. Re-fires when the agent
    // changes or the user triggers a refresh (e.g. after Assign Number).
    useEffect(() => {
        const aid = agentData?.agent?.agent_id;
        if (!aid) return;
        let cancelled = false;
        fetchSetupScore(aid)
            .then((res) => {
                if (cancelled) return;
                setSetupScore(res || null);
            })
            .catch(() => {
                if (!cancelled) setSetupScore(null);
            });
        return () => {
            cancelled = true;
        };
    }, [agentData?.agent?.agent_id, refresh]);

    //  Missing function added
    const handleInactiveAgentAlert = () => {
        setPopupMessage("Your agent is not active. Please activate your agent first.");
        setPopupType("failed");
    };

    //  Start call
    const handleStartCall = async () => {
        try {
            await navigator.mediaDevices.getUserMedia({ audio: true });
            trackEvent("test_call_start", { mic_permission: "granted" });
        } catch (err) {
            trackEvent("test_call_start", { mic_permission: "denied" });
            console.error("Microphone access denied or error:", err);
            setPopupMessage("Microphone access is required to test agent.");
            setPopupType("failed");
            return;
        }

        if (
            isStartingRef.current ||
            isCallInProgress ||
            // Python agents have no Retell client — don't require it for them.
            (!isPythonBackend() && !retellWebClient) ||
            !agentData?.agent
        ) {
            console.error("RetellWebClient or agent data not ready.");
            return;
        }

        isStartingRef.current = true;
        setCallLoading(true);
        setIsCallInProgress(true);

        // ── Python flow (rexpt.in / port 3001): a Python agent has no Retell
        // web-call. Stream over the WebSocket exactly as GlobalCallContext does
        // (startPythonTestCall). Node agents fall through to the Retell path
        // below, unchanged. ──
        if (isPythonBackend()) {
            pythonCallRef.current = startPythonTestCall(
                agentData?.agent?.agent_id,
                {
                    onStatus: (s) => {
                        if (s === "connected") {
                            callStartTimeRef.current = Date.now();
                            // A Python agent has no Retell SDK, so the
                            // client.on("call_started") that flips isCallActive
                            // for a Node agent never fires. Set it here so the
                            // CallTest popup shows "End Call" instead of "Call".
                            setIsCallActive(true);
                        } else if (s === "ended" || s === "error") {
                            // The ref is still set only if the AGENT ended the
                            // call (the caller asked it to disconnect) — the End
                            // Call button clears it before hanging up.
                            const agentEnded = s === "ended" && pythonCallRef.current;
                            setIsCallActive(false);
                            setIsCallInProgress(false);
                            if (agentEnded) {
                                // Same wrap-up as pressing End Call: marks the
                                // setup step (testCallCompleted) and refreshes the
                                // score. Without it the step stayed pending and
                                // the user could not move on. Then close the popup.
                                handleEndCallRef.current?.();
                                setOpenCallModal(false);
                            }
                            pythonCallRef.current = null;
                        }
                    },
                }
            );
            setCallLoading(false);
            isStartingRef.current = false;
            return;
        }

        try {
            const res = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/agent/create-web-call`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    // rexpt_test_call: owner ki apni test call — backend live-monitoring push skip karta hai
                    body: JSON.stringify({ agent_id: agentData?.agent?.agent_id, metadata: { rexpt_test_call: "true" } }),
                }
            );

            if (res.status === 403) {
                setPopupMessage("Agent Plan minutes exhausted");
                setPopupType("failed");
                setIsCallInProgress(false);
                return;
            }

            const data = await res.json();
            await retellWebClient.startCall({
                accessToken: data.access_token,
                callId: data.call_id,
                transport: data.transport,
                iceServers: data.ice_servers,
                emitRawAudioSamples: true,
            });
            callStartTimeRef.current = Date.now();
            setCallId(data?.call_id);
        } catch (err) {
            console.error("Error starting call:", err);
        } finally {
            setCallLoading(false);
            isStartingRef.current = false;
        }
    };

    // End call
    const handleEndCall = async () => {
        if (isEndingRef.current) return;
        isEndingRef.current = true;

        // Python flow: no Retell client — hang up the WebSocket call. Fall
        // through to the shared finally block for score/refresh bookkeeping.
        if (isPythonBackend()) {
            try { pythonCallRef.current?.hangUp(); } catch (_e) { /* ignore */ }
            pythonCallRef.current = null;
            // No Retell call_ended event for a Python agent — reset the button
            // state here so the popup leaves "End Call".
            setIsCallActive(false);
        } else if (!retellWebClient) {
            isEndingRef.current = false;
            return;
        }

        try {
            if (!isPythonBackend()) {
                await retellWebClient.stopCall();
            }
        } catch (err) {
            console.error("Error ending call:", err);
        } finally {
            setIsCallInProgress(false);
            isEndingRef.current = false;

            // GA4: activation-preview event — the user heard the AI (free).
            const durationSec = callStartTimeRef.current
                ? Math.round((Date.now() - callStartTimeRef.current) / 1000)
                : 0;
            callStartTimeRef.current = null;
            trackEvent("test_call_complete", { duration_sec: durationSec });

            /*
             * Setup-score progression: if the agent's testCallCompleted
             * step is still pending, mark it now so SetupScoreCard
             * advances. Gated on the LIVE score state so we only fire
             * on genuine first-completions — repeat test calls don't
             * burn extra backend round-trips. The backend mark is
             * idempotent regardless, but skipping the call when not
             * needed is cleaner.
             *
             * After firing we re-fetch the score so the dot row + Continue
             * button reflect the new state without a manual refresh.
             */
            try {
                const aid = agent?.agent_id;
                if (
                    aid &&
                    setupScore &&
                    !setupScore?.steps?.testCallCompleted?.done
                ) {
                    markSetupStep("testCallCompleted", aid);
                    fetchSetupScore(aid)
                        .then((fresh) => {
                            if (fresh) setSetupScore(fresh);
                        })
                        .catch(() => {
                            /* refresh failure is harmless — next page
                               load will pull the updated score. */
                        });
                }
            } catch (_e) {
                /* never let score plumbing fail a call-end handler */
            }
            /*
             * Call-count + agent data refresh. The dashboard's "Total
             * Calls" pill on AgentCardDetail reads `agentData.callSummary.totalCalls`,
             * which is only re-fetched when `refresh` ticks. Without
             * this bump, a test call ends but the counter stays stale
             * until the user manually reloads. Bumping `refresh` here
             * triggers:
             *   - fetchAgentDetailById → fresh callSummary
             *   - fetchSetupScore (the independent SetupScoreCard
             *     effect depends on `refresh`) — belt-and-braces for
             *     the score sync above in case the LIVE state gate
             *     misread the step.
             *
             * Delayed 1.2s because Retell's call-end webhook lands a
             * few hundred ms after stopCall resolves; fetching too
             * early returns the pre-call totals.
             */
            setTimeout(() => setRefresh((p) => p + 1), 1200);
        }
    };
    // Latest handleEndCall for the Python onStatus callback, which is created
    // once per call and would otherwise hold a stale copy.
    handleEndCallRef.current = handleEndCall;

    // QR-I467: Law Firm + Drive not connected → no calls. `false` is only ever
    // set for Law Firm + paid + non-team-member, so `null` never blocks.
    const driveLocked = driveConnected === false && !isRestrictedTeamMember;
    const DRIVE_LOCK_MESSAGE =
        "Connect Google Drive first — your agent can't take calls until recordings have somewhere to go.";

    // All in-app test calls funnel through here, so the gate lives in one place.
    const openCallTestModal = () => {
        if (driveLocked) {
            setShowDrivePopup(true);
            setPopupType("failed");
            setPopupMessage(DRIVE_LOCK_MESSAGE);
            return;
        }
        setOpenCallModal(true);
    };

    /*
     * "Continue" handler for the Great Progress (SetupProgress) card —
     * now the ONLY setup card on this page (the purple SetupScoreCard is
     * no longer rendered).
     *
     *  - Paid users  → /setup-ready (their post-setup home). Paid users
     *    are never routed back through plan selection.
     *  - Free users  → resume the onboarding ladder where they left off.
     *    This mirrors the old SetupScoreCard.handleContinue exactly:
     *    testCall opens the in-place CallTest modal instead of navigating,
     *    and businessConfirmed-at-0 marks the step before routing. Because
     *    this branch only runs for free users, every plan-gated step
     *    resolves to /recommended-plan (there is no paid /go-live-setup
     *    fork here).
     */
    /*
     * Agent pe phone number assign ho chuka hai?
     *
     * voip_numbers kai shakl me aata hai — JSON string, array of strings, legacy
     * array-of-objects, ya bare string. Isi file me neeche rows ke liye wahi
     * parse pehle se hai; yahan sirf "hai ya nahi" chahiye, isliye chhota version.
     */
    const hasAssignedVoipNumber = (a) => {
        const v = a?.voip_numbers;
        if (!v) return false;
        if (Array.isArray(v)) return !!v[0];
        if (typeof v === "string") {
            const t = v.trim();
            if (!t || t === "[]" || t === "null") return false;
            if (t.startsWith("[")) {
                try {
                    const parsed = JSON.parse(t);
                    return Array.isArray(parsed) ? !!parsed[0] : !!parsed;
                } catch {
                    return true; // parse na ho par kuch to likha hai
                }
            }
            return true;
        }
        return false;
    };

    const isVariantB = () => getVariant(EXPERIMENTS.GO_LIVE_FLOW) === VARIANT_B;

    const handleSetupContinue = () => {
        /*
         * PAID user (A ya B, dono) → /setup-ready. Ye check SABSE PEHLE hai:
         * plan lene ke baad B flow khatam ho chuka hai, to usse dobara
         * /agent-live ya /fast-step bhejna peeche le jaana hoga.
         */
        /*
         * A CANCELLED-SUBSCRIPTION agent reverts to no/free/demo plan, so
         * `isPaidPlanAgent` goes false and this used to fall through to the
         * free-user paths — sending them to the plans/test-call flow when they
         * tapped Setup Score. They already onboarded; they want their existing
         * setup, not a fresh pitch.
         *
         * What separates them from a genuinely NEW free user is deactivation:
         * a new free user has no plan and is NOT deactivated. Reuses the same
         * polymorphic flag the setup-bar retirement uses (true / 1 / "true"),
         * so the two surfaces can never disagree about what "cancelled" means.
         */
        const hasNoPlan =
            !agentPlanLower ||
            agentPlanLower === "free" ||
            agentPlanLower === "demo";
        const isCancelledSubscriptionAgent =
            hasNoPlan && isAgentCancelledOrDeactivated;

        if (isPaidPlanAgent || isCancelledSubscriptionAgent) {
            navigate("/setup-ready", {
                state: {
                    setupPercent: Number(setupScore?.percent) || 0,
                    agentId: agent?.agent_id,
                    bussinesId: agent?.businessId || agent?.business_id,
                },
            });
            return;
        }

        /*
         * A/B variant B, plan abhi liya nahi — user ko wahin le jao jahan wo B
         * flow me chhoda tha:
         *   number assigned  → /agent-live ("Congratulations / Call <agent> on
         *                      her number"), jahan se wo asli call kar sakta hai
         *   number nahi hai  → /fast-step (web test-call wali screen), taaki wo
         *                      pehle agent ko azmaye aur flow aage badhe
         * Variant A me ye branch chalti hi nahi.
         */
        if (isVariantB()) {
            if (hasAssignedVoipNumber(agent)) {
                navigate("/agent-live");
            } else {
                navigate("/fast-step", { state: { suppressPopup: true } });
            }
            return;
        }

        // App-surface (now web too) → send them into the /fast-step test-call
        // screen (the guided demo flow) instead of the normal onboarding ladder.
        // Pass suppressPopup so the "Meet" intro dialog does NOT auto-open here —
        // coming from Continue, the user lands on the ready summary and taps
        // "Test again" to call.
        if (isMobileAppSurface()) {
            navigate("/fast-step", { state: { suppressPopup: true } });
            return;
        }

        const nextAction = computeSetupNextAction(setupScore, agent);

        if (nextAction === "businessConfirmed" && setupScore?.percent === 0) {
            markSetupStep("businessConfirmed", agent?.agent_id);
        }
        if (nextAction === "testCallCompleted") {
            openCallTestModal();
            return;
        }

        const route = (() => {
            switch (nextAction) {
                case "businessConfirmed":
                case "planActivated":
                case "phoneNumberAssigned":
                    return "/recommended-plan?mode=plans";
                case "callForwardingDone":
                    return "/forward-instructions";
                case "triageRulesSaved":
                    return "/call-transfer";
                case "contactsSynced":
                    return "/contacts";
                case "firstRealCall":
                default:
                    return "/go-live-setup";
            }
        })();
        if (route) navigate(route);
    };

    const closeCallTestModal = () => {
        handleEndCall();
        setOpenCallModal(false);
    };

    const handleTestCallClick = () => {
        /*
         * Number PEHLE SE assigned hai → in-place call POPUP, hamesha.
         *
         * Agent live hai; user bas ek test call karna chahta hai — usse doosri
         * screen pe bhejna bekaar hop hai. Aur /fast-step global call BANNER ko
         * prime kar deta hai, jo phir $5 wali screen tak chipka reh jaata hai.
         *
         * Ye check pehle `isVariantB()` ke ANDAR tha. Wo galat tha: variant ek
         * rollout switch hai, agent ki haalat nahi. EXPERIMENT_GO_LIVE_FLOW=A
         * karte hi isVariantB() false ho jaata, wahi number-wala user neeche
         * /fast-step branch me gir jaata, aur usse banner mil jaata — popup
         * nahi. Number hai ya nahi, bas isi se faisla hona chahiye.
         */
        if (hasAssignedVoipNumber(agent)) {
            openCallTestModal();
            return;
        }

        /*
         * Variant B, number NAHI hai → /fast-step. User ne B flow beech me
         * chhoda hai (/receptionist-number se bina number liye nikal gaya).
         * Popup kholne se wo wahin ka wahin reh jaata; /fast-step usse flow me
         * wapas daal deta hai jahan se wo number tak pahunchega.
         */
        if (isVariantB()) {
            navigate("/fast-step", { state: { suppressPopup: true } });
            return;
        }

        // App-surface (now web too) + FREE agent → send them to the /fast-step
        // guided test screen (ready summary + "Test again") instead of the
        // in-place call modal. Paid agents keep the existing modal behaviour.
        if (isMobileAppSurface() && !isPaidPlanAgent) {
            navigate("/fast-step", { state: { suppressPopup: true } });
            return;
        }
        openCallTestModal();
    };

    // Assign-number click — opens the View-Plans-or-Trial popup.
    //
    // Earlier this jumped straight to /recommended-plan; that nav is
    // commented out below and now lives behind the popup's "View Plans"
    // CTA. "Activate Trial" calls /freeSetup-plan directly so the user
    // never sees the pricing list when they pick the trial path.
    const handleAssignNumberClick = async () => {
        if (!agent) return;

        // Payment-gated action — support team members can never trigger a
        // plan / trial purchase on the owner's behalf. Admin team members
        // are allowed (full access). Mirrors the dashboard pattern where
        // payment options are wrapped in <LockOverlay locked={isTeamMember}>.
        if (isRestrictedTeamMember) {
            setPopupMessage("Only the account owner can assign a phone number.");
            setPopupType("failed");
            return;
        }

        if (!!agent?.isDeactivated) {
            handleInactiveAgentAlert();
            return;
        }

        sessionStorage.setItem("SelectAgentId", agent?.agent_id);
        sessionStorage.setItem("SelectAgentBusinessId", agent?.businessId || "");

        /*
         * Paid users skip to GoLiveWizard directly.
         *
         * Paid agents already hold an active plan; direct-route them
         * straight to /go-live-setup which auto-runs the number
         * cascade.
         *
         * `goLiveWizard.assignNumberOnly` flag tells finishToContactSync
         * inside GoLiveWizard to skip /contact-sync at the end of
         * the wizard (these users finished onboarding long ago).
         */
        const planLower = (agent?.agentPlan || "")
            .toString()
            .trim()
            .toLowerCase();
        const isFreeOrDemo =
            planLower === "" ||
            planLower === "free" ||
            planLower === "demo";

        // AppSumo takes the same route as a free agent, not the paid one.
        //
        // The paid branch below opens GoLiveWizard, which on variant B bounces
        // first to /setup-path ("How Customers Reach <agent>?") — a question
        // aimed at someone still deciding how to launch. An AppSumo buyer
        // clicking Assign Phone Number has already built their agent and is
        // here for a number, so they belong on the /fast-step summary that free
        // agents get, which leads straight into the number flow.
        const isAppSumoPlan = planLower === "appsumo";

        if (!isFreeOrDemo && !isAppSumoPlan) {
            try {
                sessionStorage.setItem("goLiveWizard.assignNumberOnly", "1");
            } catch (_e) { }
            /*
             * Number PEHLE SE assigned hai → wizard ka "Assign Number" step
             * (Step 1) dikhane ka koi matlab nahi: wahan wahi number dikhta hai
             * jo unke paas already hai, aur "Continue With This Number" kuch
             * khareedta bhi nahi (ImmediateOwnerShip ki purchase branch
             * selectedNumber hone par skip ho jaati hai). User ko lagta hai
             * usse dobara number chunna hai — bekaar ka ek step.
             *
             * Ye variant B me sabse zyada hota hai, jahan number payment se
             * PEHLE hi mil jaata hai (/receptionist-number).
             *
             * ?goto=forwarding wizard ka pehle se maujood hook hai — number
             * hone par wo seedha Call Forwarding stage (Step 2) pe le jaata
             * hai. Naya rasta banane ki zaroorat nahi.
             */
            navigate(
                hasAssignedVoipNumber(agent)
                    ? "/go-live-setup?goto=forwarding"
                    : "/go-live-setup"
            );
            return;
        }

        /*
         * For Free users (Flow A & Flow B):
         * Clicking "Assign Phone Number" lands on the /fast-step summary screen
         * ("Pro is ready for <businessName>", "works 24/7 for far less cost",
         * "Every call she catches is a typical $250 customer you'd have missed",
         * and the "Go Live with <agentName>" button).
         */
        navigate("/fast-step", { state: { suppressPopup: true } });
    };

    // Dashboard agent cards enter Assign Number through this screen so they
    // always use the same current flow as this page (trial/plans/Go Live).
    useEffect(() => {
        const requestedAgentId = sessionStorage.getItem("dashboard.assignNumberAgentId");
        if (!requestedAgentId || String(requestedAgentId) !== String(agent?.agent_id)) {
            return;
        }

        sessionStorage.removeItem("dashboard.assignNumberAgentId");
        handleAssignNumberClick();
    }, [agent?.agent_id]);

    // Popup — "View Plans" → /recommended-plan plans view. Stripe
    // success URL stays on /go-live-setup (RecommendedPlan's default
    // when upgradeReturnTo is unset), so the post-payment flow matches
    // the regular checkout path the rest of the app uses.
    const handleViewPlansFromAssignPopup = () => {
        if (!agent) return;
        setShowAssignPopup(false);
        /*
         * "Assign number only" intent — user already finished
         * onboarding; they're here just to add a phone number to an
         * existing agent. GoLiveWizard.finishToContactSync reads
         * this flag and bounces them back to /fast-agent-detail
         * instead of routing through /contact-sync (which would
         * re-prompt contact import they've already managed).
         */
        try {
            sessionStorage.setItem("goLiveWizard.assignNumberOnly", "1");
        } catch (_e) { }
        navigate("/recommended-plan?mode=plans", {
            state: {
                agentID: agent?.agent_id,
                locationPath: location.pathname,
                fromAssignNumber: true,
                planName: agent?.agentPlan,
            },
        });
    };

    // Popup — "Activate Trial" → /freeSetup-plan ($20 + 21-day Starter
    // trial). Mirrors RecommendedPlan.handleStartTrial so the cross-
    // icon flow and this popup hit Stripe with the same configuration.
    // Success URL is /go-live-setup (the normal post-checkout flow), so
    // the user doesn't bounce back to /fast-agent-detail after paying.
    const handleActivateTrialFromAssignPopup = async () => {
        if (trialLoading) return;
        if (!agent) return;

        const trialUserId = decodeTokenData?.id;
        const trialEmail = decodeTokenData?.email;
        if (!token || !trialUserId || !trialEmail) {
            setTrialError("Missing account info. Please refresh and sign in again.");
            return;
        }

        // "Assign number only" intent — same purpose as in the
        // View-Plans handler above (skip /contact-sync on wizard exit).
        try {
            sessionStorage.setItem("goLiveWizard.assignNumberOnly", "1");
        } catch (_e) { }

        setTrialLoading(true);
        setTrialError("");

        try {
            // Pull Starter monthly priceId from /products. Same source of
            // truth that RecommendedPlan uses when it lists plans.
            const productsRes = await axios.get(`${API_BASE}/products`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            const products = Array.isArray(productsRes?.data)
                ? productsRes.data
                : [];
            const trialProduct = products.find(
                (p) => (p?.name || "").trim().toLowerCase() === "starter"
            );
            const monthlyPrice = trialProduct?.prices?.find(
                (pr) => pr.interval === "month"
            );
            const monthlyPriceId = monthlyPrice?.id;
            if (!monthlyPriceId) {
                setTrialError("Trial plan isn't available right now.");
                setTrialLoading(false);
                return;
            }

            const monthlyAmount = monthlyPrice?.unit_amount;
            const planPriceLabel = Number.isFinite(monthlyAmount)
                ? `$${Math.round(monthlyAmount / 100)}/month`
                : undefined;

            const trialAgentId = agent?.agent_id;
            sessionStorage.setItem("selectedPlan", "starter");
            sessionStorage.setItem("selectedBillingInterval", "month");
            sessionStorage.setItem("cancelReturnTo", "/fast-agent-detail");

            const successParams = new URLSearchParams({
                fromCheckout: "1",
                trial: "1",
            });
            if (trialAgentId) successParams.append("agentId", trialAgentId);
            if (trialUserId) successParams.append("userId", trialUserId);
            const successUrl = `${window.location.origin}/go-live-setup?${successParams.toString()}`;
            const cancelUrl = `${window.location.origin}/cancel-payment`;

            const trialBusinessName =
                agentData?.business?.businessName ||
                agentData?.business?.googleBusinessName ||
                "";

            const res = await axios.post(
                `${API_BASE}/freeSetup-plan`,
                {
                    email: trialEmail,
                    priceId: monthlyPriceId,
                    sucessurl: successUrl,
                    cancelurl: cancelUrl,
                    userId: trialUserId,
                    planName: "starter",
                    agentId: trialAgentId,
                    business_name: trialBusinessName,
                    activation_price: "$20",
                    trial_days: 21,
                    trial_minutes: 150,
                    plan_price: planPriceLabel,
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (res?.data?.checkoutUrl) {
                window.location.href = res.data.checkoutUrl;
                return;
            }
            setTrialError("Could not start the trial. Please try again.");
        } catch (err) {
            console.error(
                "[FastAgentDetails] trial checkout error:",
                err?.response?.data || err?.message
            );
            setTrialError("Could not start the trial. Please try again.");
        } finally {
            setTrialLoading(false);
        }
    };
    useEffect(() => {
        window.history.pushState(null, "", window.location.href);

        const handlePopState = () => {
            window.history.pushState(null, "", window.location.href);
        };

        window.addEventListener("popstate", handlePopState);

        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);

    return (
        <div className={styles.containerBox}>
            {/* Browser push permission ask. Only shown when permission === "default"
                and user hasn't dismissed within last 7 days. On Allow → token is
                registered with the backend, which auto-fires the welcome push. */}
            <PushPermissionModal
                disabled={
                    // Suppressed on login for now — only the "No calls yet"
                    // modal should show. Restore via SHOW_LOGIN_PROMPTS.
                    !SHOW_LOGIN_PROMPTS ||
                    !calendarReminderReady ||
                    calendarReminderEligible ||
                    showCalendarReminder ||
                    showContactSyncPopup ||
                    summaryOpen ||
                    isTourOpen ||
                    !tourDone ||
                    loading ||
                    showDraftView ||
                    notificatioView
                }
                onOpen={() => setPushPermissionOpen(true)}
                onClose={() => setPushPermissionOpen(false)}
                onTokenReceived={(fcmToken) => {
                    if (userId && fcmToken) {
                        registerPushToken(userId, fcmToken, "web");
                    }
                }}
            />
            {/* Floating "Connect Your Calendar" nudge (FRD §3.2 dashboard nudge).
                Eligibility (calendar not connected + 3rd dashboard visit +
                no session dismissal) is owned above by checkCalendarReminder;
                `calendarNudgeVisible` additionally retracts it while any
                overlay is open. This banner REPLACES the centred modal below,
                which is why that block stays commented out — both render off
                `showCalendarReminder`, so having both would show two nudges. */}
            <CalendarNudgeBanner
                open={calendarNudgeVisible}
                onStart={() => {
                    dismissCalendarReminder();
                    // returnTo so CalendarBookingIntro's Back / Skip come back
                    // to the dashboard rather than walking the add-on sequence.
                    navigate("/calendar-access", {
                        state: { returnTo: "/fast-agent-detail" },
                    });
                }}
                onDismiss={dismissCalendarReminder}
            />
            {/* <NeedHelpNew
                visible={!calendarNudgeVisible}
                agentName={agent?.agentName}
            /> */}

            {/* {!isTeamMember && (
            <NeedHelpNew
                visible={!calendarNudgeVisible}
            />)} */}

            {/* SUPERSEDED by CalendarNudgeBanner above (2026-08-25). Kept for
                reference; do NOT re-enable both — they share showCalendarReminder.
            {SHOW_LOGIN_PROMPTS && showCalendarReminder && (
                <div className={styles.modalBackdrop} onClick={() => {
                    dismissCalendarReminder();
                }}>
                    <div className={styles.calendarReminderModal} onClick={(e) => e.stopPropagation()}>
                        <div className={styles.calendarReminderIcon}>
                            <img src="/svg/google_calendar.svg" alt="" />
                        </div>
                        <h2>Connect your calendar</h2>
                        <p>
                            Connect Google Calendar so your AI receptionist can book appointments
                            directly into your schedule and avoid missed bookings.
                        </p>
                        <div className={styles.modalButtons}>
                            <button
                                type="button"
                                className={`${styles.modalButton} ${styles.cancel}`}
                                onClick={() => {
                                    dismissCalendarReminder();
                                }}
                            >
                                Not now
                            </button>
                            <button
                                type="button"
                                className={`${styles.modalButton} ${styles.submit}`}
                                onClick={() => {
                                    dismissCalendarReminder();
                                    navigate("/connect-calender2", {
                                        state: { agentId, bussinesId },
                                    });
                                }}
                            >
                                Connect
                            </button>
                        </div>
                    </div>
                </div>
            )}
            */}
            {isTourOpen && <div className={styles.tourClickShield} onClick={(e) => e.stopPropagation()} />}
            <div className={styles.Forsticky}>
                {isPounceAgent ? (
                    /* Logo `subtitle` me jaata hai, `title` me nahi: HeaderBar title
                       ko === se compare karke swap animation chalata hai, aur
                       JSX har render pe naya object hota — title me dete to loop. */
                    <HeaderBar
                        title=""
                        subtitle={
                            <OutboundCallerBrand />
                        }
                        onBack={() => navigate("/dashboard")}
                        rightIcon={
                            <span className={pounceStyles.rightGroup}>
                            {/* Pounce on/off — /leads wala hi. */}
                            <PounceToggle />
                            </span>
                        }
                    />
                ) : (
                    <>
                        <HeaderBar
                            subtitle="Hello!"
                            title={
                                showCompletePrompt
                                    ? NUDGE_TEXT
                                    : headerFirstName || "there"
                            }
                            compactTitle={showCompletePrompt}
                            titleArrow={showCompletePrompt}
                            showProfileIcon={true}
                            profileImg={
                                user?.profile ||
                                decodeTokenData?.profile ||
                                decodeTokenData?.profilePicture ||
                                ""
                            }
                        />

                        <div className={styles.notification}>
                            <div style={{ position: "relative", display: "inline-flex" }}>
                                <button
                                    type="button"
                                    className={`${styles.notificationToggle} ${notificatioView ? styles.notificationToggleActive : ""}`}
                                    aria-label={notificatioView ? "Close notifications" : "Open notifications"}
                                    onClick={() => {
                                        setNotificationsView((prev) => !prev);
                                        sessionStorage.setItem("naviateFrom", "fast-agent-detail");
                                    }}
                                >
                                    {notificatioView ? (
                                        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                            <path d="M6 6L18 18M18 6L6 18" />
                                        </svg>
                                    ) : (
                                        <img src="/svg/Notification_icon.svg" alt="" />
                                    )}
                                </button>
                                {!notificatioView && unreadCount > 0 && (
                                    <span
                                        aria-label={`${unreadCount} unread notifications`}
                                        style={{
                                            position: "absolute",
                                            top: "-4px",
                                            right: "-4px",
                                            minWidth: "16px",
                                            height: "16px",
                                            padding: "0 4px",
                                            boxSizing: "border-box",
                                            background: "#EF4444",
                                            color: "#fff",
                                            fontSize: "10px",
                                            fontWeight: 700,
                                            lineHeight: "16px",
                                            textAlign: "center",
                                            borderRadius: "999px",
                                            pointerEvents: "none",
                                        }}
                                    >
                                        {unreadCount > 99 ? "99+" : unreadCount}
                                    </span>
                                )}
                            </div>
                            {hasRedeemedAppSumo() && (
                                <button
                                    type="button"
                                    className={styles.notificationToggle}
                                    aria-label="Rewards"
                                    title="Refer & earn credits"
                                    onClick={() => {
                                        sessionStorage.setItem("naviateFrom", "fast-agent-detail");
                                        navigate("/rewards");
                                    }}
                                >
                                    <img src="/svg/refrel_icon.svg" alt="" />
                                </button>
                            )}
                            <button
                                type="button"
                                className={styles.logoutBtn}
                                onClick={handleLogout}
                                aria-label="Logout"
                            >
                                <svg
                                    width="16"
                                    height="22"
                                    viewBox="0 0 16 22"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    aria-hidden="true"
                                >
                                    <path
                                        d="M11.2451 14.7432C11.2018 14.7346 11.1592 14.7221 11.1182 14.7051C11.0367 14.6713 10.9628 14.6218 10.9004 14.5596L10.8154 14.457C10.791 14.4205 10.7699 14.3816 10.7529 14.3408C10.719 14.2592 10.7022 14.1714 10.7021 14.083L10.7148 13.9512C10.7235 13.9079 10.7359 13.8652 10.7529 13.8242C10.7699 13.7834 10.791 13.7445 10.8154 13.708L10.9004 13.6055L12.8428 11.6738L6.74316 11.6738C6.5645 11.6738 6.39296 11.6029 6.2666 11.4766C6.14027 11.3502 6.06943 11.1786 6.06934 11C6.06934 10.8214 6.14037 10.6498 6.2666 10.5234C6.39296 10.3971 6.56447 10.3253 6.74316 10.3252L12.8428 10.3252L10.9004 8.39355L10.8994 8.39355L10.8154 8.29004C10.7422 8.18004 10.7021 8.05011 10.7021 7.91602C10.7022 7.737 10.7737 7.565 10.9004 7.43848C11.027 7.31205 11.199 7.24113 11.3779 7.24121C11.5568 7.24141 11.7281 7.31291 11.8545 7.43945L11.8545 7.43848L14.9512 10.5225C15.0141 10.5849 15.0645 10.6593 15.0986 10.7412C15.1327 10.8231 15.1504 10.9113 15.1504 11C15.1503 11.0885 15.1326 11.1761 15.0986 11.2578C15.0815 11.2989 15.0599 11.3383 15.0352 11.375L14.9512 11.4775L11.8525 14.5596C11.7901 14.622 11.7154 14.6712 11.6338 14.7051C11.5521 14.7389 11.4644 14.7568 11.376 14.7568L11.2451 14.7432Z"
                                        fill="#222222"
                                        stroke="#222222"
                                        strokeWidth="0.3"
                                    />
                                    <path
                                        d="M5.41602 21.457L5.18945 21.4512C4.06174 21.3954 2.99122 20.9227 2.18848 20.1211C1.33243 19.2661 0.850217 18.1064 0.848633 16.8965L0.848634 5.11426L0.854494 4.88769C0.911831 3.75841 1.38613 2.68712 2.18945 1.88379C2.993 1.08037 4.06483 0.605939 5.19434 0.548827L5.4209 0.542968L10.5869 0.542968C11.7964 0.543775 12.956 1.02494 13.8115 1.87988C14.667 2.73482 15.1488 3.8941 15.1504 5.10352L15.1504 5.10449L15.1465 6.10059L15.1338 6.23242C15.1079 6.36202 15.044 6.48232 14.9492 6.57715C14.8229 6.70349 14.6513 6.77436 14.4727 6.77441C14.294 6.77441 14.1225 6.70341 13.9961 6.57715C13.8697 6.4508 13.7989 6.27926 13.7988 6.10059L13.7988 5.10449L13.7939 4.94531C13.7536 4.15165 13.421 3.39863 12.8564 2.83398C12.2544 2.23179 11.4375 1.89301 10.5859 1.8916L5.42676 1.8916L5.26758 1.89551C4.47112 1.93575 3.71506 2.27041 3.14844 2.83691C2.54444 3.44103 2.20427 4.25998 2.20313 5.11426L2.20313 16.8955L2.20801 17.0547C2.2482 17.8484 2.58093 18.6013 3.14551 19.166C3.71012 19.7306 4.46313 20.0642 5.25684 20.1045L5.41602 20.1084L10.5781 20.1084C11.4326 20.1075 12.2521 19.7681 12.8564 19.1641C13.4608 18.56 13.8005 17.7402 13.8018 16.8857L13.8018 15.8994L13.8145 15.7676C13.8403 15.638 13.9042 15.5177 13.999 15.4229C14.1254 15.2965 14.2969 15.2257 14.4756 15.2256C14.6542 15.2256 14.8258 15.2966 14.9521 15.4229C15.0785 15.5492 15.1503 15.7207 15.1504 15.8994L15.1504 16.8867L15.1445 17.1133C15.0873 18.2423 14.6127 19.313 13.8096 20.1162C12.9528 20.9729 11.7917 21.4556 10.5801 21.457L5.41602 21.457Z"
                                        fill="#222222"
                                        stroke="#222222"
                                        strokeWidth="0.3"
                                    />
                                </svg>
                            </button>
                        </div>
                    </>
                )}
            </div>
            {/*  */}

            {loading ? (
                isPounceAgent ? (
                    <>
                        <PounceSkeleton />
                        <footer className={pounceStyles.pounceFooter}>
                            <div className={pounceStyles.shimmer} style={{ width: 44, height: 28, borderRadius: 6 }} />
                            <div className={pounceStyles.shimmer} style={{ width: 44, height: 28, borderRadius: 6 }} />
                            <div className={pounceStyles.shimmer} style={{ width: 44, height: 28, borderRadius: 6 }} />
                            <div className={pounceStyles.shimmer} style={{ width: 44, height: 28, borderRadius: 6 }} />
                        </footer>
                    </>
                ) : (
                    <>
                        <div className={styles.skeletonContainer}>
                            {/* Setup Progress Skeleton */}
                            <div className={styles.skeletonSetupProgress}>
                                <div className={styles.shimmer} style={{ width: 44, height: 44, borderRadius: "50%", flexShrink: 0 }} />
                                <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: 6 }}>
                                    <div className={styles.shimmer} style={{ width: "40%", height: 16, borderRadius: 4 }} />
                                    <div className={styles.shimmer} style={{ width: "65%", height: 12, borderRadius: 4 }} />
                                </div>
                            </div>

                            {/* Agent Card Skeleton */}
                            <div className={styles.skeletonCard}>
                                <div className={`${styles.skeletonAvatar} ${styles.shimmer}`} />
                                <div className={styles.skeletonCardInfo}>
                                    <div className={styles.shimmer} style={{ width: "60%", height: 22, borderRadius: 6 }} />
                                    <div className={styles.shimmer} style={{ width: "45%", height: 14, borderRadius: 4 }} />
                                    <div className={styles.shimmer} style={{ width: "70%", height: 18, borderRadius: 6, marginTop: 4 }} />
                                </div>
                            </div>

                            {/* Attached Action Strip Skeleton */}
                            <div className={styles.skeletonActionStrip}>
                                <div className={styles.shimmer} style={{ width: "28%", height: 36, borderRadius: 8 }} />
                                <div className={styles.shimmer} style={{ width: "28%", height: 36, borderRadius: 8 }} />
                                <div className={styles.shimmer} style={{ width: "28%", height: 36, borderRadius: 8 }} />
                            </div>

                            {/* Public URL Box Skeleton */}
                            <div className={`${styles.skeletonUrlBox} ${styles.shimmer}`} />

                            {/* Call Analytics Heading Skeleton */}
                            <div className={styles.shimmer} style={{ width: "40%", height: 28, borderRadius: 6, marginTop: 10 }} />

                            {/* 4 Analytics Tiles Skeleton */}
                            <div className={styles.skeletonTiles}>
                                <div className={`${styles.skeletonTile} ${styles.shimmer}`} />
                                <div className={`${styles.skeletonTile} ${styles.shimmer}`} />
                                <div className={`${styles.skeletonTile} ${styles.shimmer}`} />
                                <div className={`${styles.skeletonTile} ${styles.shimmer}`} />
                            </div>
                        </div>

                        {/* Receptionist Floating Footer Skeleton */}
                        <div className={styles.skeletonNavbar}>
                            <div className={styles.shimmer} style={{ width: 36, height: 36, borderRadius: 10 }} />
                            <div className={styles.shimmer} style={{ width: 36, height: 36, borderRadius: 10 }} />
                            <div className={styles.skeletonCreateWrapper}>
                                <div className={`${styles.skeletonCreateBtn} ${styles.shimmer}`} />
                            </div>
                            <div className={styles.shimmer} style={{ width: 36, height: 36, borderRadius: 10 }} />
                            <div className={styles.shimmer} style={{ width: 36, height: 36, borderRadius: 10 }} />
                        </div>
                    </>
                )
            ) : isPounceAgent ? (
                <>
                    <PounceOverview
                        agentData={agentData}
                        agentId={agentId}
                        range={pounceRange}
                        // Date-range pill: pehle header me tha, ab "Call Analytics"
                        // heading ke daayein. State (pounceRange) yahin rehta hai.
                        rangeControl={
                            <label className={pounceStyles.rangePill}>
                                <span className={pounceStyles.rangeText}>
                                    <span className={pounceStyles.rangeLabel}>
                                        {POUNCE_RANGES.find((r) => r.key === pounceRange)?.label || "Today"}
                                    </span>
                                    <span className={pounceStyles.rangeDate}>
                                        {pounceRange === "today" || pounceRange === "yesterday"
                                            ? pounceFormatShortDate(pounceRangeBounds(pounceRange).from)
                                            : pounceFormatDayRange(pounceRangeBounds(pounceRange).from, new Date())}
                                    </span>
                                </span>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                <select
                                    className={pounceStyles.rangeSelect}
                                    value={pounceRange}
                                    onChange={(e) => setPounceRange(e.target.value)}
                                    aria-label="Date range"
                                >
                                    {POUNCE_RANGES.map((r) => (
                                        <option key={r.key} value={r.key}>
                                            {r.label}
                                        </option>
                                    ))}
                                </select>
                            </label>
                        }
                    />
                    <footer className={pounceStyles.pounceFooter}>
                        <button
                            type="button"
                            className={`${pounceStyles.pounceFooterItem} ${activePounceTab === "home" ? pounceStyles.pounceFooterActive : ""}`}
                            onClick={() => {
                                setActivePounceTab("home");
                                // Home = dashboard (saare agents), receptionist ke footer jaisa hi.
                                navigate("/dashboard");
                            }}
                        >
                            <HomeIcon />
                            <span>Home</span>
                        </button>
                        {/* Team: call logs ki permission na ho to Leads tab nahi. */}
                        {canViewCallLogs && (
                        <button
                            type="button"
                            className={`${pounceStyles.pounceFooterItem} ${activePounceTab === "leads" ? pounceStyles.pounceFooterActive : ""}`}
                            onClick={() => {
                                setActivePounceTab("leads");
                                // "New Leads" tile wala hi page — poori leads list.
                                navigate("/leads");
                            }}
                        >
                            <LeadsIcon />
                            <span>Leads</span>
                        </button>
                        )}
                        {/* Team: appointments ki permission na ho to ye tab nahi. */}
                        {canViewAppointments && (
                        <button
                            type="button"
                            className={`${pounceStyles.pounceFooterItem} ${activePounceTab === "appointments" ? pounceStyles.pounceFooterActive : ""}`}
                            // Team member: sirf jise appointments dekhne ka haq ho.
                            disabled={!canViewAppointments}
                            style={canViewAppointments ? undefined : { opacity: 0.45, cursor: "not-allowed" }}
                            onClick={() => {
                                setActivePounceTab("appointments");
                                // Appointments page isi agent ki list dikhata hai.
                                if (agentId) sessionStorage.setItem("SelectAgentId", agentId);
                                navigate("/pounce-appointments");
                            }}
                        >
                            <AppointmentsIcon />
                            <span>Appointments</span>
                        </button>
                        )}
                        {/* Receptionist wali hi Integrations screen, par sirf MCP (mcpOnly). */}
                        <button
                            type="button"
                            className={`${pounceStyles.pounceFooterItem} ${activePounceTab === "integrations" ? pounceStyles.pounceFooterActive : ""}`}
                            disabled={!canEditAgents}
                            style={canEditAgents ? undefined : { opacity: 0.45, cursor: "not-allowed" }}
                            onClick={() => {
                                setActivePounceTab("integrations");
                                navigate("/integrations", {
                                    state: {
                                        agentId: agentData?.agent?.agent_id,
                                        businessId: agentData?.agent?.businessId,
                                        mcpOnly: true,
                                    },
                                });
                            }}
                        >
                            <IntegrationsIcon />
                            <span>Integrations</span>
                        </button>
                        <button
                            type="button"
                            className={`${pounceStyles.pounceFooterItem} ${activePounceTab === "settings" ? pounceStyles.pounceFooterActive : ""}`}
                            // Settings = edit. Support ko sirf tab jab owner ne diya ho.
                            disabled={!canEditAgents}
                            style={canEditAgents ? undefined : { opacity: 0.45, cursor: "not-allowed" }}
                            onClick={() => {
                                setActivePounceTab("settings");
                                // Settings hub isi agent ke liye khule; Calling
                                // Settings (/call-setting) uske andar se khulta hai.
                                if (agentId) sessionStorage.setItem("SelectAgentId", agentId);
                                navigate("/outbound-settings");
                            }}
                        >
                            <SettingsIcon />
                            <span>Settings</span>
                        </button>
                    </footer>
                </>
            ) : showDraftView ? (
                /*
                  Draft Agent view — 0-agent users (abandoned onboarding,
                  fresh accounts, etc.). Replaces the regular agent
                  details body with a single resume-or-discard card so
                  the user has an actionable path forward instead of
                  being bounced into a fresh /fork flow that loses the
                  partial state. Mirrors Dashboard's Draft Agent card.
                */
                <div
                    style={{
                        padding: "24px 18px 60px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 16,
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            maxWidth: 420,
                            background: "#fff",
                            border: "1.5px solid #E0E5F2",
                            borderRadius: 16,
                            padding: "20px",
                            boxShadow: "0 8px 24px -8px rgba(15, 23, 42, 0.10)",
                        }}
                    >
                        <span
                            style={{
                                display: "inline-block",
                                padding: "4px 10px",
                                borderRadius: 999,
                                background: "#F3EEFF",
                                color: "#6524EB",
                                fontSize: 12,
                                fontWeight: 700,
                                letterSpacing: "0.04em",
                                textTransform: "uppercase",
                                marginBottom: 12,
                            }}
                        >
                            Draft Agent
                        </span>
                        <h3
                            style={{
                                margin: "0 0 8px",
                                fontSize: 18,
                                fontWeight: 700,
                                color: "#24252C",
                                lineHeight: 1.3,
                            }}
                        >
                            Finish setting up your first agent to start
                            automating your inbound calls.
                        </h3>
                        <p
                            style={{
                                margin: "0 0 18px",
                                fontSize: 14,
                                color: "#6E6A7C",
                                lineHeight: 1.5,
                            }}
                        >
                            You started setup but haven't completed it yet.
                            Pick up where you left off, or discard the
                            draft and start fresh.
                        </p>
                        {/* Completing / discarding a half-built agent is an
                            agent-CREATE action — locked for ALL team members
                            (admin included); only the owner can finish setup. */}
                        <LockOverlay locked={isTeamMember}>
                            <div style={{ display: "flex", gap: 10 }}>
                                <button
                                    type="button"
                                    onClick={() => setShowDiscardDraftModal(true)}
                                    style={{
                                        flex: "0 0 auto",
                                        padding: "12px 16px",
                                        background: "#fff",
                                        border: "1.5px solid #E0E5F2",
                                        borderRadius: 12,
                                        color: "#6E6A7C",
                                        fontWeight: 600,
                                        fontSize: 14,
                                        cursor: "pointer",
                                    }}
                                >
                                    Discard
                                </button>
                                <button
                                    type="button"
                                    onClick={handleDraftContinue}
                                    style={{
                                        flex: "1 1 auto",
                                        padding: "12px 16px",
                                        background: "#6524EB",
                                        border: "none",
                                        borderRadius: 12,
                                        color: "#fff",
                                        fontWeight: 700,
                                        fontSize: 14,
                                        cursor: "pointer",
                                        boxShadow:
                                            "0 6px 18px -4px rgba(101, 36, 235, 0.45)",
                                    }}
                                >
                                    Continue Setup →
                                </button>
                            </div>
                        </LockOverlay>
                    </div>
                </div>
            ) : (
                <>
                    {!notificatioView ? (
                        <>
                            {/* Connect-Drive reminder strip — only for Law Firm
                                agents on a paid plan whose Drive isn't linked
                                yet. Clicking re-opens the popup; the strip
                                disappears once the user actually connects. */}
                            {isLawFirmAgent && isPaidPlanAgent && driveConnected === false && !isRestrictedTeamMember && (
                                <div
                                    onClick={() => setShowDrivePopup(true)}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" || e.key === " ") setShowDrivePopup(true);
                                    }}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 10,
                                        padding: "10px 14px",
                                        margin: "0 0 12px",
                                        background: "linear-gradient(135deg, #fff4e0, #ffe6b8)",
                                        border: "1px solid #f1c27b",
                                        borderRadius: 10,
                                        cursor: "pointer",
                                        fontSize: 13,
                                        fontWeight: 600,
                                        color: "#7a4b00",
                                        boxShadow: "0 2px 6px rgba(241, 194, 123, 0.25)",
                                    }}
                                >
                                    <span style={{ fontSize: 16 }}>🔗</span>
                                    <span style={{ flex: 1 }}>
                                        Connect Google Drive — your agent needs Drive to attend calls.
                                    </span>
                                    <span style={{ fontSize: 12, fontWeight: 700, color: "#6524eb" }}>
                                        Connect →
                                    </span>
                                </div>
                            )}

                            {/* "$5/month — For real calls" banner commented out.
                                The new flow routes Assign Number through
                                /recommended-plan, so the standalone PAYG banner
                                is no longer needed. */}
                            {/* {!hasVoipNumbers && (
                                <div>
                                    <RealCalls
                                        agentData={agentData}
                                        isPaidPlan={
                                            !!agent?.agentPlan &&
                                            (agent.agentPlan.toLowerCase() !== "free" && agent.agentPlan.toLowerCase() !== "demo")
                                        }
                                        onTestCall={handleTestCallClick}
                                        onAssignNumber={handleAssignNumberClick}
                                    />
                                </div>
                            )} */}

                            {/* Great Progress — the single setup card on this
                                page for BOTH free and paid users (the purple
                                SetupScoreCard ladder was retired). Shows the
                                real setup-score percent and hides once setup
                                is complete. Continue routing (handleSetupContinue):
                                  - free users  → resume the onboarding ladder
                                    where they left off (in-place CallTest modal
                                    for the test-call step);
                                  - paid users  → /setup-ready.
                                Gating mirrors the old card: hidden until the
                                score has loaded, at 100%, for team members (who
                                can't drive payment/plan steps), and for
                                cancelled/deactivated agents (they re-subscribe
                                via the Activate button, not this ladder). */}
                            {(() => {
                                const percent = Number(setupScore?.percent) || 0;
                                if (!setupScore) return null;
                                // Wahi flag jo More menu ki entry chalata hai —
                                // ek jagah se, taaki page aur menu kabhi alag
                                // baat na kahein.
                                if (isSetupComplete) return null;
                                // Retire the bar from the page (it moves into the
                                // More menu) after the first-week window OR once the
                                // agent is deactivated / subscription-cancelled.
                                // Replaces the old `agent?.isDeactivated === 1`
                                // check, which missed the boolean `true` the
                                // post-cancel re-fetch returns.
                                if (retireSetupBar) return null;
                                // Setup/activation ladder is owner-only (it drives
                                // create/plan steps) — hidden for ALL team members.
                                if (isTeamMember) return null;
                                return (
                                    // 2px upar — card ki top shadow header ke
                                    // neeche kati hui na lage. Sirf is page pe;
                                    // More menu wala SetupProgress waisa hi.
                                    <div style={{ paddingTop: 2 }}>
                                        <SetupProgress
                                            percent={percent}
                                            onContinue={handleSetupContinue}
                                        />
                                    </div>
                                );
                            })()}
                            <CaughtBanner
                                callCount={agentData?.callSummary?.totalCalls ?? 0}
                                agentName={agentData?.agent?.agentName}
                                // Show the "No calls yet" modal only after the
                                // intro tour finishes (tooltip tour goes first)
                                // AND no other popup is open — this is the
                                // lowest-priority popup, so it waits for the
                                // summary / push / contacts / drive / calendar ones.
                                //
                                // NOTE: the old branch also had `&& !popupGapActive`
                                // here. That flag belongs to the one-popup-at-a-time
                                // gap mechanism, which is NOT in live yet (item 1 of
                                // the nudges port list) — referencing it now would
                                // throw. Add that clause when the gap lands.
                                onboardingReady={
                                    tourDone && !isTourOpen &&
                                    !summaryOpen && !pushPermissionOpen &&
                                    !showContactSyncPopup && !showDrivePopup &&
                                    !showCalendarReminder
                                }
                                // "No calls yet" call-forwarding popup is a
                                // paid-only nudge. Free/demo agents have no
                                // live number to forward, so gate it here. Also
                                // suppress it for support team members — call
                                // forwarding is an owner/admin setup action they
                                // have no permission for, so the nudge must not
                                // show. Admins (owner-equivalent) still see it.
                                noCallsEligible={isPaidPlanAgent && !isRestrictedTeamMember}
                                // First-call celebration — CaughtBanner fetches
                                // the latest call itself using this agentId.
                                agentId={agentData?.agent?.agent_id}
                                // "Test My Forwarding" (and the "Test your call
                                // forwarding" row) → the forwarding test screen,
                                // which runs the actual startForwardingTestCall
                                // flow. Was previously unwired, so the button
                                // did nothing.
                                onTestForwarding={() => navigate("/forward-instructions")}
                            />

                            {/*
                              Upgrade banner. "EXPLORE PLANS" SEEDHA navigate
                              karta hai — koi confirm popup nahi.

                              Isliye yahan handleUpgradeClick jaata hai,
                              openUpgradeConfirm nahi. Dono ka farq bas itna
                              hai: openUpgradeConfirm pehle "Upgrade Plan?"
                              modal kholta hai aur uska Upgrade button phir
                              handleUpgradeClick chalata hai. Banner khud hi ek
                              deliberate tap hai, uspe dobara "sure?" poochhna
                              ek extra kadam hai. Confirm popup sirf More
                              Setting ke "Upgrade Agent" pe rehta hai (wahan
                              user menu browse kar raha hota hai, galti se tap
                              ho sakta hai).

                              Routing dono me ek hi hai, to plans/trial/$5 ka
                              faisla waise ka waisa rehta hai.

                              Do gates:

                              1. showUpgradeBanner — sirf $5 PAYG aur 21-day
                                 trial wale agents (upar dekho, wahan wajah
                                 likhi hai).

                              2. Restricted team members ko chhupa dete hain:
                                 payment owner ka kaam hai, aur FooterNew bhi
                                 inhi ke liye "Upgrade Agent" entry hata deta
                                 hai (wahan `undefined` bhejte hain). Banner
                                 dikhta to woh gating bekaar ho jaati.
                            */}
                            {showUpgradeBanner && !isRestrictedTeamMember && (
                                <UpgradeBanner onExplorePlans={handleUpgradeClick} />
                            )}

                            <AgentCardDetail
                                agentData={agentData}
                                onTestCall={handleTestCallClick}
                                onAssignNumber={handleAssignNumberClick}
                                isRefresh={() => setRefresh((prev) => prev + 1)}
                                driveLocked={driveLocked}
                                driveLockMessage={DRIVE_LOCK_MESSAGE}
                            />
                            <SparkleLine />
                            {/* Number gate removed — AgentAnalysis
                                ab hamesha dikhte hain, chahe agent ke paas VOIP
                                number ho ya na ho. Pehle hasVoipNumbers false
                                hone par sirf demo CallAnalysis dikhta tha. */}
                            <div className={styles.agentAnalysisMain}>
                                <AgentAnalysis
                                    agentId={agentDetails?.agentId}
                                    data={agentData?.callSummary?.data}
                                    calApiKey={agentData?.agent?.calApiKey}
                                    callVolume={agentData?.callSummary?.totalCalls}
                                />
                            </div>
                        </>
                    ) : (
                        /*
                         * onAction closes this panel. NotificationView calls it
                         * ONLY when the notification's destination is this same
                         * /fast-agent-detail route — there is no unmount in that
                         * case, so without it the panel would stay open on top of
                         * the dashboard the user was just sent to. For a
                         * cross-route destination it deliberately does NOT fire:
                         * navigating unmounts this whole screen (and the panel
                         * with it), and closing first would flash the dashboard
                         * for ~1s before the new route lands.
                         */
                        <NotificationView
                            onAction={() => setNotificationsView(false)}
                        />
                    )}

                    <FooterNew
                        agentData={agentData}
                        onTestCall={handleTestCallClick}
                        onAssignNumber={handleAssignNumberClick}
                        driveLocked={driveLocked}
                        driveLockMessage={DRIVE_LOCK_MESSAGE}
                        /*
                          Native-only Drive connect (More menu → CONNECT_DRIVE bridge).
                          FooterNew has always FIRED this after a successful native
                          connect, but nothing ever passed it, so the call was a no-op
                          and only FooterNew's OWN local driveConnected flipped — this
                          component's stayed false, `driveLocked` stayed true, and the
                          three menu entries plus the public widget URL stayed hidden
                          until a manual reload.

                          Web never hit it: that path leaves the page for Google OAuth
                          and returns to /fast-agent-detail?drive=connected, where the
                          effect above re-checks on a fresh load. The native bridge runs
                          in-place — no redirect, nothing re-checks, so the host has to
                          be told.

                          Same body as ConnectDrivePopup's onConnected below, so all
                          three connect paths (popup, web OAuth return, native bridge)
                          leave this component in one identical state.
                        */
                        onDriveStatusChange={() => {
                            setDriveConnected(true);
                            setShowDrivePopup(false);
                            setPopupType("success");
                            setPopupMessage(
                                "Drive connected. Your agent can now save call recordings."
                            );
                        }}
                        /*
                          Retired setup bar's replacement entry. Same `retireSetupBar`
                          flag that hides the on-page bar above, so the bar and this
                          menu icon can never both be visible or both be missing.
                          Team members never drive the setup ladder, so they get
                          neither surface — mirroring the bar's own isTeamMember gate.
                          onSetupScore reuses the retired Continue button's handler,
                          so the destination is identical to what the bar did.
                        */
                        showSetupScoreEntry={
                            retireSetupBar && !isTeamMember && !isSetupComplete
                        }
                        onSetupScore={handleSetupContinue}
                        setupScorePercent={Number(setupScore?.percent) || 0}
                        /*
                          Team-member gating — payment / destructive
                          subscription actions are owner-only. Passing
                          `undefined` makes FooterNew skip those menu
                          entries entirely (it already checks each prop
                          before pushing the option). Mirrors the
                          Dashboard pattern that wrapped these items in
                          <LockOverlay locked={isTeamMember}>.
                        */
                        onUpgrade={isRestrictedTeamMember ? undefined : openUpgradeConfirm}
                        onDelete={isOwnAgent ? openDeleteConfirm : undefined}
                        onDeactivate={isRestrictedTeamMember ? undefined : openDeactivateConfirm}
                        /* PAYG handler kept wired but the menu entry
                           inside FooterNew is now commented out; the
                           Cancel Subscription action below replaces it. */
                        onTogglePayg={isRestrictedTeamMember ? undefined : openPaygConfirm}
                        isPaygActive={isPaygActive}
                        paygStatusLoading={paygStatusLoading}
                        /*
                          Cancel Subscription — only exposed for
                          actual paying agents. Free / demo plans
                          have nothing to cancel, so we pass undefined
                          and FooterNew silently skips the menu entry.
                          Plan strings checked case-insensitively to
                          tolerate "Free" / "free" / "Demo" / "demo".
                          Team members never see this regardless of
                          plan — payment is owner-only.

                          "appsumo" is excluded for the same reason: that
                          lifetime deal was bought on AppSumo's checkout, not
                          ours, so there is no subscription of ours to cancel.
                          The entry returns once they upgrade —
                          updateAgentSubscription overwrites agentPlan with the
                          real plan name (starter / scaler / growth) and attaches
                          the Stripe subscriptionId.
                        */
                        // Show Usage & Billing whenever the agent is on a paid plan
                        // OR has EVER had one (canReactivate ⇒ a prior subscription
                        // exists). A brand-new free agent that never subscribed
                        // doesn't see it; a cancelled agent reverted to free keeps
                        // it — they still need invoices + the Reactivate panel.
                        showUsageBilling={!isRestrictedTeamMember && (isPaidPlanAgent || !!reactivation?.canReactivate)}
                        onCancelSubscription={(() => {
                            if (isRestrictedTeamMember) return undefined;
                            // Plan already ended (PAYG keeps agentPlan after it ends): nothing left to cancel.
                            if (isSubscriptionCanceled || (isPaygSwitchedOff && !isSubscriptionCancelScheduled)) return undefined;
                            const planLower = (agentData?.agent?.agentPlan || "")
                                .toString()
                                .trim()
                                .toLowerCase();
                            const isFreeOrDemo =
                                planLower === "" ||
                                planLower === "free" ||
                                planLower === "demo" ||
                                planLower === "appsumo";
                            return isFreeOrDemo ? undefined : openCancelSubConfirm;
                        })()}
                        /*
                          Already cancelled → keep the entry visible but locked.
                          Only the IMMEDIATE (refund-eligible) cancel path turns the
                          agent free + deactivated, which is what made the entry
                          disappear on its own. The SCHEDULED path — taken whenever
                          the customer is not refund-eligible, and now always for
                          trial packs and PAYG — deliberately leaves the agent alive
                          with its plan intact, so nothing above changed and the
                          user could cancel the same subscription again and again.

                          `cancel_scheduled` / `payment_canceled_on_end` are written
                          by handleSubscriptionCanceled (stripeModel) and already
                          arrive on this page: fetchAgentDetailsById returns the
                          Subscription row as `data.subscription`. Server truth, so
                          it survives a reload, cleared storage and a device change —
                          and it clears itself the moment a new active subscription
                          replaces the cancelled one, with no marker to reset.
                        */
                        cancelSubscriptionLocked={isSubscriptionCancelScheduled}
                        cancelSubscriptionLockMessage={
                            cancelScheduledUntil
                                ? `Your subscription is already cancelled and stays active until ${cancelScheduledUntil}.`
                                : "Your subscription is already cancelled."
                        }
                    />
                </>
            )}

            {openCallModal && (
                <Modal3
                    isOpen={openCallModal}
                    onClose={closeCallTestModal}
                    isEndingRef={isEndingRef}
                >
                    <CallTest
                        isCallActive={isCallActive}
                        onStartCall={handleStartCall}
                        onEndCall={handleEndCall}
                        callLoading={callLoading}
                        setCallLoading={setCallLoading}
                        agentName={agentData?.agent?.agentName}
                        agentAvatar={agentData?.agent?.avatar}
                        businessName={
                            agentData?.business?.businessName ||
                            agentData?.business?.googleBusinessName ||
                            agentData?.knowledge_base_texts?.name
                        }
                        isEndingRef={isEndingRef}
                    />
                </Modal3>
            )}

            {popupMessage && (
                <PopUp
                    type={popupType}
                    message={popupMessage}
                    onClose={() => setPopupMessage("")}
                    onConfirm={handleLogoutConfirm}
                />
            )}
            {/*
              * Post-onboarding "Sophia is Live" dialog — opens once
              * when the user lands here from the contact-sync screen
              * (gated by sessionStorage flag set by ContactSyncStep).
              * setupSummary mode renders the 6-row status card; user
              * MUST tap Okay (no backdrop / ESC dismiss) so the next
              * step (intro.js tour) kicks off from a known state.
              */}
            <SophiaReadyDialog
                open={summaryOpen}
                mode="setupSummary"
                agentName={agent?.agentName || "Sophia"}
                agentAvatar={agent?.avatar || agent?.agentAvatar || "/svg/receptionist_profile.png"}
                businessName={
                    agentData?.business?.businessName ||
                    agentData?.business?.googleBusinessName ||
                    agentData?.knowledge_base_texts?.name ||
                    "your business"
                }
                loading={!summaryItems}
                setupItems={summaryItems || []}
                onOkay={handleSummaryOkay}
            />
            <UnlockNumberModal isOpen={showUpgradeConfirmModalAssign} onClose={() => setShowUpgradeConfirmModalAssign(false)} onUpgrade={handleAssignNum} />

            {/* Assign-Number popup — Activate Trial vs View Plans split.
                Custom bottom-sheet (not FreeTrialModal) so the design
                matches the Figma: large avatar on the left, headline +
                subtitle on the right, dashed divider, two stacked-pair
                action buttons. Replaces the old direct-navigate to
                /recommended-plan that used to fire from AgentCardDetail
                / FooterNew Assign Number buttons. */}
            {showAssignPopup && (
                <div
                    className={styles.assignSheetOverlay}
                    onClick={() => {
                        if (trialLoading) return;
                        setShowAssignPopup(false);
                        setTrialError("");
                    }}
                >
                    <div
                        className={styles.assignSheet}
                        onClick={(e) => e.stopPropagation()}
                        role="dialog"
                        aria-modal="true"
                    >
                        <div className={styles.assignPopupHead}>
                            <div className={styles.assignPopupAvatar}>
                                <img
                                    src={
                                        agentData?.agent?.agentAvatar ||
                                        "/svg/receptionist_profile.png"
                                    }
                                    alt={agentData?.agent?.agentName || "Agent"}
                                    onError={(e) => {
                                        e.currentTarget.src = "/svg/receptionist_profile.png";
                                    }}
                                />
                                <span className={styles.assignPopupAvatarBadge} aria-hidden="true" />
                            </div>
                            <div className={styles.assignPopupHeadText}>
                                <h3 className={styles.assignPopupTitle}>
                                    Unlock {agentData?.agent?.agentName || "your agent"}'s
                                    <br />
                                    full potential
                                </h3>
                                <p className={styles.assignPopupSubtitle}>
                                    Choose a <strong>plan</strong> or <strong>Start your
                                        trial</strong> to unlock smart receptionist features
                                </p>
                            </div>
                        </div>

                        <ul className={styles.assignPopupBullets}>
                            {[
                                "Smart calendar & meeting sync",
                                "AI-powered spam call protection",
                                "Automated booking workflows",
                            ].map((item) => (
                                <li key={item} className={styles.assignPopupBullet}>
                                    <span className={styles.assignPopupTick}>
                                        <img src="/svg/green-check.svg" alt="" />
                                    </span>
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>

                        <div className={styles.assignPopupDivider} />

                        {trialError && (
                            <p className={styles.assignPopupError}>{trialError}</p>
                        )}

                        <div className={styles.assignPopupActions}>
                            <button
                                type="button"
                                className={`${styles.assignPopupBtn} ${styles.assignPopupBtnGhost}`}
                                onClick={handleActivateTrialFromAssignPopup}
                                disabled={trialLoading}
                            >
                                {trialLoading ? "Redirecting…" : "Activate Trial"}
                            </button>
                            <button
                                type="button"
                                className={`${styles.assignPopupBtn} ${styles.assignPopupBtnPrimary}`}
                                onClick={handleViewPlansFromAssignPopup}
                                disabled={trialLoading}
                            >
                                View Plans
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <ContactSyncPopup
                isOpen={showContactSyncPopup}
                onClose={() => {
                    setShowContactSyncPopup(false);
                    setIsSyncSkipContact(true);
                    sessionStorage.removeItem("isAgentCreated");
                    setRefresh((prev) => prev + 1);
                }}
                onSyncComplete={() => {
                    setShowContactSyncPopup(false);
                    setIsSyncSkipContact(true);
                    setRefresh((prev) => prev + 1);
                }}
            />

            <ConnectDrivePopup
                isOpen={showDrivePopup}
                userId={userId}
                agentId={agent?.agent_id}
                onClose={() => setShowDrivePopup(false)}
                onConnected={() => {
                    setDriveConnected(true);
                    setPopupType("success");
                    setPopupMessage("Drive connected. Your agent can now save call recordings.");
                }}
            />

            {/* ----- Upgrade confirm modal (paid plans only) ----- */}
            {showUpgradeConfirmModal && (
                <div className={styles.modalBackdrop} onClick={() => setShowUpgradeConfirmModal(false)}>
                    <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                        <h2>Upgrade Plan</h2>
                        <p>Continue to the plans page to upgrade <strong>{agent?.agentName}</strong>?</p>
                        <div className={styles.modalButtons}>
                            <button
                                className={`${styles.modalButton} ${styles.cancel}`}
                                onClick={() => setShowUpgradeConfirmModal(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className={`${styles.modalButton} ${styles.submit}`}
                                onClick={() => {
                                    setShowUpgradeConfirmModal(false);
                                    handleUpgradeClick();
                                }}
                            >
                                {upgradeLoading ? <>Redirecting <Loader size={16} /></> : "Upgrade"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ----- Delete confirm modal ----- */}
            {showDeleteConfirm && agent && (() => {
                const totalMins = Number(agent?.subscription?.plan_mins) || 0;
                const minsLeft = agent?.mins_left || 0;
                const usedPercentage = totalMins > 0 ? ((totalMins - minsLeft) / totalMins) * 100 : 100;
                const currentPeriodStart = agent?.subscription?.current_period_start;
                const subscriptionAgeDays = currentPeriodStart
                    ? dayjs().diff(dayjs(currentPeriodStart), "day")
                    : Infinity;
                const isRefundEligible = usedPercentage < 10 && subscriptionAgeDays <= 7;
                return (
                    <div className={styles.modalBackdrop} onClick={() => setShowDeleteConfirm(false)}>
                        <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                            <h2>Are you sure?</h2>
                            <p>Do you want to delete agent <strong>{agent.agentName}</strong>?</p>
                            {agent?.subscription && (
                                <p style={{ marginTop: "12px" }}>
                                    {isRefundEligible
                                        ? "Since this agent's subscription is within 7 days and less than 10% of minutes are used, a refund (minus a 3% payment processing fee) will be issued to the original payment method within 5–7 business days."
                                        : "This subscription is either older than 7 days or more than 10% of the minutes are used. No refund will be provided per our policy."}
                                </p>
                            )}
                            <div className={styles.modalButtons}>
                                <button
                                    className={`${styles.modalButton} ${styles.cancel}`}
                                    onClick={() => setShowDeleteConfirm(false)}
                                >
                                    No
                                </button>
                                <button
                                    className={`${styles.modalButton} ${styles.submit}`}
                                    onClick={handleDelete}
                                >
                                    {deleteloading ? <>Deleting <Loader size={16} /></> : "Yes"}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* ----- Deactivate / Activate confirm modal ----- */}
            {showDeactivateConfirm && agent && (() => {
                const isAgentDeactivated = !!agent?.isDeactivated;
                // Cancelled-subscription branch — Stripe sub-deleted
                // webhook leaves the agent with isDeactivated=1 AND
                // agentPlan="free". Reactivation requires picking a new
                // plan; we route to /recommended-plan instead of just
                // flipping isDeactivated.
                const planLower = (agent?.agentPlan || "")
                    .toString()
                    .trim()
                    .toLowerCase();
                const isCancelledReactivate =
                    isAgentDeactivated &&
                    (planLower === "" ||
                        planLower === "free" ||
                        planLower === "demo");

                // ----- Pause (deactivate) flow — shown inside NewModal with a
                // short "reason for pausing" feedback step. Same action wiring
                // (handleDeactivateAgent); the reason is UI-only feedback.
                if (!isAgentDeactivated) {
                    const pauseReasons = [
                        "Taking a temporary break",
                        "Low call volume",
                        "Too expensive",
                        "Other reason",
                    ];
                    /*
                     * Same rule as the Cancel Subscription modal: a reason must
                     * be picked, and "Other reason" additionally needs trimmed
                     * text. Pausing is reversible, so this is about answering
                     * the form rather than guarding a destructive action — but
                     * the two modals sit side by side in the same More menu and
                     * behaving differently would just read as a bug.
                     */
                    const pauseOtherFilled = deactivateOtherText.trim().length > 0;
                    const canConfirmPause =
                        !!deactivateReason &&
                        (deactivateReason !== "Other reason" || pauseOtherFilled);
                    return (
                        <NewModal
                            isOpen={showDeactivateConfirm}
                            onClose={() => !deactivateLoading && setShowDeactivateConfirm(false)}
                            title={null}
                            height="auto"
                            bodyMaxHeight="90vh"
                        >
                            <div className={styles.deactivateModal}>
                                <div className={styles.deactivateIcon}>
                                    <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="27.5" cy="27.5" r="27.5" fill="#FBE6EB" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M32.4962 18.9751C32.4964 19.6504 32.3331 20.3158 32.0202 20.9142C31.7074 21.5127 31.2543 22.0266 30.6997 22.4119C30.1451 22.7973 29.5055 23.0426 28.8355 23.1271C28.1655 23.2115 27.485 23.1325 26.8521 22.8968L29.3485 25.8716C30.574 25.6873 31.7283 25.1798 32.6926 24.4014C33.6568 23.6229 34.3962 22.6016 34.8347 21.4425C35.2732 20.2834 35.395 19.0283 35.1874 17.8066C34.9799 16.5848 34.4506 15.4404 33.6539 14.4911C32.8573 13.5418 31.8221 12.8219 30.6549 12.4055C29.4877 11.9891 28.2306 11.8912 27.013 12.1219C25.7953 12.3526 24.6612 12.9036 23.7272 13.7181C22.7932 14.5327 22.0931 15.5813 21.699 16.7563L24.1968 19.7338C24.0922 19.1622 24.1078 18.5751 24.2426 18.0099C24.3774 17.4447 24.6285 16.9137 24.9799 16.4509C25.3312 15.9881 25.7751 15.6035 26.2833 15.3217C26.7915 15.0399 27.3528 14.8671 27.9315 14.8142C28.5101 14.7613 29.0935 14.8295 29.6443 15.0145C30.1952 15.1995 30.7014 15.4972 31.1309 15.8886C31.5603 16.2801 31.9035 16.7567 32.1386 17.2881C32.3737 17.8195 32.4955 18.3941 32.4962 18.9751ZM24.1661 28.9217L15.2265 18.3503C15.1008 18.2117 15.0043 18.0491 14.9428 17.8724C14.8812 17.6956 14.8559 17.5083 14.8683 17.3216C14.8807 17.1348 14.9305 16.9525 15.0148 16.7854C15.0991 16.6184 15.2162 16.47 15.3591 16.3491C15.502 16.2282 15.6677 16.1373 15.8465 16.0819C16.0252 16.0264 16.2133 16.0075 16.3995 16.0262C16.5857 16.0449 16.7662 16.1009 16.9303 16.1909C17.0944 16.2809 17.2387 16.4029 17.3547 16.5499L38.5434 41.6017C38.7823 41.8841 38.8993 42.2499 38.8686 42.6185C38.8378 42.9872 38.6619 43.3285 38.3795 43.5675C38.0971 43.8064 37.7314 43.9234 37.3627 43.8926C36.9941 43.8619 36.6527 43.686 36.4138 43.4036L34.2688 40.8667C33.3643 41.1477 32.4225 41.2902 31.4754 41.2893H25.1493C22.6593 41.2893 20.2712 40.3001 18.5105 38.5394C16.7498 36.7787 15.7606 34.3907 15.7606 31.9006C15.7606 31.3539 16.0479 30.8519 16.55 30.6357C17.7075 30.1392 20.1704 29.2927 24.1661 28.9217ZM32.2313 38.4568C31.983 38.4847 31.7306 38.5 31.4754 38.5H25.1493C23.5606 38.4999 22.0253 37.9268 20.8251 36.886C19.6249 35.8451 18.8403 34.4063 18.6154 32.8336C20.0421 32.3539 22.579 31.7277 26.4031 31.5659L32.2313 38.4568ZM31.8645 28.8715L34.4808 31.9885C35.6777 32.1752 36.8576 32.4578 38.0092 32.8336C37.8911 33.672 37.6117 34.4794 37.1864 35.2115L39.0552 37.4415C40.2334 35.8346 40.8672 33.8932 40.8641 31.9006C40.8641 31.3539 40.5768 30.8519 40.0747 30.6357C38.8614 30.1141 36.2116 29.2104 31.8645 28.8715Z" fill="#E4133C" />
                                    </svg>

                                </div>
                                <h2 className={styles.deactivateTitle}>Deactivate Agent?</h2>
                                <p className={styles.deactivateDesc}>
                                    Pausing stops your monthly minutes immediately.
                                    Billing resumes when you reactivate.
                                </p>

                                <div className={styles.reasonHead}>
                                    <p className={styles.reasonTitle}>What's the reason for pausing?</p>
                                    <p className={styles.reasonSub}>your feedback helps us improve</p>
                                </div>

                                <div className={styles.reasonList}>
                                    {pauseReasons.map((reason) => (
                                        <label key={reason} className={styles.reasonRow}>
                                            <span className={styles.reasonLabel}>{reason}</span>
                                            <input
                                                type="radio"
                                                name="deactivateReason"
                                                className={styles.reasonRadio}
                                                checked={deactivateReason === reason}
                                                onChange={() => setDeactivateReason(reason)}
                                            />
                                        </label>
                                    ))}
                                </div>

                                {deactivateReason === "Other reason" && (
                                    <div className={styles.reasonOtherWrap}>
                                        <textarea
                                            className={styles.reasonTextarea}
                                            placeholder="Tell us other reason..."
                                            maxLength={120}
                                            value={deactivateOtherText}
                                            onChange={(e) => setDeactivateOtherText(e.target.value)}
                                        />
                                        <span className={styles.reasonCounter}>
                                            {deactivateOtherText.length}/120
                                        </span>
                                    </div>
                                )}

                                <AnimatedButton
                                    label="Yes, Pause"
                                    isLoading={deactivateLoading}
                                    disabled={deactivateLoading || !canConfirmPause}
                                    onClick={handleDeactivateAgent}
                                    positionType="relative"
                                    width="100%"
                                    bottom="0"
                                />
                            </div>
                        </NewModal>
                    );
                }

                return (
                    <div className={styles.modalBackdrop} onClick={() => !deactivateLoading && setShowDeactivateConfirm(false)}>
                        <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                            <h2>
                                {isCancelledReactivate
                                    ? "Subscription Required"
                                    : isAgentDeactivated
                                        ? "Activate Agent"
                                        : "Deactivate Agent"}
                            </h2>
                            <p>
                                {isCancelledReactivate
                                    ? `Your subscription was cancelled, so ${agent?.agentName} can't be activated directly. Pick a plan to reactivate the agent — it will go live automatically once payment is complete.`
                                    : isAgentDeactivated
                                        ? `Are you sure you want to activate ${agent?.agentName}?`
                                        : `If you pause your voice agent service, your monthly minutes will stop immediately. Don't worry — when you reactivate, your billing cycle will resume from that day, so you'll still get all your paid time. Deactivate ${agent?.agentName}?`}
                            </p>
                            <div className={styles.modalButtons}>
                                <button
                                    className={`${styles.modalButton} ${styles.cancel}`}
                                    onClick={() => setShowDeactivateConfirm(false)}
                                    disabled={deactivateLoading}
                                >
                                    {isCancelledReactivate
                                        ? "Cancel"
                                        : isAgentDeactivated
                                            ? "No"
                                            : "Keep Active"}
                                </button>
                                <button
                                    className={`${styles.modalButton} ${styles.submit}`}
                                    onClick={
                                        isCancelledReactivate
                                            ? handleReactivateNoSub
                                            : handleDeactivateAgent
                                    }
                                >
                                    {deactivateLoading
                                        ? <>Updating <Loader size={16} /></>
                                        : isCancelledReactivate
                                            ? "Pick a Plan"
                                            : isAgentDeactivated
                                                ? "Yes"
                                                : "Yes, Pause"}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })()}

            {/* ----- PAYG confirm modal ----- */}
            {showPaygConfirm && agent && checkPaygStatus === 1 && (
                <div className={styles.modalBackdrop} onClick={() => setshowPaygConfirm(false)}>
                    <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                        <h2>Are you sure?</h2>
                        <p>
                            {isPaygActive
                                ? "Are you sure you want to deactivate Pay-As-You-Go for this agent? Once disabled, calls will no longer continue after the included minutes are used."
                                : "Activate PAYG for your agent to stay connected without limits. After your included plan minutes are used, calls will continue under PAYG. PAYG usage is billed at the end of its billing cycle."}
                        </p>
                        <p style={{ marginTop: "16px" }}>Are you sure you want to continue?</p>
                        <div className={styles.modalButtons}>
                            <button
                                className={`${styles.modalButton} ${styles.cancel}`}
                                onClick={() => setshowPaygConfirm(false)}
                            >
                                No
                            </button>
                            <button
                                className={`${styles.modalButton} ${styles.submit}`}
                                onClick={() => {
                                    handleTogglePayG();
                                    setshowPaygConfirm(false);
                                }}
                            >
                                {paygStatusLoading ? <>Working <Loader size={16} /></> : "Yes"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* PAYG-not-enabled-on-account informational popup */}
            {showPaygConfirm && (checkPaygStatus === null || checkPaygStatus === 0) && (
                <div className={styles.modalBackdrop} onClick={() => setshowPaygConfirm(false)}>
                    <div className={styles.modalContainer} onClick={(e) => e.stopPropagation()}>
                        <h2>Pay-As-You-Go not enabled</h2>
                        <p>Pay-As-You-Go is not enabled for your account. Please contact support or enable it from your billing settings to use this feature.</p>
                        <div className={styles.modalButtons}>
                            <button
                                className={`${styles.modalButton} ${styles.submit}`}
                                onClick={() => setshowPaygConfirm(false)}
                            >
                                Got it
                            </button>
                        </div>
                    </div>
                </div>
            )}


            {showDiscardDraftModal && (
                <div
                    className={styles.modalBackdrop}
                    onClick={() => setShowDiscardDraftModal(false)}
                >
                    <div
                        className={styles.modalContainer}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <h2>Discard draft agent?</h2>
                        <p style={{ marginTop: "8px" }}>
                            Your previous draft agent details will be deleted.
                            Are you sure you want to start fresh and create a
                            new agent?
                        </p>
                        <div
                            className={styles.modalButtons}
                            style={{ marginTop: "18px" }}
                        >
                            <button
                                type="button"
                                className={`${styles.modalButton} ${styles.cancel}`}
                                onClick={() => setShowDiscardDraftModal(false)}
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className={`${styles.modalButton} ${styles.submit}`}
                                onClick={handleDraftDiscardConfirmed}
                            >
                                Continue
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/*
              Cancel Subscription confirmation modal.
              Mirrors the Dashboard implementation (Dashboard.js
              "Cancel Subscription" modal at ~line 4854) so a paid
              user sees the same refund-policy copy regardless of
              which surface they cancel from. Eligibility math is
              client-side mirror of the backend's check (per
              https://www.rxpt.ai/terms-condition):
                isRefundEligible = usedPercentage < 10
                                      && subscriptionAgeDays <= 7
              Backend re-validates inside refundAndCancelSubscriptionAgnetApi
              so we don't need to trust the client computation —
              this is purely for showing the right copy upfront.
            */}
            {showCancelSubConfirm && agent && (() => {
                const cancelReasons = [
                    "Too expensive",
                    "Not using enough",
                    "Missing features",
                    "Other reason",
                ];
                // Client-side mirror of the backend eligibility check, purely so
                // the copy matches what will actually happen. Eligible → refunded
                // and shut down immediately. Not eligible → no refund, but the
                // plan runs to the end of the period the customer already paid
                // for, and only then are minutes zeroed and the number released.
                const totalMinsC = Number(agent?.subscription?.plan_mins) || 0;
                const minsLeftC = agent?.mins_left || 0;
                const usedPctC = totalMinsC > 0 ? ((totalMinsC - minsLeftC) / totalMinsC) * 100 : 100;
                const periodStartC = agent?.subscription?.current_period_start;
                const ageDaysC = periodStartC ? dayjs().diff(dayjs(periodStartC), "day") : Infinity;
                const isRefundEligibleC = usedPctC < 10 && ageDaysC <= 7;
                const periodEndC = agent?.subscription?.current_period_end;
                const accessUntilC = periodEndC ? dayjs(periodEndC).format("D MMM YYYY") : null;
                /*
                 * "Yes, Cancel" stays disabled until the user has actually
                 * answered: a reason must be picked, and picking "Other reason"
                 * additionally requires text in the box (trimmed — whitespace is
                 * not an answer). Cancelling is destructive and irreversible
                 * (agent deactivated, number released), so the confirm button
                 * must not be reachable on an empty form.
                 */
                const cancelOtherFilled = cancelOtherText.trim().length > 0;
                const canConfirmCancel =
                    !!cancelReason &&
                    (cancelReason !== "Other reason" || cancelOtherFilled);
                return (
                    <NewModal
                        isOpen={showCancelSubConfirm}
                        onClose={() => !cancelSubLoading && setShowCancelSubConfirm(false)}
                        title={null}
                        height="auto"
                        bodyMaxHeight="70vh"
                    >
                        <div className={styles.deactivateModal}>
                            <div className={styles.cancelIconWrap}>
                                <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="27.5" cy="27.5" r="27.5" fill="#FBE6EB" />
                                    <path d="M18.3321 38.6696C18.3321 39.8093 18.7848 40.9022 19.5907 41.708C20.3965 42.5139 21.4894 42.9666 22.6291 42.9666H33.3715C34.5111 42.9666 35.6041 42.5139 36.4099 41.708C37.2158 40.9022 37.6685 39.8093 37.6685 38.6696V21.4817H39.817C40.1019 21.4817 40.3751 21.3686 40.5766 21.1671C40.778 20.9657 40.8912 20.6924 40.8912 20.4075C40.8912 20.1226 40.778 19.8494 40.5766 19.6479C40.3751 19.4464 40.1019 19.3333 39.817 19.3333H34.3491C34.0874 17.8394 33.3073 16.4857 32.1461 15.5103C30.9849 14.5348 29.5169 14 28.0003 14C26.4837 14 25.0157 14.5348 23.8545 15.5103C22.6933 16.4857 21.9132 17.8394 21.6515 19.3333H16.1836C15.8987 19.3333 15.6255 19.4464 15.424 19.6479C15.2226 19.8494 15.1094 20.1226 15.1094 20.4075C15.1094 20.6924 15.2226 20.9657 15.424 21.1671C15.6255 21.3686 15.8987 21.4817 16.1836 21.4817H18.3321V38.6696ZM28.0003 16.1105C28.9524 16.1112 29.8772 16.4281 30.6297 17.0114C31.3822 17.5947 31.9196 18.4114 32.1576 19.3333H23.843C24.081 18.4114 24.6184 17.5947 25.3709 17.0114C26.1233 16.4281 27.0482 16.1112 28.0003 16.1105ZM22.6291 21.4817H35.52V38.6696C35.52 39.2394 35.2936 39.7859 34.8907 40.1888C34.4878 40.5918 33.9413 40.8181 33.3715 40.8181H22.6291C22.0593 40.8181 21.5128 40.5918 21.1099 40.1888C20.7069 39.7859 20.4806 39.2394 20.4806 38.6696V21.4817H22.6291ZM23.7033 36.5211V25.7787C23.7033 25.4938 23.8165 25.2206 24.018 25.0191C24.2194 24.8177 24.4927 24.7045 24.7776 24.7045C25.0625 24.7045 25.3357 24.8177 25.5372 25.0191C25.7386 25.2206 25.8518 25.4938 25.8518 25.7787V36.5211C25.8518 36.806 25.7386 37.0793 25.5372 37.2807C25.3357 37.4822 25.0625 37.5954 24.7776 37.5954C24.4927 37.5954 24.2194 37.4822 24.018 37.2807C23.8165 37.0793 23.7033 36.806 23.7033 36.5211ZM30.1488 36.5211V25.7787C30.1488 25.4938 30.2619 25.2206 30.4634 25.0191C30.6649 24.8177 30.9381 24.7045 31.223 24.7045C31.5079 24.7045 31.7812 24.8177 31.9826 25.0191C32.1841 25.2206 32.2973 25.4938 32.2973 25.7787V36.5211C32.2973 36.806 32.1841 37.0793 31.9826 37.2807C31.7812 37.4822 31.5079 37.5954 31.223 37.5954C30.9381 37.5954 30.6649 37.4822 30.4634 37.2807C30.2619 37.0793 30.1488 36.806 30.1488 36.5211Z" fill="#E4133C" />
                                </svg>

                            </div>

                            <h2 className={styles.deactivateTitle}>Cancel Subscription?</h2>

                            <p className={styles.deactivateDesc}>
                                {isRefundEligibleC
                                    ? "You're within the refund window, so your payment will be returned and your agent will be deactivated and its number released right away."
                                    : accessUntilC
                                        ? `No refund is available per our policy, so your plan stays active until ${accessUntilC}. It won't renew, and your agent will be deactivated and its number released on that date.`
                                        : (
                                            <>
                                                If your cancellation is eligible for a refund under our <strong>Refund Policy</strong>, the eligible refund amount will be returned to your original payment method within <strong>5–7 business days</strong>.
                                                <br />
                                                If your subscription is <strong>not eligible for a refund</strong>, it will remain active until the end of your current billing period and will be canceled on that date. You will not be charged for the next billing cycle.
                                            </>
                                        )
                                }{" "}

                                <br /> <a
                                    href="https://www.rxpt.ai/terms-condition"
                                    target="_blank"
                                    rel="noreferrer"
                                    className={styles.cancelRefundLink}
                                >
                                    View Refund Policy.
                                </a>
                            </p>

                            <p className={styles.cancelConfirmText}>
                                Are you sure you want to continue?
                            </p>

                            <div className={styles.reasonHead}>
                                <p className={styles.reasonTitle}>Why are you canceling?</p>
                                <p className={styles.reasonSub}>your feedback helps us improve</p>
                            </div>

                            <div className={styles.reasonList}>
                                {cancelReasons.map((reason) => (
                                    <label key={reason} className={styles.reasonRow}>
                                        <span className={styles.reasonLabel}>{reason}</span>
                                        <input
                                            type="radio"
                                            name="cancelReason"
                                            className={styles.reasonRadio}
                                            checked={cancelReason === reason}
                                            onChange={() => setCancelReason(reason)}
                                        />
                                    </label>
                                ))}
                            </div>

                            {cancelReason === "Other reason" && (
                                <div className={styles.reasonOtherWrap}>
                                    <textarea
                                        className={styles.reasonTextarea}
                                        placeholder="Tell us other reason..."
                                        maxLength={120}
                                        value={cancelOtherText}
                                        onChange={(e) => setCancelOtherText(e.target.value)}
                                    />
                                    <span className={styles.reasonCounter}>
                                        {cancelOtherText.length}/120
                                    </span>
                                </div>
                            )}

                            <AnimatedButton
                                label="Yes, Cancel"
                                isLoading={cancelSubLoading}
                                disabled={cancelSubLoading || !canConfirmCancel}
                                onClick={handleCancelSubscriptionConfirmed}
                                positionType="relative"
                                width="100%"
                                bottom="0"
                            />
                        </div>
                    </NewModal>
                );
            })()}

            {showReactivateConfirm && reactivation && (() => {
                const isResume = reactivation.mode === "resume";
                const chargeDate = reactivation.nextChargeDate
                    ? dayjs(reactivation.nextChargeDate).format("D MMM YYYY")
                    : null;
                const card = reactivation.card;
                const cardText = card?.last4 ? `your ${card.brand || "card"} ending ${card.last4}` : "your saved card";
                const planLabel = reactivation.isPayg
                    ? reactivation.hasMonthlyNumberFee ? "Pay-As-You-Go + $5 number plan" : "Pay-As-You-Go plan"
                    : `${reactivation.planName || "previous"} plan`;
                return (
                    <NewModal
                        isOpen={showReactivateConfirm}
                        onClose={() => !reactivateLoading && setShowReactivateConfirm(false)}
                        title={null}
                        height="auto"
                    >
                        <div className={styles.deactivateModal}>
                            <h2 className={styles.deactivateTitle}>Reactivate Subscription?</h2>
                            <p className={styles.deactivateDesc}>
                                {isResume
                                    ? reactivation.needsCard
                                        ? `Your ${planLabel} will continue. Please add a card first — it will be charged${chargeDate ? ` on ${chargeDate}` : " on the renewal date"}.`
                                        : `Your ${planLabel} will continue with the same number. Nothing is charged now; ${cardText} will be charged${chargeDate ? ` on ${chargeDate}` : " on the renewal date"}.`
                                    : `Your ${planLabel} will start again. You'll pay now on the next screen, then choose a new number for your agent.`}
                            </p>
                            <AnimatedButton
                                label={
                                    isResume && reactivation.needsCard
                                        ? "Add Card"
                                        : isResume ? "Yes, Reactivate" : "Continue to Payment"
                                }
                                isLoading={reactivateLoading}
                                disabled={reactivateLoading}
                                onClick={
                                    isResume && reactivation.needsCard
                                        ? () => navigate("/edit-profile")
                                        : handleReactivateConfirmed
                                }
                                positionType="relative"
                                width="100%"
                                bottom="0"
                            />
                        </div>
                    </NewModal>
                );
            })()}
        </div>
    );
};

export default FastAgentDetails;